import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Requirement from './Requirement';
import InterviewSchedule from './InterviewSchedule';
import InterviewsList from './InterviewsList';
import QuestionsManager from './QuestionsManager';
import AssessmentAnswers from './AssessmentAnswers';
import FeedBack from './FeedBack';
import './HiringDashboard.css';
import { toast } from "react-toastify";
import AdminVerificationDashboard from './AdminVerificationDashboard';
import AIInterviewDashboard from './AIInterviewDashboard';

import { FaBriefcase, FaHandsHelping, FaHandSparkles, FaUser, FaUserCircle } from "react-icons/fa";





import { useTrialCheck } from '../hooks/useTrialCheck';

import API_BASE_URL from '../config';

const HiringDashboard = () => {
  const [user, setUser] = useState(null);
  const [requirements, setRequirements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showRequirementModal, setShowRequirementModal] = useState(false);
  const [editingRequirement, setEditingRequirement] = useState(null);
  const [selectedRequirement, setSelectedRequirement] = useState(null);
  const [applications, setApplications] = useState([]);
  const [showApplications, setShowApplications] = useState(false);
  const [activeTab, setActiveTab] = useState('jobs');
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortBy, setSortBy] = useState('newest');
  const [currentPage, setCurrentPage] = useState(1);
  const [applicationsPerPage, setApplicationsPerPage] = useState(10);
  const [dropdownOpen, setDropdownOpen] = useState(null);

  const [jobSearchFilter, setJobSearchFilter] = useState('');
  const [departmentFilter, setDepartmentFilter] = useState('all');

  const [error, setError] = useState('');

  const [showTrialLimitModal, setShowTrialLimitModal] = useState(false);
  const [trialLimitMessage, setTrialLimitMessage] = useState('');

  const [offerLetters, setOfferLetters] = useState([]);
  const [loadingOfferLetters, setLoadingOfferLetters] = useState(false);
  const [offerLetterSearchTerm, setOfferLetterSearchTerm] = useState('');
  const [offerLetterStatusFilter, setOfferLetterStatusFilter] = useState('all');
  const [offerLetterSortBy, setOfferLetterSortBy] = useState('newest');
  const [offerLetterCurrentPage, setOfferLetterCurrentPage] = useState(1);
  const [offerLettersPerPage, setOfferLettersPerPage] = useState(10);

  // Add these state variables

  const [expandedJob, setExpandedJob] = useState(null);
  const [jobApplications, setJobApplications] = useState({});
  const [loadingApplications, setLoadingApplications] = useState({});

  const [showAllCandidates, setShowAllCandidates] = useState(false);
  const [allCandidates, setAllCandidates] = useState([]);
  const [candidatesLoading, setCandidatesLoading] = useState(false);
  const [candidateSearchTerm, setCandidateSearchTerm] = useState('');
  const [candidateStatusFilter, setCandidateStatusFilter] = useState('all');
  const [candidatePositionFilter, setCandidatePositionFilter] = useState('all');
  const [candidateDepartmentFilter, setCandidateDepartmentFilter] = useState('all');
  const [candidateExperienceFilter, setCandidateExperienceFilter] = useState('all');
  const [candidateSortBy, setCandidateSortBy] = useState('newest');
  const [candidateCurrentPage, setCandidateCurrentPage] = useState(1);
  const [candidatesPerPage, setCandidatesPerPage] = useState(10);
  const [showCandidateFilters, setShowCandidateFilters] = useState(false);



  // Enhanced Job Filtering States
  const [jobSearchTerm, setJobSearchTerm] = useState('');
  const [jobStatusFilter, setJobStatusFilter] = useState('all');
  const [jobDepartmentFilter, setJobDepartmentFilter] = useState('all');
  const [jobSortBy, setJobSortBy] = useState('newest');
  const [jobCurrentPage, setJobCurrentPage] = useState(1);
  const [jobsPerPage, setJobsPerPage] = useState(9);
  const [showJobFilters, setShowJobFilters] = useState(false);

  // Interview scheduling states
  const [showInterviewModal, setShowInterviewModal] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [skillsModalOpen, setSkillsModalOpen] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedCandidateName, setSelectedCandidateName] = useState('');

  const getSubscriptionClass = (subscription) => {
    if (!subscription) return 'no-plan';
    if (subscription.activePlanType === 'paid' || subscription.plan === 'paid') return 'premium';
    if (subscription.activePlanType === 'trial' || subscription.isTrialActive) return 'trial';
    return 'basic';
  };


  const getTodayInterviewsCount = () => {
    // Implement logic to count today's interviews
    return 0;
  };

  const getPendingReviewsCount = () => {
    // Implement logic to count pending reviews
    return allCandidates.filter(c => c.status === 'Under Review').length;
  };

  const getUpcomingDeadlinesCount = () => {
    // Implement logic to count upcoming deadlines
    const today = new Date();
    return requirements.filter(req => {
      const deadline = new Date(req.deadline);
      const diffDays = Math.ceil((deadline - today) / (1000 * 60 * 60 * 24));
      return diffDays >= 0 && diffDays <= 7;
    }).length;
  };

  const calculateJobGrowth = () => {
    // Implement logic to calculate job growth percentage
    return 12; // Example percentage
  };

  const calculateAverageTimeToFill = () => {
    // Implement logic to calculate average time to fill positions
    return '24 days'; // Example value
  };

  const calculateCandidateGrowth = () => {
    // Implement logic to calculate candidate growth percentage
    return 18; // Example percentage
  };

  const getNewCandidatesCount = () => {
    // Get candidates who applied in the last 7 days
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
    return allCandidates.filter(c => {
      const appliedDate = new Date(c.applicationDate || c.createdAt);
      return appliedDate >= sevenDaysAgo;
    }).length;
  };

  const getScreeningCandidatesCount = () => {
    return allCandidates.filter(c => c.status === 'Under Review').length;
  };

  const getInterviewCandidatesCount = () => {
    return allCandidates.filter(c => c.status === 'Shortlisted').length;
  };

  const getRecentActivities = () => {
    const activities = [];

    // Add recent job creations
    requirements.slice(0, 2).forEach(req => {
      activities.push({
        type: 'application',
        message: `New job posted: ${req.position}`,
        time: 'Just now',
        status: 'new'
      });
    });

    // Add recent applications
    if (allCandidates.length > 0) {
      const recentCandidate = allCandidates[0];
      activities.push({
        type: 'application',
        message: `${recentCandidate.name} applied for ${recentCandidate.requirementId?.position || 'a position'}`,
        time: '2 hours ago',
        status: 'new'
      });
    }

    // Add offer letters sent
    if (offerLetters.length > 0) {
      const recentOffer = offerLetters[0];
      activities.push({
        type: 'status',
        message: `Offer sent to ${recentOffer.candidateName}`,
        time: '1 day ago',
        status: 'completed'
      });
    }

    return activities;
  };

  const getUpcomingInterviews = () => {
    // Implement logic to get upcoming interviews
    return []; // Return array of interview objects
  };

  const formatTime = (time) => {
    if (!time) return 'N/A';
    return time;
  };

  const handleJoinInterview = (interview) => {
    // Implement join interview logic
    console.log('Joining interview:', interview);
  };

  const [stats, setStats] = useState({
    totalJobs: 0,
    activeJobs: 0,
    totalCandidates: 0,
    matches: 0
  });
  const navigate = useNavigate();

  useTrialCheck();


  const clearOfferLetterFilters = () => {
    setOfferLetterSearchTerm('');
    setOfferLetterStatusFilter('all');
    setOfferLetterSortBy('newest');
    setOfferLetterCurrentPage(1);
  };

  const getDaysUntilDate = (dateString) => {
    if (!dateString) return '';
    const targetDate = new Date(dateString);
    const today = new Date();
    const diffTime = targetDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return 'Past';
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Tomorrow';
    return `${diffDays} days`;
  };

  // Filter and sort offer letters
  const filteredOfferLetters = useMemo(() => {
    return offerLetters
      .filter(offer => {
        const matchesSearch = !offerLetterSearchTerm ||
          offer.candidateName?.toLowerCase().includes(offerLetterSearchTerm.toLowerCase()) ||
          offer.candidateEmail?.toLowerCase().includes(offerLetterSearchTerm.toLowerCase()) ||
          offer.position?.toLowerCase().includes(offerLetterSearchTerm.toLowerCase()) ||
          offer.department?.toLowerCase().includes(offerLetterSearchTerm.toLowerCase());

        const matchesStatus = offerLetterStatusFilter === 'all' ||
          offer.status === offerLetterStatusFilter;

        return matchesSearch && matchesStatus;
      })
      .sort((a, b) => {
        switch (offerLetterSortBy) {
          case 'newest':
            return new Date(b.sentDate || b.createdAt) - new Date(a.sentDate || a.createdAt);
          case 'oldest':
            return new Date(a.sentDate || a.createdAt) - new Date(b.sentDate || b.createdAt);
          case 'candidate_name':
            return (a.candidateName || '').localeCompare(b.candidateName || '');
          case 'position':
            return (a.position || '').localeCompare(b.position || '');
          case 'salary_high':
            return (b.salary || 0) - (a.salary || 0);
          case 'salary_low':
            return (a.salary || 0) - (b.salary || 0);
          default:
            return 0;
        }
      });
  }, [offerLetters, offerLetterSearchTerm, offerLetterStatusFilter, offerLetterSortBy]);






  const currentOfferLetters = useMemo(() => {
    const startIndex = (offerLetterCurrentPage - 1) * offerLettersPerPage;
    const endIndex = startIndex + offerLettersPerPage;
    return filteredOfferLetters.slice(startIndex, endIndex);
  }, [filteredOfferLetters, offerLetterCurrentPage, offerLettersPerPage]);

  const startOnboarding = (offer) => {
    console.log('Starting onboarding for:', offer.candidateName);
    // Implement onboarding flow
  };

  const trackOfferStatus = (offer) => {
    console.log('Tracking offer status:', offer);
    // Implement tracking modal
  };
  // Export all offer letters to Excel - CORRECTED VERSION
  const exportAllOfferLettersToExcel = () => {
    if (offerLetters.length === 0) {
      showNotification('No offer letters to export', 'error');
      return;
    }

    try {
      // Create CSV headers
      const headers = [
        'Candidate Name',
        'Candidate Email',
        'Candidate Phone',
        'Position',
        'Department',
        'Salary',
        'Salary Period',
        'Joining Date',
        'Work Location',
        'Reporting Manager',
        'Probation Period',
        'Notice Period',
        'Working Hours',
        'Offer Reference',
        'Status',
        'Sent Date',
        'Accepted Date',
        'HR Manager',
        'Company Name',
        'Company Email',
        'Company Phone',
        'Company Address'
      ];

      // Create CSV content
      const csvContent = [
        headers.join(','),
        ...offerLetters.map(offer => {
          // Helper function to escape CSV values
          const escapeCSV = (value) => {
            if (value === null || value === undefined || value === '') return '""';
            const stringValue = String(value);
            // Escape quotes and wrap in quotes if contains comma, newline, or quote
            if (stringValue.includes('"') || stringValue.includes(',') || stringValue.includes('\n')) {
              return `"${stringValue.replace(/"/g, '""')}"`;
            }
            return `"${stringValue}"`;
          };

          // Format dates
          const joiningDate = offer.joiningDate
            ? new Date(offer.joiningDate).toLocaleDateString('en-IN')
            : '';

          const sentDate = offer.sentDate
            ? new Date(offer.sentDate).toLocaleDateString('en-IN')
            : '';

          const acceptedDate = offer.acceptedDate
            ? new Date(offer.acceptedDate).toLocaleDateString('en-IN')
            : '';

          // Get status text
          const statusText = offer.status === 'sent_to_candidate' ? 'Sent to Candidate' :
            offer.status === 'accepted' ? 'Accepted' :
              offer.status === 'rejected' ? 'Rejected' :
                offer.status === 'expired' ? 'Expired' : 'Draft';

          return [
            escapeCSV(offer.candidateName),
            escapeCSV(offer.candidateEmail),
            escapeCSV(offer.candidatePhone || ''),
            escapeCSV(offer.position),
            escapeCSV(offer.department),
            escapeCSV(offer.salary),
            escapeCSV(offer.salaryPeriod || 'Month'),
            escapeCSV(joiningDate),
            escapeCSV(offer.workLocation || ''),
            escapeCSV(offer.reportingManager || ''),
            escapeCSV(offer.probationPeriod || ''),
            escapeCSV(offer.noticePeriod || ''),
            escapeCSV(offer.workingHours || ''),
            escapeCSV(offer.refNumber || ''),
            escapeCSV(statusText),
            escapeCSV(sentDate),
            escapeCSV(acceptedDate),
            escapeCSV(offer.companyDetails?.hrManagerName || ''),
            escapeCSV(offer.companyDetails?.companyName || ''),
            escapeCSV(offer.companyDetails?.companyEmail || ''),
            escapeCSV(offer.companyDetails?.companyPhone || ''),
            escapeCSV(offer.companyDetails?.companyAddress || '')
          ].join(',');
        })
      ].join('\n');

      // Create BOM for UTF-8 to handle special characters
      const BOM = '\uFEFF';
      const csvWithBOM = BOM + csvContent;

      // Create and download file
      const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      // Generate filename with date
      const dateStr = new Date().toISOString().split('T')[0];

      link.setAttribute('href', url);
      link.setAttribute('download', `offer-letters-${dateStr}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up URL object
      setTimeout(() => URL.revokeObjectURL(url), 100);

      // Show success message
      showNotification(`Exported ${offerLetters.length} offer letters to Excel`, 'success');
      console.log(`Exported ${offerLetters.length} offer letters successfully`);

    } catch (error) {
      console.error('Error exporting offer letters to Excel:', error);
      showNotification('Error exporting offer letters. Please try again.', 'error');
    }
  };

  // Export filtered offer letters to Excel
  const exportFilteredOfferLettersToExcel = () => {
    const filteredOffers = filteredOfferLetters;

    if (filteredOffers.length === 0) {
      showNotification('No offer letters match your current filters', 'error');
      return;
    }

    try {
      // Create CSV headers
      const headers = [
        'Candidate Name',
        'Candidate Email',
        'Candidate Phone',
        'Position',
        'Department',
        'Salary',
        'Salary Period',
        'Joining Date',
        'Work Location',
        'Reporting Manager',
        'Probation Period',
        'Notice Period',
        'Working Hours',
        'Offer Reference',
        'Status',
        'Sent Date',
        'Accepted Date',
        'HR Manager',
        'Company Name',
        'Company Email',
        'Company Phone',
        'Company Address'
      ];

      // Create CSV content
      const csvContent = [
        headers.join(','),
        ...filteredOffers.map(offer => {
          // Helper function to escape CSV values
          const escapeCSV = (value) => {
            if (value === null || value === undefined || value === '') return '""';
            const stringValue = String(value);
            // Escape quotes and wrap in quotes if contains comma, newline, or quote
            if (stringValue.includes('"') || stringValue.includes(',') || stringValue.includes('\n')) {
              return `"${stringValue.replace(/"/g, '""')}"`;
            }
            return `"${stringValue}"`;
          };

          // Format dates
          const joiningDate = offer.joiningDate
            ? new Date(offer.joiningDate).toLocaleDateString('en-IN')
            : '';

          const sentDate = offer.sentDate
            ? new Date(offer.sentDate).toLocaleDateString('en-IN')
            : '';

          const acceptedDate = offer.acceptedDate
            ? new Date(offer.acceptedDate).toLocaleDateString('en-IN')
            : '';

          // Get status text
          const statusText = offer.status === 'sent_to_candidate' ? 'Sent to Candidate' :
            offer.status === 'accepted' ? 'Accepted' :
              offer.status === 'rejected' ? 'Rejected' :
                offer.status === 'expired' ? 'Expired' : 'Draft';

          return [
            escapeCSV(offer.candidateName),
            escapeCSV(offer.candidateEmail),
            escapeCSV(offer.candidatePhone || ''),
            escapeCSV(offer.position),
            escapeCSV(offer.department),
            escapeCSV(offer.salary),
            escapeCSV(offer.salaryPeriod || 'Month'),
            escapeCSV(joiningDate),
            escapeCSV(offer.workLocation || ''),
            escapeCSV(offer.reportingManager || ''),
            escapeCSV(offer.probationPeriod || ''),
            escapeCSV(offer.noticePeriod || ''),
            escapeCSV(offer.workingHours || ''),
            escapeCSV(offer.refNumber || ''),
            escapeCSV(statusText),
            escapeCSV(sentDate),
            escapeCSV(acceptedDate),
            escapeCSV(offer.companyDetails?.hrManagerName || ''),
            escapeCSV(offer.companyDetails?.companyName || ''),
            escapeCSV(offer.companyDetails?.companyEmail || ''),
            escapeCSV(offer.companyDetails?.companyPhone || ''),
            escapeCSV(offer.companyDetails?.companyAddress || '')
          ].join(',');
        })
      ].join('\n');

      // Create BOM for UTF-8 to handle special characters
      const BOM = '\uFEFF';
      const csvWithBOM = BOM + csvContent;

      // Create and download file
      const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      // Generate filename with date
      const dateStr = new Date().toISOString().split('T')[0];

      link.setAttribute('href', url);
      link.setAttribute('download', `filtered-offer-letters-${dateStr}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up URL object
      setTimeout(() => URL.revokeObjectURL(url), 100);

      // Show success message
      showNotification(`Exported ${filteredOffers.length} filtered offer letters to Excel`, 'success');
      console.log(`Exported ${filteredOffers.length} filtered offer letters successfully`);

    } catch (error) {
      console.error('Error exporting filtered offer letters to Excel:', error);
      showNotification('Error exporting offer letters. Please try again.', 'error');
    }
  };

  const viewCandidateProfile = (candidate) => {
    // You can implement a modal or redirect to detailed view
    console.log('Viewing profile for:', candidate.name);
    // Example: setSelectedCandidate(candidate) and open a modal
  };

  // Add this function inside your HiringDashboard component, before the return statement

  // Add these helper functions to your component

  // Function to calculate days until deadline
  const getDaysUntilDeadline = (deadline) => {
    if (!deadline) return 'No deadline';
    const deadlineDate = new Date(deadline);
    const today = new Date();
    const diffTime = deadlineDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return 'Expired';
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Tomorrow';
    if (diffDays <= 7) return `${diffDays} days`;
    if (diffDays <= 30) return `${Math.ceil(diffDays / 7)} weeks`;
    return `${Math.ceil(diffDays / 30)} months`;
  };


  // Helper function for skill descriptions
  const getSkillDescription = (skill) => {
    const descriptions = {
      'JavaScript': 'Programming language for web development',
      'React': 'JavaScript library for building user interfaces',
      'Node.js': 'JavaScript runtime for server-side development',
      'Python': 'High-level programming language for various applications',
      'Java': 'Object-oriented programming language',
      'HTML': 'Markup language for creating web pages',
      'CSS': 'Style sheet language for web design',
      'SQL': 'Language for managing and querying databases',
      'MongoDB': 'NoSQL database program',
      'Git': 'Version control system',
      'AWS': 'Cloud computing services',
      'Docker': 'Containerization platform',
      'Communication': 'Ability to convey information effectively',
      'Teamwork': 'Collaborating effectively with others',
      'Problem Solving': 'Finding solutions to difficult or complex issues'
    };

    return descriptions[skill] || 'A valuable skill for this position';
  };

  // Function to export skills to PDF
  const exportSkillsToPDF = (skills) => {
    const skillsText = skills.join(', ');
    alert(`Skills exported to PDF:\n\n${skillsText}`);
    // In a real app, you would use a PDF library like jsPDF
  };

  // Function to copy skills to clipboard
  const copySkillsToClipboard = (skills) => {
    const skillsText = skills.join(', ');
    navigator.clipboard.writeText(skillsText)
      .then(() => {
        alert('Skills copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy skills:', err);
      });
  };

  // Function to handle skill action
  const handleSkillAction = (skill) => {
    // You can implement specific actions for each skill
    console.log(`Clicked on skill: ${skill}`);
    // Example: Open a modal with skill details
  };

  // Function to check if deadline is expired

  // HiringDashboard.js - Update the trial check to subscription check
  // HiringDashboard.js - Replace the subscription check useEffect
  // Enhanced subscription status check
  // Enhanced subscription status check - FIXED VERSION
  useEffect(() => {
    const checkSubscriptionStatus = async () => {
      const token = sessionStorage.getItem('authToken');
      const userDataStr = sessionStorage.getItem('userData');

      console.log('🔍 Dashboard - Checking subscription status:', {
        hasToken: !!token,
        hasUserData: !!userDataStr
      });

      if (!token || !userDataStr) {
        console.log('❌ No token or user data, redirecting to login');
        navigate('/access-recruit');
        return;
      }

      try {
        const userData = JSON.parse(userDataStr);
        console.log('📊 User data from session:', userData);

        // Enhanced subscription check with proper date validation
        const currentDate = new Date();
        let activePlanType = 'none';
        let currentPeriodEnd = null;
        let hasActiveAccess = false;

        // Check subscription data from session
        const subscription = userData.subscription;

        if (subscription) {
          console.log('📦 Subscription data from session:', subscription);

          // Check paid subscription first
          if (subscription.paymentStatus === 'active' && subscription.plan === 'paid') {
            if (subscription.subscriptionEndDate) {
              const subscriptionEnd = new Date(subscription.subscriptionEndDate);
              if (currentDate < subscriptionEnd) {
                hasActiveAccess = true;
                activePlanType = 'paid';
                currentPeriodEnd = subscription.subscriptionEndDate;
                console.log('💰 Active paid subscription found');
              } else {
                console.log('❌ Paid subscription expired');
              }
            } else {
              // If no end date but payment is active, consider it active
              hasActiveAccess = true;
              activePlanType = 'paid';
              console.log('💰 Active paid subscription (no end date)');
            }
          }

          // Check trial subscription if no paid access
          if (!hasActiveAccess && subscription.isTrialActive && subscription.trialEndDate) {
            const trialEnd = new Date(subscription.trialEndDate);
            if (currentDate < trialEnd) {
              hasActiveAccess = true;
              activePlanType = 'trial';
              currentPeriodEnd = subscription.trialEndDate;
              console.log('🆓 Active trial subscription found');
            } else {
              console.log('❌ Trial subscription expired');
            }
          }

          console.log('🔍 Session access check result:', {
            hasActiveAccess,
            activePlanType,
            currentPeriodEnd
          });

          if (hasActiveAccess) {
            console.log('✅ Active access confirmed from session data');

            // Update user state with subscription info for display
            setUser(prev => ({
              ...prev,
              subscription: {
                ...subscription,
                activePlanType,
                currentPeriodEnd,
                hasActiveAccess
              }
            }));

            return; // User has access, no need to check API
          }
        }

        // If session data doesn't confirm access, check with API
        console.log('🔄 Checking subscription status from API...');
        const response = await axios.get(`${API_BASE_URL}/api/hiring/subscription-status`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          timeout: 10000
        });

        console.log('📦 API Response:', response.data);

        if (response.data.success) {
          const subscriptionData = response.data.data;

          // Enhanced API access check with proper validation
          let apiHasActiveAccess = false;
          let apiActivePlanType = 'none';
          let apiCurrentPeriodEnd = null;

          // Check paid subscription from API
          if (subscriptionData.paymentStatus === 'active' && subscriptionData.plan === 'paid') {
            if (subscriptionData.subscriptionEndDate) {
              const subscriptionEnd = new Date(subscriptionData.subscriptionEndDate);
              if (currentDate < subscriptionEnd) {
                apiHasActiveAccess = true;
                apiActivePlanType = 'paid';
                apiCurrentPeriodEnd = subscriptionData.subscriptionEndDate;
              }
            } else {
              apiHasActiveAccess = true;
              apiActivePlanType = 'paid';
            }
          }

          // Check trial subscription from API
          if (!apiHasActiveAccess && subscriptionData.isTrialActive && subscriptionData.trialEndDate) {
            const trialEnd = new Date(subscriptionData.trialEndDate);
            if (currentDate < trialEnd) {
              apiHasActiveAccess = true;
              apiActivePlanType = 'trial';
              apiCurrentPeriodEnd = subscriptionData.trialEndDate;
            }
          }

          console.log('🔍 API Access check result:', {
            apiHasActiveAccess,
            apiActivePlanType,
            apiCurrentPeriodEnd
          });

          if (!apiHasActiveAccess) {
            console.log('❌ No active access from API, logging out');
            sessionStorage.clear();
            navigate('/access-recruit');
            return;
          }

          // Update session data with enhanced subscription info
          const updatedUserData = {
            ...userData,
            subscription: {
              ...subscriptionData,
              hasActiveAccess: apiHasActiveAccess,
              activePlanType: apiActivePlanType,
              currentPeriodEnd: apiCurrentPeriodEnd
            }
          };
          sessionStorage.setItem('userData', JSON.stringify(updatedUserData));

          // Update user state for display
          setUser(prev => ({
            ...prev,
            subscription: updatedUserData.subscription
          }));

          console.log('✅ Session data updated with enhanced subscription info');

        } else {
          throw new Error('API returned success: false');
        }

      } catch (error) {
        console.error('❌ Error checking subscription status:', error);

        // If API call fails, check if we have valid session data
        const userData = JSON.parse(userDataStr || '{}');
        const subscription = userData.subscription;

        if (subscription) {
          const currentDate = new Date();
          let hasValidAccess = false;
          let validPlanType = 'none';

          // Check paid subscription
          if (subscription.paymentStatus === 'active' && subscription.plan === 'paid') {
            if (subscription.subscriptionEndDate) {
              hasValidAccess = currentDate < new Date(subscription.subscriptionEndDate);
            } else {
              hasValidAccess = true;
            }
            validPlanType = 'paid';
          }

          // Check trial subscription
          if (!hasValidAccess && subscription.isTrialActive && subscription.trialEndDate) {
            hasValidAccess = currentDate < new Date(subscription.trialEndDate);
            validPlanType = 'trial';
          }

          if (hasValidAccess) {
            console.log('⚠️ API failed but session data shows valid access, allowing access');

            // Update user state for display
            setUser(prev => ({
              ...prev,
              subscription: {
                ...subscription,
                activePlanType: validPlanType,
                hasActiveAccess: true
              }
            }));

            return;
          }
        }

        // If no valid session data and API failed, log out
        console.log('❌ No valid access, logging out');
        sessionStorage.clear();
        navigate('/access-recruit');
      }
    };

    checkSubscriptionStatus();

    // Set up periodic check (every 30 minutes)
    const interval = setInterval(checkSubscriptionStatus, 30 * 60 * 1000);

    return () => clearInterval(interval);
  }, [navigate]);



  // Add this to your HiringDashboard component
  useEffect(() => {
    const checkTrialStatus = async () => {
      const token = sessionStorage.getItem('authToken');
      const userData = sessionStorage.getItem('userData');

      if (!token || !userData) {
        navigate('/access-recruit');
        return;
      }

      try {
        const user = JSON.parse(userData);
        const trialEndDate = new Date(user.subscription.trialEndDate);
        const isTrialActive = new Date() < trialEndDate;

        // If trial ended and not paid, auto logout
        if (!isTrialActive && user.subscription.paymentStatus !== 'active') {
          sessionStorage.clear();
          navigate('/access-recruit');
          return;
        }

        // Check subscription status from backend
        const response = await axios.get(`${API_BASE_URL}/api/hiring/subscription`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const subscription = response.data.data;
        if (!subscription.isTrialActive && subscription.paymentStatus !== 'active') {
          sessionStorage.clear();
          navigate('/access-recruit');
        }
      } catch (error) {
        console.error('Error checking trial status:', error);
        // If there's an error, log out for security
        sessionStorage.clear();
        navigate('/access-recruit');
      }
    };

    checkTrialStatus();

    // Check every hour
    const interval = setInterval(checkTrialStatus, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, [navigate]);



  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return 'No deadline';
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  // Check if deadline is expired - MOVED BEFORE useMemo
  const isDeadlineExpired = (deadline) => {
    if (!deadline) return false;
    return new Date(deadline) < new Date();
  };

  // Add this function to check job creation limits
  // Enhanced job creation limit check
  // Enhanced job creation limit check with better trial detection
  const checkJobCreationLimit = () => {
    if (!user?.subscription) {
      return {
        allowed: false,
        reason: 'Please login and activate your subscription to create job posts.',
        limit: 0,
        current: requirements.length,
        isTrial: false
      };
    }

    const subscription = user.subscription;
    const currentJobsCount = requirements.length;

    // Check if user is on active trial (but not paid)
    const isActiveTrial = (subscription.activePlanType === 'trial' || subscription.isTrialActive) && subscription.plan !== 'paid';
    const isTrialEnded = subscription.trialEndDate && new Date() > new Date(subscription.trialEndDate);

    // If user has active paid subscription, no limits
    if (subscription.activePlanType === 'paid' || subscription.plan === 'paid') {
      return {
        allowed: true,
        reason: 'Premium user - Unlimited job posts',
        limit: 'unlimited',
        current: currentJobsCount,
        isTrial: false
      };
    }

    // If user is on ACTIVE TRIAL (trial period is still ongoing)
    if (isActiveTrial && !isTrialEnded) {
      const trialLimit = 1; // Only 1 job allowed in trial
      if (currentJobsCount >= trialLimit) {
        return {
          allowed: false,
          reason: `Free trial users can create only ${trialLimit} job post. Upgrade to premium to create unlimited jobs.`,
          limit: trialLimit,
          current: currentJobsCount,
          isTrial: true,
          trialEnded: false
        };
      }
      return {
        allowed: true,
        reason: `Trial active. You can create ${trialLimit - currentJobsCount} more job(s).`,
        limit: trialLimit,
        current: currentJobsCount,
        isTrial: true,
        trialEnded: false
      };
    }

    // If trial has ENDED
    if (isTrialEnded && subscription.plan !== 'paid') {
      return {
        allowed: false,
        reason: 'Your free trial has ended. Please upgrade to premium to create job posts.',
        limit: 0,
        current: currentJobsCount,
        isTrial: true,
        trialEnded: true
      };
    }

    // Basic/free plan users
    return {
      allowed: currentJobsCount < 1,
      reason: currentJobsCount >= 1 ? 'Free users can create only 1 job post. Upgrade to premium for unlimited.' : 'You can create this job post',
      limit: 1,
      current: currentJobsCount,
      isTrial: false
    };
  };

  // Replace the existing handleOnboarding function with this fixed version
  const handleOnboarding = (offerLetter) => {
    try {
      // Store offer letter data for onboarding
      const onboardingData = {
        offerLetterId: offerLetter._id,
        candidateName: offerLetter.candidateName,
        candidateEmail: offerLetter.candidateEmail,
        candidatePhone: offerLetter.candidatePhone,
        position: offerLetter.position,
        department: offerLetter.department,
        joiningDate: offerLetter.joiningDate,
        salary: offerLetter.salary,
        workLocation: offerLetter.workLocation,
        companyName: offerLetter.companyDetails?.companyName,
        companyEmail: offerLetter.companyDetails?.companyEmail,
        hrManagerName: offerLetter.companyDetails?.hrManagerName
      };

      console.log('🚀 Starting onboarding process for:', offerLetter.candidateName);
      console.log('📋 Onboarding data:', onboardingData);

      // Store in sessionStorage for the onboarding process
      sessionStorage.setItem('onboardingData', JSON.stringify(onboardingData));
      sessionStorage.setItem('onboardingCandidate', offerLetter.candidateName);
      sessionStorage.setItem('onboardingPosition', offerLetter.position);

      // Method 1: Try to open the header's auth modal first
      try {
        const authModalEvent = new CustomEvent('openAuthModal', {
          detail: {
            isLoginForm: false, // Show signup form for onboarding
            onboardingData: onboardingData,
            autoOpen: true
          }
        });
        window.dispatchEvent(authModalEvent);
        console.log('✅ Auth modal event dispatched');
      } catch (eventError) {
        console.log('❌ Auth modal event failed, trying direct navigation');
      }

      // Method 2: Direct navigation to onboarding page
      try {
        // Check if we're already on a page that can handle onboarding
        const currentPath = window.location.pathname;
        if (currentPath.includes('/hiring') || currentPath.includes('/dashboard')) {
          // We're in the hiring dashboard, try to open a modal or new tab
          window.open(`/onboarding?offerId=${offerLetter._id}`, '_blank');
        } else {
          // Navigate to onboarding page
          navigate('/onboarding', {
            state: {
              onboardingData: onboardingData,
              fromOfferLetter: true
            }
          });
        }
      } catch (navError) {
        console.log('❌ Navigation failed, trying alternative method');

        // Method 3: Create a temporary form and submit it
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/onboarding';
        form.target = '_blank';

        Object.keys(onboardingData).forEach(key => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = onboardingData[key];
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }

      // Show success notification
      showNotification(`Starting onboarding process for ${offerLetter.candidateName}`, 'success');

      // Close any open modals
      setShowInterviewModal(false);

    } catch (error) {
      console.error('❌ Error starting onboarding process:', error);
      showNotification('Failed to start onboarding process. Please try again.', 'error');
    }
  };

  // Alternative simplified version if the above doesn't work:
  // Fixed onboarding function that will open the auth modal
  // Fixed onboarding function in HiringDashboard.js
  const handleOnboardingSimple = (offerLetter) => {
    try {
      // Store data in sessionStorage
      const onboardingData = {
        offerLetterId: offerLetter._id,
        candidateName: offerLetter.candidateName,
        candidateEmail: offerLetter.candidateEmail,
        position: offerLetter.position,
        department: offerLetter.department,
        joiningDate: offerLetter.joiningDate,
        companyName: offerLetter.companyDetails?.companyName,
        fromOnboarding: true
      };

      sessionStorage.setItem('onboardingData', JSON.stringify(onboardingData));

      console.log('🚀 Dispatching onboarding event to HomePage');

      // Create and dispatch the event
      const onboardingEvent = new CustomEvent('startOnboarding', {
        detail: {
          candidateData: onboardingData,
          offerData: offerLetter,
          timestamp: new Date().toISOString()
        }
      });

      // Dispatch the event
      window.dispatchEvent(onboardingEvent);

      // Navigate to home page first
      navigate('/');

      // Show immediate feedback
      showNotification(`Opening onboarding form for ${offerLetter.candidateName}...`, 'info');

    } catch (error) {
      console.error('❌ Error starting onboarding process:', error);
      showNotification('Failed to start onboarding process. Please try again.', 'error');
    }
  };

  // Skills Modal Component
  const SkillsModal = ({ isOpen, onClose, skills, candidateName }) => {
    if (!isOpen) return null;

    return (
      <div className="rd-modal-overlay" onClick={onClose}>
        <div className="rd-modal-content rd-skills-modal" onClick={(e) => e.stopPropagation()}>
          <div className="rd-modal-header">
            <h3 className="rd-modal-title">
              Skills - {candidateName}
              <span className="rd-skills-count">({skills.length} skills)</span>
            </h3>
            <button className="rd-close-button" onClick={onClose}>x</button>
          </div>

          <div className="rd-modal-body">
            <div className="rd-skills-grid">
              {skills.map((skill, index) => (
                <div key={index} className="rd-skill-item">
                  <span className="rd-skill-text">{skill}</span>
                  <span className="rd-skill-number">{index + 1}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="rd-modal-footer">
            <button className="rd-close-modal-btn" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };


  // Offer Letter Actions
  const viewOfferLetter = (offerLetterId) => {
    // Open offer letter in new tab or modal
    const frontendUrl = process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000';
    const candidateLink = `${frontendUrl}/candidate/offer/${offerLetterId}`;
    window.open(candidateLink, '_blank');
  };

  const downloadOfferLetter = async (offerLetterIdOrObject) => {
    try {
      let offerLetterId;

      if (typeof offerLetterIdOrObject === 'object') {
        offerLetterId = offerLetterIdOrObject._id;
      } else {
        offerLetterId = offerLetterIdOrObject;
      }

      const token = sessionStorage.getItem('authToken');
      const response = await axios.get(
        `${API_BASE_URL}/api/offer-letters/download/${offerLetterId}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          responseType: 'blob'  // Important!
        }
      );

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `signed-offer-letter.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      showNotification('Signed offer letter downloaded!', 'success');
    } catch (error) {
      console.error('Error:', error);
      showNotification('Download failed', 'error');
    }
  };

  const resendOfferLetter = async (offerLetterId) => {
    try {
      const token = sessionStorage.getItem('authToken');
      const response = await axios.post(
        `${API_BASE_URL}/api/offer-letters/${offerLetterId}/resend`,
        {},
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (response.data.success) {
        showNotification('Offer letter resent successfully!', 'success');
        loadOfferLetters(); // Refresh the list
      }
    } catch (error) {
      console.error('Error resending offer letter:', error);
      showNotification('Failed to resend offer letter', 'error');
    }
  };

  const trackOfferLetter = (offerLetterId) => {
    // Show tracking modal or details
    const offer = offerLetters.find(ol => ol._id === offerLetterId);
    if (offer) {
      alert(`Tracking offer letter for ${offer.candidateName}\nStatus: ${offer.status}\nSent: ${offer.sentDate ? new Date(offer.sentDate).toLocaleString() : 'Not sent'}\nAccepted: ${offer.acceptedDate ? new Date(offer.acceptedDate).toLocaleString() : 'Not accepted'}`);
    }
  };


  // Load all offer letters
  const loadOfferLetters = async () => {
    try {
      setLoadingOfferLetters(true);
      const token = sessionStorage.getItem('authToken');
      const currentUser = getCurrentUser();

      if (!currentUser) {
        setError('Unable to identify current user. Please login again.');
        setLoadingOfferLetters(false);
        return;
      }

      console.log('📄 Loading offer letters for user:', currentUser.email);

      // Try multiple endpoints for user-specific offer letters
      const endpoints = [
        `${API_BASE_URL}/api/offer-letters/my-offers`,
        `${API_BASE_URL}/api/offer-letters/company`
      ];

      let offerLettersData = [];
      let successfulEndpoint = '';

      for (const endpoint of endpoints) {
        try {
          console.log(`🔄 Trying endpoint: ${endpoint}`);
          const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          if (response.ok) {
            const result = await response.json();
            if (result.success) {
              offerLettersData = result.data || [];
              successfulEndpoint = endpoint;
              console.log(`✅ Success with endpoint: ${endpoint}, found: ${offerLettersData.length} offers`);
              break;
            }
          }
        } catch (error) {
          console.log(`❌ Endpoint failed: ${endpoint}`, error);
          continue;
        }
      }

      if (offerLettersData.length === 0) {
        console.log('❌ No offer letters found from any endpoint');
        setOfferLetters([]);
        showNotification('No offer letters found for your account', 'info');
        return;
      }

      // Double filter by current user for safety
      const userOfferLetters = offerLettersData.filter(offer => {
        const matchesUser =
          offer.userEmail === currentUser.email ||
          offer.userId === currentUser.userId ||
          offer.companyDetails?.companyEmail === currentUser.email ||
          offer.sentBy === currentUser.userId;

        return matchesUser;
      });

      console.log(`✅ Final filtered offer letters: ${userOfferLetters.length} for user: ${currentUser.email}`);
      setOfferLetters(userOfferLetters);

      if (userOfferLetters.length === 0) {
        showNotification('No offer letters found for your account', 'info');
      }

    } catch (error) {
      console.error('💥 Error loading offer letters:', error);
      showNotification('Failed to load offer letters. Please try again.', 'error');
    } finally {
      setLoadingOfferLetters(false);
    }
  };

  // Enhanced getCurrentUser function
  const getCurrentUser = () => {
    try {
      // Get user data from sessionStorage
      const userData = sessionStorage.getItem('userData');
      const userEmail = sessionStorage.getItem('userEmail');
      const userName = sessionStorage.getItem('userName');
      const userId = sessionStorage.getItem('userId');

      if (userData) {
        const parsedUser = JSON.parse(userData);
        return {
          email: parsedUser.email || userEmail,
          name: parsedUser.name || userName,
          company: parsedUser.company || 'Your Company',
          userId: parsedUser.userId || parsedUser._id || userId
        };
      }

      // Fallback to individual sessionStorage items
      if (userEmail) {
        return {
          email: userEmail,
          name: userName || 'HR Manager',
          company: sessionStorage.getItem('userCompany') || 'Your Company',
          userId: userId
        };
      }

      // Final fallback - try to get from token
      const token = sessionStorage.getItem('authToken') || sessionStorage.getItem('token');
      if (token) {
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          return {
            email: payload.email,
            name: payload.name || 'HR Manager',
            company: payload.company || 'Your Company',
            userId: payload.userId || payload._id
          };
        } catch (tokenError) {
          console.error('Error decoding token:', tokenError);
        }
      }

      console.warn('No user data found in sessionStorage');
      return null;
    } catch (error) {
      console.error('Error getting current user:', error);
      return null;
    }
  };


  // Load all candidates from all requirements
  // Load all candidates from all requirements
  // Load all candidates from all requirements - UPDATE THIS FUNCTION
  const loadAllCandidates = async () => {
    try {
      setCandidatesLoading(true);
      const token = sessionStorage.getItem('authToken');

      console.log('🔍 Loading all candidates...');

      const requirementsResponse = await axios.get(
        `${API_BASE_URL}/api/requirements`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (requirementsResponse.data.success) {
        const allRequirements = requirementsResponse.data.data || [];
        console.log('📋 Found requirements:', allRequirements.length);

        let allCandidatesData = [];

        for (const requirement of allRequirements) {
          try {
            const appsResponse = await axios.get(
              `${API_BASE_URL}/api/applications/requirement/${requirement._id}`,
              {
                headers: { 'Authorization': `Bearer ${token}` }
              }
            );

            if (appsResponse.data.success && appsResponse.data.data) {
              const applicationsWithRequirement = appsResponse.data.data.map(app => ({
                ...app,
                requirementId: {
                  _id: requirement._id,
                  position: requirement.position,
                  department: requirement.department
                },
                hasResume: !!app.resumeUrl || !!app.resume || !!app.resumeData || !!app.resumePath
              }));

              allCandidatesData = [...allCandidatesData, ...applicationsWithRequirement];
            }
          } catch (error) {
            console.error(`❌ Error loading applications for requirement ${requirement._id}:`, error);
            continue;
          }
        }

        console.log('👥 Total candidates loaded:', allCandidatesData.length);
        setAllCandidates(allCandidatesData);

        // Update stats after loading candidates
        updateStats(allRequirements);

        if (allCandidatesData.length === 0) {
          showNotification('No candidates found in the system', 'info');
        }

      } else {
        console.error('❌ Failed to load requirements');
        showNotification('Failed to load requirements', 'error');
      }

    } catch (error) {
      console.error('💥 Error loading all candidates:', error);

      if (error.response?.status === 404) {
        showNotification('API endpoint not found. Please check backend routes.', 'error');
      } else if (error.response?.status === 401) {
        showNotification('Authentication failed. Please login again.', 'error');
        navigate('/access-recruit');
      } else {
        showNotification('Failed to load candidates. Please try again.', 'error');
      }
    } finally {
      setCandidatesLoading(false);
    }
  };



  // Export Offer Letters to Excel - ADD THESE FUNCTIONS AFTER THE loadOfferLetters FUNCTION

  // Export all offer letters to Excel
  // Export all offer letters to Excel - ADD THESE FUNCTIONS AFTER THE loadOfferLetters FUNCTION

  // Export all offer letters to Excel
  const exportOfferLettersToExcel = () => {
    if (offerLetters.length === 0) {
      showNotification('No offer letters to export', 'error');
      return;
    }

    try {
      // Create CSV headers
      const headers = [
        'Candidate Name',
        'Candidate Email',
        'Candidate Phone',
        'Position',
        'Department',
        'Salary',
        'Salary Period',
        'Joining Date',
        'Work Location',
        'Reporting Manager',
        'Probation Period',
        'Notice Period',
        'Working Hours',
        'Offer Reference',
        'Status',
        'Sent Date',
        'Accepted Date',
        'HR Manager',
        'Company Name',
        'Company Email',
        'Company Phone',
        'Company Address'
      ];

      // Create CSV content
      const csvContent = [
        headers.join(','),
        ...offerLetters.map(offer => {
          // Helper function to escape CSV values
          const escapeCSV = (value) => {
            if (value === null || value === undefined || value === '') return '""';
            const stringValue = String(value);
            // Escape quotes and wrap in quotes if contains comma, newline, or quote
            if (stringValue.includes('"') || stringValue.includes(',') || stringValue.includes('\n')) {
              return `"${stringValue.replace(/"/g, '""')}"`;
            }
            return `"${stringValue}"`;
          };

          // Format dates
          const joiningDate = offer.joiningDate
            ? new Date(offer.joiningDate).toLocaleDateString('en-IN')
            : '';

          const sentDate = offer.sentDate
            ? new Date(offer.sentDate).toLocaleDateString('en-IN')
            : '';

          const acceptedDate = offer.acceptedDate
            ? new Date(offer.acceptedDate).toLocaleDateString('en-IN')
            : '';

          // Get status text
          const statusText = offer.status === 'sent_to_candidate' ? 'Sent to Candidate' :
            offer.status === 'accepted' ? 'Accepted' :
              offer.status === 'rejected' ? 'Rejected' :
                offer.status === 'expired' ? 'Expired' : 'Draft';

          return [
            escapeCSV(offer.candidateName),
            escapeCSV(offer.candidateEmail),
            escapeCSV(offer.candidatePhone || ''),
            escapeCSV(offer.position),
            escapeCSV(offer.department),
            escapeCSV(offer.salary),
            escapeCSV(offer.salaryPeriod || 'Month'),
            escapeCSV(joiningDate),
            escapeCSV(offer.workLocation || ''),
            escapeCSV(offer.reportingManager || ''),
            escapeCSV(offer.probationPeriod || ''),
            escapeCSV(offer.noticePeriod || ''),
            escapeCSV(offer.workingHours || ''),
            escapeCSV(offer.refNumber || ''),
            escapeCSV(statusText),
            escapeCSV(sentDate),
            escapeCSV(acceptedDate),
            escapeCSV(offer.companyDetails?.hrManagerName || ''),
            escapeCSV(offer.companyDetails?.companyName || ''),
            escapeCSV(offer.companyDetails?.companyEmail || ''),
            escapeCSV(offer.companyDetails?.companyPhone || ''),
            escapeCSV(offer.companyDetails?.companyAddress || '')
          ].join(',');
        })
      ].join('\n');

      // Create BOM for UTF-8 to handle special characters
      const BOM = '\uFEFF';
      const csvWithBOM = BOM + csvContent;

      // Create and download file
      const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      // Generate filename with date
      const dateStr = new Date().toISOString().split('T')[0];

      link.setAttribute('href', url);
      link.setAttribute('download', `offer-letters-${dateStr}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up URL object
      setTimeout(() => URL.revokeObjectURL(url), 100);

      // Show success message
      showNotification(`Exported ${offerLetters.length} offer letters to Excel`, 'success');
      console.log(`Exported ${offerLetters.length} offer letters successfully`);

    } catch (error) {
      console.error('Error exporting offer letters to Excel:', error);
      showNotification('Error exporting offer letters. Please try again.', 'error');
    }
  };

  // Export filtered offer letters
  const exportFilteredOfferLetters = () => {
    const filteredOffers = offerLetters.filter(offer => {
      // Apply the same filters as in the table
      const matchesSearch = offerLetterSearchTerm === '' ||
        offer.candidateName?.toLowerCase().includes(offerLetterSearchTerm.toLowerCase()) ||
        offer.candidateEmail?.toLowerCase().includes(offerLetterSearchTerm.toLowerCase()) ||
        offer.position?.toLowerCase().includes(offerLetterSearchTerm.toLowerCase());

      const matchesStatus = offerLetterStatusFilter === 'all' ||
        offer.status === offerLetterStatusFilter;

      return matchesSearch && matchesStatus;
    });

    if (filteredOffers.length === 0) {
      showNotification('No offer letters match your current filters', 'error');
      return;
    }

    // Use the same export function but with filtered data
    const originalOffers = [...offerLetters];

    // Temporarily set offers to filtered ones for export
    const tempOffers = offerLetters;
    setOfferLetters(filteredOffers);

    setTimeout(() => {
      exportOfferLettersToExcel();
      // Restore original offers
      setOfferLetters(tempOffers);
    }, 100);
  };
  // Advanced Export with more details
  const exportOfferLettersDetailed = () => {
    if (offerLetters.length === 0) {
      showNotification('No offer letters to export', 'error');
      return;
    }

    try {
      // Enhanced headers with more details
      const headers = [
        'Offer Reference',
        'Candidate Name',
        'Candidate Email',
        'Candidate Phone',
        'Candidate Address',
        'Position',
        'Department',
        'Salary',
        'Salary Period',
        'Joining Date',
        'Work Location',
        'Reporting Manager',
        'Probation Period',
        'Notice Period',
        'Working Hours',
        'Saturday Hours',
        'Sick Leave',
        'Earned Leave',
        'Offer Status',
        'Sent Date',
        'Sent By',
        'Accepted Date',
        'HR Manager',
        'HR Designation',
        'Company Name',
        'Company Email',
        'Company Phone',
        'Company Address',
        'CIN Number',
        'Terms & Conditions'
      ];

      // Create CSV content
      const csvContent = [
        headers.join(','),
        ...offerLetters.map(offer => {
          const escapeCSV = (value) => {
            if (value === null || value === undefined || value === '') return '""';
            const stringValue = String(value);
            if (stringValue.includes('"') || stringValue.includes(',') || stringValue.includes('\n')) {
              return `"${stringValue.replace(/"/g, '""')}"`;
            }
            return `"${stringValue}"`;
          };

          // Format dates
          const formatDate = (date) => date ? new Date(date).toLocaleDateString('en-IN') : '';

          // Get status text
          const statusText = offer.status === 'sent_to_candidate' ? 'Sent to Candidate' :
            offer.status === 'accepted' ? 'Accepted' :
              offer.status === 'rejected' ? 'Rejected' :
                offer.status === 'expired' ? 'Expired' : 'Draft';

          return [
            escapeCSV(offer.refNumber || ''),
            escapeCSV(offer.candidateName),
            escapeCSV(offer.candidateEmail),
            escapeCSV(offer.candidatePhone || ''),
            escapeCSV(offer.candidateAddress || ''),
            escapeCSV(offer.position),
            escapeCSV(offer.department),
            escapeCSV(offer.salary),
            escapeCSV(offer.salaryPeriod || 'Month'),
            escapeCSV(formatDate(offer.joiningDate)),
            escapeCSV(offer.workLocation || ''),
            escapeCSV(offer.reportingManager || ''),
            escapeCSV(offer.probationPeriod || ''),
            escapeCSV(offer.noticePeriod || ''),
            escapeCSV(offer.workingHours || ''),
            escapeCSV(offer.saturdayHours || ''),
            escapeCSV(offer.sickLeave || ''),
            escapeCSV(offer.earnedLeave || ''),
            escapeCSV(statusText),
            escapeCSV(formatDate(offer.sentDate)),
            escapeCSV(offer.sentBy || ''),
            escapeCSV(formatDate(offer.acceptedDate)),
            escapeCSV(offer.companyDetails?.hrManagerName || ''),
            escapeCSV(offer.companyDetails?.designation || ''),
            escapeCSV(offer.companyDetails?.companyName || ''),
            escapeCSV(offer.companyDetails?.companyEmail || ''),
            escapeCSV(offer.companyDetails?.companyPhone || ''),
            escapeCSV(offer.companyDetails?.companyAddress || ''),
            escapeCSV(offer.companyDetails?.cinNumber || ''),
            escapeCSV((offer.termsAndConditions || '').replace(/\n/g, '; '))
          ].join(',');
        })
      ].join('\n');

      // Create and download file
      const BOM = '\uFEFF';
      const csvWithBOM = BOM + csvContent;

      const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      const dateStr = new Date().toISOString().split('T')[0];

      link.setAttribute('href', url);
      link.setAttribute('download', `detailed-offer-letters-${dateStr}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => URL.revokeObjectURL(url), 100);

      showNotification(`Exported ${offerLetters.length} detailed offer letters to Excel`, 'success');

    } catch (error) {
      console.error('Error exporting detailed offer letters:', error);
      showNotification('Error exporting offer letters. Please try again.', 'error');
    }
  };


  // Export all candidates to Excel
  // Enhanced export all candidates to Excel
  const exportAllCandidatesToExcel = () => {
    if (allCandidates.length === 0) {
      showNotification('No candidates to export', 'error');
      return;
    }

    try {
      // Enhanced headers with all possible fields
      const headers = [
        'Application ID',
        'Candidate Name',
        'Candidate Email',
        'Candidate Phone',
        'Experience (Years)',
        'Current Company',
        'Current Designation',
        'Expected Salary',
        'Notice Period',
        'Applied Position',
        'Applied Department',
        'Candidate Location',
        'Primary Skills',
        'Secondary Skills',
        'Education',
        'Gender',
        'Date of Birth',
        'Marital Status',
        'Address',
        'City',
        'State',
        'Pincode',
        'Application Status',
        'Applied Date',
        'Last Status Update',
        'Resume Available',
        'Application Source',
        'Rejection Reason',
        'Interview Date',
        'Interview Status',
        'Interview Feedback',
        'Offer Status',
        'Offer Amount',
        'Expected Joining Date',
        'Actual Joining Date',
        'HR Remarks',
        'Application Rating',
        'Skill Match %'
      ];

      // Create CSV content
      const csvContent = [
        headers.join(','),
        ...allCandidates.map(candidate => {
          // Helper function to escape CSV values
          const escapeCSV = (value) => {
            if (value === null || value === undefined || value === '') return '""';
            const stringValue = String(value);
            // Escape quotes and wrap in quotes if contains comma, newline, or quote
            if (stringValue.includes('"') || stringValue.includes(',') || stringValue.includes('\n')) {
              return `"${stringValue.replace(/"/g, '""')}"`;
            }
            return `"${stringValue}"`;
          };

          // Format education details
          const educationDetails = Array.isArray(candidate.educationalDetails)
            ? candidate.educationalDetails.map(edu => {
              const qualification = escapeCSV(edu.qualification || '');
              const institution = escapeCSV(edu.institution || '');
              const year = escapeCSV(edu.year || '');
              const percentage = edu.percentage ? escapeCSV(`${edu.percentage}%`) : '';
              return `${qualification}${institution ? ` - ${institution}` : ''}${year ? ` (${year})` : ''}${percentage ? ` - ${percentage}` : ''}`;
            }).join('; ')
            : '';

          // Split skills into primary (first 3) and secondary (rest)
          const skills = candidate.skills || [];
          const primarySkills = skills.slice(0, 3).join('; ');
          const secondarySkills = skills.slice(3).join('; ');

          // Format dates
          const formatDate = (dateString) => {
            if (!dateString) return '';
            try {
              return new Date(dateString).toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
              });
            } catch (e) {
              return '';
            }
          };

          const appliedDate = formatDate(candidate.applicationDate || candidate.createdAt);
          const lastUpdateDate = formatDate(candidate.updatedAt);
          const dobDate = formatDate(candidate.dateOfBirth);
          const interviewDate = formatDate(candidate.interview?.date);
          const expectedJoiningDate = formatDate(candidate.expectedJoiningDate);
          const actualJoiningDate = formatDate(candidate.actualJoiningDate);

          // Calculate skill match percentage (example logic)
          const calculateSkillMatch = () => {
            const requirement = candidate.requirementId;
            if (!requirement || !requirement.requiredSkills || !candidate.skills) return '';

            const requiredSkills = Array.isArray(requirement.requiredSkills) ? requirement.requiredSkills : [];
            const candidateSkills = Array.isArray(candidate.skills) ? candidate.skills : [];

            if (requiredSkills.length === 0) return '';

            const matchedSkills = candidateSkills.filter(skill =>
              requiredSkills.some(reqSkill =>
                reqSkill.toLowerCase().includes(skill.toLowerCase()) ||
                skill.toLowerCase().includes(reqSkill.toLowerCase())
              )
            );

            const matchPercentage = Math.round((matchedSkills.length / requiredSkills.length) * 100);
            return `${matchPercentage}%`;
          };

          return [
            escapeCSV(candidate._id || 'N/A'),
            escapeCSV(candidate.name || ''),
            escapeCSV(candidate.email || ''),
            escapeCSV(candidate.phone || ''),
            escapeCSV(candidate.totalExperience || candidate.experience || ''),
            escapeCSV(candidate.currentCompany || ''),
            escapeCSV(candidate.currentDesignation || ''),
            escapeCSV(candidate.expectedSalary || ''),
            escapeCSV(candidate.noticePeriod || ''),
            escapeCSV(candidate.requirementId?.position || candidate.position || ''),
            escapeCSV(candidate.requirementId?.department || candidate.department || ''),
            escapeCSV(candidate.location || ''),
            escapeCSV(primarySkills),
            escapeCSV(secondarySkills),
            escapeCSV(educationDetails),
            escapeCSV(candidate.gender || ''),
            escapeCSV(dobDate),
            escapeCSV(candidate.maritalStatus || ''),
            escapeCSV(candidate.address || ''),
            escapeCSV(candidate.city || ''),
            escapeCSV(candidate.state || ''),
            escapeCSV(candidate.pincode || ''),
            escapeCSV(candidate.status || 'Applied'),
            escapeCSV(appliedDate),
            escapeCSV(lastUpdateDate),
            escapeCSV(candidate.resumeUrl || candidate.resume || candidate.resumeData ? 'Yes' : 'No'),
            escapeCSV(candidate.applicationSource || 'Website'),
            escapeCSV(candidate.rejectionReason || ''),
            escapeCSV(interviewDate),
            escapeCSV(candidate.interview?.status || ''),
            escapeCSV(candidate.interviewFeedback || ''),
            escapeCSV(candidate.offerStatus || ''),
            escapeCSV(candidate.offerAmount || ''),
            escapeCSV(expectedJoiningDate),
            escapeCSV(actualJoiningDate),
            escapeCSV(candidate.hrRemarks || ''),
            escapeCSV(candidate.applicationRating || ''),
            escapeCSV(calculateSkillMatch())
          ].join(',');
        })
      ].join('\n');

      // Create BOM for UTF-8 to handle special characters
      const BOM = '\uFEFF';
      const csvWithBOM = BOM + csvContent;

      // Create and download file
      const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      // Generate filename with date
      const dateStr = new Date().toISOString().split('T')[0];
      const companyName = user?.company?.replace(/[^a-zA-Z0-9]/g, '-') || 'company';

      link.setAttribute('href', url);
      link.setAttribute('download', `candidates-export-${companyName}-${dateStr}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up URL object
      setTimeout(() => URL.revokeObjectURL(url), 100);

      // Show success message
      showNotification(`Successfully exported ${allCandidates.length} candidates to Excel`, 'success');
      console.log(`Exported ${allCandidates.length} candidates with enhanced details`);

    } catch (error) {
      console.error('Error exporting candidates to Excel:', error);
      showNotification('Error exporting candidates. Please try again.', 'error');
    }
  };

  // Enhanced Job Filtering Functions
  // Replace the existing filteredJobs function with this one for job requirements tab
  const filteredJobs = useMemo(() => {
    let filtered = requirements.filter(job => {
      // Search filter - use jobSearchTerm instead of jobSearchFilter
      const matchesSearch = jobSearchTerm === '' ||
        job.position.toLowerCase().includes(jobSearchTerm.toLowerCase()) ||
        job.department.toLowerCase().includes(jobSearchTerm.toLowerCase()) ||
        (job.requiredSkills && job.requiredSkills.some(skill =>
          skill.toLowerCase().includes(jobSearchTerm.toLowerCase())
        ));

      // Department filter - use jobDepartmentFilter instead of departmentFilter
      const matchesDepartment = jobDepartmentFilter === 'all' || job.department === jobDepartmentFilter;

      // Status filter - use jobStatusFilter instead of statusFilter
      let matchesStatus = true;
      if (jobStatusFilter === 'active') {
        matchesStatus = job.status === 'Active' && !isDeadlineExpired(job.deadline);
      } else if (jobStatusFilter === 'expired') {
        matchesStatus = isDeadlineExpired(job.deadline);
      } else if (jobStatusFilter === 'draft') {
        matchesStatus = job.status === 'Draft';
      }

      return matchesSearch && matchesDepartment && matchesStatus;
    });

    // Sort logic - use jobSortBy instead of sortBy
    filtered.sort((a, b) => {
      switch (jobSortBy) {
        case 'newest':
          return new Date(b.createdAt) - new Date(a.createdAt);
        case 'oldest':
          return new Date(a.createdAt) - new Date(b.createdAt);
        case 'position':
          return a.position.localeCompare(b.position);
        case 'department':
          return a.department.localeCompare(b.department);
        case 'applicants':
          const aApps = jobApplications[a._id]?.length || 0;
          const bApps = jobApplications[b._id]?.length || 0;
          return bApps - aApps;
        case 'deadline':
          return new Date(a.deadline) - new Date(b.deadline);
        default:
          return new Date(b.createdAt) - new Date(a.createdAt);
      }
    });

    return filtered;
  }, [requirements, jobSearchTerm, jobDepartmentFilter, jobStatusFilter, jobSortBy, jobApplications]);


  // Add this separate filteredJobs function for the "jobs" tab
  const filteredJobsForJobsTab = useMemo(() => {
    let filtered = requirements.filter(job => {
      // Search filter
      const matchesSearch = jobSearchFilter === '' ||
        job.position.toLowerCase().includes(jobSearchFilter.toLowerCase()) ||
        job.department.toLowerCase().includes(jobSearchFilter.toLowerCase());

      // Department filter
      const matchesDepartment = departmentFilter === 'all' || job.department === departmentFilter;

      // Status filter
      let matchesStatus = true;
      if (statusFilter === 'active') {
        matchesStatus = job.status === 'Active' && !isDeadlineExpired(job.deadline);
      } else if (statusFilter === 'expired') {
        matchesStatus = isDeadlineExpired(job.deadline);
      } else if (statusFilter === 'draft') {
        matchesStatus = job.status === 'Draft';
      }

      return matchesSearch && matchesDepartment && matchesStatus;
    });

    // Sort logic
    filtered.sort((a, b) => {
      switch (sortBy) {
        case 'newest':
          return new Date(b.createdAt) - new Date(a.createdAt);
        case 'oldest':
          return new Date(a.createdAt) - new Date(b.createdAt);
        case 'position':
          return a.position.localeCompare(b.position);
        case 'applicants':
          const aApps = jobApplications[a._id]?.length || 0;
          const bApps = jobApplications[b._id]?.length || 0;
          return bApps - aApps;
        case 'deadline':
          return new Date(a.deadline) - new Date(b.deadline);
        default:
          return new Date(b.createdAt) - new Date(a.createdAt);
      }
    });

    return filtered;
  }, [requirements, jobSearchFilter, departmentFilter, statusFilter, sortBy, jobApplications]);
  // Helper variables for jobs tab
  const hasActiveFiltersForJobsTab = jobSearchFilter || departmentFilter !== 'all' || statusFilter !== 'all' || sortBy !== 'newest';

  // Clear all filters function for jobs tab
  // const clearAllFilters = () => {
  //   setJobSearchFilter('');
  //   setDepartmentFilter('all');
  //   setStatusFilter('all');
  //   setSortBy('newest');
  // };

  // Pagination for jobs tab - use filteredJobsForJobsTab instead of filteredJobs
  const currentJobsForJobsTab = filteredJobsForJobsTab.slice(
    (jobCurrentPage - 1) * jobsPerPage,
    jobCurrentPage * jobsPerPage
  );


  // Add these missing variables after the state declarations

  // Get unique departments for job requirements tab
  const departments = useMemo(() => {
    const depts = [...new Set(requirements.map(job => job.department).filter(Boolean))];
    return depts.sort();
  }, [requirements]);

  // Get current jobs for job requirements tab pagination
  const currentJobs = useMemo(() => {
    const startIndex = (jobCurrentPage - 1) * jobsPerPage;
    return filteredJobs.slice(startIndex, startIndex + jobsPerPage);
  }, [filteredJobs, jobCurrentPage, jobsPerPage]);

  // Helper variables for job requirements tab
  const hasActiveFilters = jobSearchTerm || jobDepartmentFilter !== 'all' || jobStatusFilter !== 'all' || jobSortBy !== 'newest';

  // Clear all filters function for job requirements tab
  const clearAllFilters = () => {
    setJobSearchTerm('');
    setJobDepartmentFilter('all');
    setJobStatusFilter('all');
    setJobSortBy('newest');
  };

  // const hasActiveFiltersForJobsTab = jobSearchFilter || departmentFilter !== 'all' || statusFilter !== 'all' || sortBy !== 'newest';

  // Clear all filters function for jobs tab
  const clearAllFiltersForJobsTab = () => {
    setJobSearchFilter('');
    setDepartmentFilter('all');
    setStatusFilter('all');
    setSortBy('newest');
  };

  // Pagination for jobs tab
  // const currentJobsForJobsTab = filteredJobsForJobsTab.slice(
  //   (jobCurrentPage - 1) * jobsPerPage,
  //   jobCurrentPage * jobsPerPage
  // );

  // Reset to first page when filters change for jobs tab
  useEffect(() => {
    setJobCurrentPage(1);
  }, [jobSearchFilter, departmentFilter, statusFilter, sortBy]);


  // Check application data function
  const checkApplicationData = (application) => {
    console.log('🔍 Full Application Data:', application);
    console.log('📄 Resume URL:', application.resumeUrl);
    console.log('📁 Resume File:', application.resume);
    console.log('📝 Resume Path:', application.resumePath);
    console.log('📋 Resume Data:', application.resumeData);
    console.log('🆔 Application ID:', application._id);

    // Check if resume exists in any form
    const hasResume = application.resumeUrl || application.resume || application.resumePath || application.resumeData;
    console.log('✅ Has Resume:', hasResume);

    return hasResume;
  };

  // Handle resume stored as URL
  const handleResumeUrl = async (resumeUrl, applicationName) => {
    try {
      // If it's a direct file URL
      if (resumeUrl.startsWith('http')) {
        // Check if it's a Google Drive link or similar
        if (resumeUrl.includes('drive.google.com')) {
          // For Google Drive, open in new tab
          window.open(resumeUrl, '_blank');
          showNotification('Opening resume from Google Drive...', 'info');
        } else {
          // For direct file links, download directly
          const link = document.createElement('a');
          link.href = resumeUrl;
          link.target = '_blank';
          link.download = `${applicationName}_resume.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          showNotification('Resume opened in new tab!', 'success');
        }
        return;
      }

      // If it's a base64 data URL
      if (resumeUrl.startsWith('data:')) {
        const link = document.createElement('a');
        link.href = resumeUrl;
        link.download = `${applicationName}_resume.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        showNotification('Resume downloaded!', 'success');
        return;
      }

      throw new Error('Unsupported resume URL format');
    } catch (error) {
      throw new Error(`Failed to process resume URL: ${error.message}`);
    }
  };

  // Handle base64 resume data
  const handleBase64Resume = (base64Data, applicationName) => {
    try {
      // Ensure it's a proper data URL
      let dataUrl = base64Data;
      if (!base64Data.startsWith('data:')) {
        dataUrl = `data:application/pdf;base64,${base64Data}`;
      }

      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `${applicationName}_resume.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      showNotification('Resume downloaded!', 'success');
    } catch (error) {
      throw new Error(`Failed to process base64 resume: ${error.message}`);
    }
  };

  // Process blob response from API
  const processResumeBlob = async (response, applicationName) => {
    const blob = response.data;

    if (!(blob instanceof Blob)) {
      throw new Error('Server returned invalid file data');
    }

    if (blob.size === 0) {
      throw new Error('Resume file is empty');
    }

    // Determine file type and name
    const contentDisposition = response.headers['content-disposition'];
    let filename = `${applicationName.replace(/[^a-zA-Z0-9]/g, '_')}_resume.pdf`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
      if (filenameMatch) {
        filename = filenameMatch[1];
      }
    }

    // Create download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 100);

    showNotification(`Resume downloaded successfully!`, 'success');
  };

  // Handle download errors
  const handleDownloadError = (error) => {
    let errorMessage = 'Failed to download resume. ';

    if (error.response) {
      switch (error.response.status) {
        case 404:
          errorMessage = 'Resume file not found for this candidate.';
          break;
        case 401:
          errorMessage = 'Authentication failed. Please login again.';
          break;
        case 403:
          errorMessage = 'You do not have permission to download this resume.';
          break;
        case 500:
          errorMessage = 'Server error. Please try again later.';
          break;
        default:
          errorMessage = `Server error (${error.response.status}). Please try again.`;
      }
    } else if (error.code === 'NETWORK_ERROR' || !navigator.onLine) {
      errorMessage = 'Network error. Please check your internet connection.';
    } else if (error.message.includes('timeout')) {
      errorMessage = 'Request timeout. Please try again.';
    } else {
      errorMessage = error.message || 'Resume file might not be available.';
    }

    showNotification(errorMessage, 'error');
  };



  // Load applications for a specific job
  const loadJobApplications = async (jobId) => {
    try {
      setLoadingApplications(prev => ({ ...prev, [jobId]: true }));
      const token = sessionStorage.getItem('authToken');

      const response = await axios.get(
        `${API_BASE_URL}/api/applications/requirement/${jobId}`,
        {
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        const applicationsWithResume = response.data.data.map(app => ({
          ...app,
          hasResume: !!app.resumeUrl || !!app.resume || !!app.resumeData || !!app.resumePath
        }));

        setJobApplications(prev => ({
          ...prev,
          [jobId]: applicationsWithResume
        }));
      }
    } catch (error) {
      console.error(`Error loading applications for job ${jobId}:`, error);
      showNotification('Failed to load applications', 'error');
    } finally {
      setLoadingApplications(prev => ({ ...prev, [jobId]: false }));
    }
  };

  // Toggle job expansion
  const toggleJobExpansion = async (jobId) => {
    if (expandedJob === jobId) {
      setExpandedJob(null);
    } else {
      setExpandedJob(jobId);
      if (!jobApplications[jobId]) {
        await loadJobApplications(jobId);
      }
    }
  };

  // Enhanced Download Resume function with better detection
  // Enhanced Download Resume function with better error handling
  const downloadResume = async (applicationOrId, applicationName = 'candidate') => {
    try {
      const token = sessionStorage.getItem('authToken');
      if (!token) {
        showNotification('Authentication failed. Please login again.', 'error');
        return;
      }

      console.log('📥 Starting resume download...');

      // Handle both application object or ID
      let application;
      let applicationId;
      let candidateName = applicationName;

      if (typeof applicationOrId === 'object') {
        application = applicationOrId;
        applicationId = application._id;
        candidateName = application.name || applicationName;
      } else {
        applicationId = applicationOrId;
        // Try to find the application from all sources
        application = applications.find(app => app._id === applicationId) ||
          allCandidates.find(c => c._id === applicationId);
      }

      if (!application) {
        throw new Error('Application not found');
      }

      console.log('📄 Application data:', {
        id: applicationId,
        name: candidateName,
        hasResumeUrl: !!application.resumeUrl,
        hasResume: !!application.resume,
        hasResumeData: !!application.resumeData,
        hasResumePath: !!application.resumePath
      });

      // Check resume availability
      const hasResume = application.resumeUrl || application.resume || application.resumeData || application.resumePath;

      if (!hasResume) {
        throw new Error('No resume found for this candidate');
      }

      // Method 1: Direct URL download
      if (application.resumeUrl) {
        console.log('🔗 Downloading from URL:', application.resumeUrl);

        // Handle different URL types
        if (application.resumeUrl.startsWith('data:')) {
          // Base64 data URL
          const link = document.createElement('a');
          link.href = application.resumeUrl;
          link.download = `${candidateName.replace(/[^a-zA-Z0-9]/g, '_')}_resume.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          showNotification('Resume downloaded!', 'success');
          return;
        }
        else if (application.resumeUrl.startsWith('http')) {
          // Regular HTTP URL
          window.open(application.resumeUrl, '_blank');
          showNotification('Opening resume in new tab...', 'info');
          return;
        }
      }

      // Method 2: Try backend download endpoints
      const endpoints = [
        `${API_BASE_URL}/api/applications/${applicationId}/resume/download`,
        `${API_BASE_URL}/api/applications/${applicationId}/download`,
        `${API_BASE_URL}/api/applications/${applicationId}/resume`,
        `${API_BASE_URL}/api/applications/resume/${applicationId}`,
        `${API_BASE_URL}/api/candidates/${applicationId}/resume`,
      ];

      let response;
      for (const endpoint of endpoints) {
        try {
          console.log(`🔄 Trying endpoint: ${endpoint}`);
          response = await axios.get(endpoint, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Accept': 'application/pdf, application/octet-stream, */*'
            },
            responseType: 'blob',
            timeout: 15000
          });

          if (response.status === 200) {
            console.log(`✅ Success with endpoint: ${endpoint}`);
            break;
          }
        } catch (endpointError) {
          console.log(`❌ Endpoint failed: ${endpoint}`, endpointError.message);
          continue;
        }
      }

      if (!response || !response.data) {
        throw new Error('Unable to download resume from server');
      }

      // Process the blob response
      const blob = response.data;

      if (!(blob instanceof Blob)) {
        throw new Error('Invalid file data received');
      }

      if (blob.size === 0) {
        throw new Error('Resume file is empty');
      }

      // Determine filename
      let filename = `${candidateName.replace(/[^a-zA-Z0-9]/g, '_')}_resume.pdf`;

      // Try to get filename from Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          const extractedName = filenameMatch[1].replace(/['"]/g, '');
          if (extractedName) {
            filename = extractedName;
          }
        }
      }

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.style.display = 'none';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);

      showNotification(`Resume downloaded successfully!`, 'success');

    } catch (error) {
      console.error('💥 Error downloading resume:', error);

      // User-friendly error messages
      let errorMessage = 'Failed to download resume. ';

      if (error.message.includes('No resume found')) {
        errorMessage = 'No resume available for this candidate.';
      } else if (error.message.includes('Authentication')) {
        errorMessage = 'Please login again to download resume.';
      } else if (error.message.includes('Network Error')) {
        errorMessage = 'Network error. Please check your connection.';
      } else if (error.message.includes('timeout')) {
        errorMessage = 'Request timeout. Please try again.';
      } else {
        errorMessage = error.message || 'Resume might not be available.';
      }

      showNotification(errorMessage, 'error');
    }
  };

  // Simple wrapper for button click
  const handleDownloadClick = async (candidate) => {
    try {
      const token = sessionStorage.getItem('authToken');

      const response = await axios.get(
        `${API_BASE_URL}/api/applications/resume/${candidate._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          responseType: 'blob' // 🔥 MUST
        }
      );

      // 🔥 Create file from buffer
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      });

      // 🔥 Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.download = candidate.resume?.originalName || 'resume.pdf'; // filename
      document.body.appendChild(link);
      link.click();

      // cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Download failed:', error);
      alert('Resume download failed');
    }
  };




  // Helper function to get file extension
  const getFileExtension = (filename) => {
    const ext = filename.split('.').pop()?.toLowerCase();
    return ext && ['pdf', 'doc', 'docx', 'txt'].includes(ext) ? ext : 'pdf';
  };

  // Notification function
  const showNotification = (message, type = 'info') => {
    // Remove existing notification
    const existingNotification = document.querySelector('.rd-download-notification');
    if (existingNotification) {
      existingNotification.remove();
    }

    const notification = document.createElement('div');
    notification.className = `rd-download-notification rd-notification-${type}`;
    notification.innerHTML = `
      <span class="rd-notification-icon">${type === 'success' ? '✅' : '❌'}</span>
      <span class="rd-notification-text">${message}</span>
      <button class="rd-notification-close" onclick="this.parentElement.remove()">×</button>
    `;

    document.body.appendChild(notification);

    // Auto remove after 5 seconds
    setTimeout(() => {
      if (notification.parentElement) {
        notification.remove();
      }
    }, 5000);
  };



  // Export to Excel function
  const exportToExcel = (applications) => {
    try {
      // Check if applications exists and has data
      if (!applications || !Array.isArray(applications)) {
        alert('No applications data found');
        return;
      }

      if (applications.length === 0) {
        alert('No applications to export');
        return;
      }

      // Create CSV headers
      const headers = [
        'Name',
        'Email',
        'Phone',
        'Experience',
        'Skills',
        'Status',
        'Applied Date',
        'Location',
        'Education',
        'Current Company',
        'Current Designation',
        'Notice Period',
        'Expected Salary',
        'Resume Link'
      ];

      // Create CSV content with proper escaping
      const csvContent = [
        headers.join(','),
        ...applications.map(app => {
          // Helper function to escape CSV values
          const escapeCSV = (value) => {
            if (value === null || value === undefined || value === '') return '""';
            const stringValue = String(value);
            // Escape quotes and wrap in quotes if contains comma, newline, or quote
            if (stringValue.includes('"') || stringValue.includes(',') || stringValue.includes('\n')) {
              return `"${stringValue.replace(/"/g, '""')}"`;
            }
            return `"${stringValue}"`;
          };

          // Format education details
          const educationDetails = Array.isArray(app.educationalDetails)
            ? app.educationalDetails.map(edu => {
              const qualification = edu.qualification || '';
              const institution = edu.institution || '';
              const year = edu.year || '';
              return `${qualification}${institution ? ` - ${institution}` : ''}${year ? ` (${year})` : ''}`;
            }).join('; ')
            : '';

          // Format skills
          const skills = Array.isArray(app.skills)
            ? app.skills.join('; ')
            : '';

          // Format date
          const appliedDate = app.applicationDate || app.appliedAt || app.createdAt;
          const formattedDate = appliedDate
            ? new Date(appliedDate).toLocaleDateString('en-IN')
            : '';

          // Get resume link if available
          const resumeLink = app.resumeUrl || app.resume || app.resumePath || '';

          return [
            escapeCSV(app.name),
            escapeCSV(app.email),
            escapeCSV(app.phone),
            escapeCSV(app.totalExperience || app.experience),
            escapeCSV(skills),
            escapeCSV(app.status),
            escapeCSV(formattedDate),
            escapeCSV(app.location),
            escapeCSV(educationDetails),
            escapeCSV(app.currentCompany),
            escapeCSV(app.currentDesignation),
            escapeCSV(app.noticePeriod),
            escapeCSV(app.expectedSalary),
            escapeCSV(resumeLink)
          ].join(',');
        })
      ].join('\n');

      // Create BOM for UTF-8 to handle special characters
      const BOM = '\uFEFF';
      const csvWithBOM = BOM + csvContent;

      // Create and download file
      const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      // Generate filename with job position and date
      const jobPosition = applications[0]?.requirement?.position || 'applications';
      const cleanJobPosition = jobPosition.replace(/[^a-zA-Z0-9]/g, '-');
      const dateStr = new Date().toISOString().split('T')[0];

      link.setAttribute('href', url);
      link.setAttribute('download', `${cleanJobPosition}-applications-${dateStr}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up URL object
      setTimeout(() => URL.revokeObjectURL(url), 100);

      // Show success message
      console.log(`Exported ${applications.length} applications successfully`);

    } catch (error) {
      console.error('Error exporting to Excel:', error);
      alert('Error exporting applications. Please try again.');
    }
  };

  // Handle stat card click
  const handleStatCardClick = (status) => {
    setStatusFilter(status);
    setCurrentPage(1);
    showNotification(`Showing ${status === 'all' ? 'all' : status} applications`, 'info');
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.rd-name-dropdown-container')) {
        setDropdownOpen(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  useEffect(() => {
    const checkAuthAndLoadUser = () => {
      const token = sessionStorage.getItem('authToken');
      const userData = sessionStorage.getItem('userData');

      if (!token || !userData) {
        navigate('/access-recruit');
        return;
      }

      try {
        const parsedUser = JSON.parse(userData);

        // Ensure company name is properly set
        const userWithCompany = {
          ...parsedUser,
          company: parsedUser.company || parsedUser.companyName || 'Your Company',
          name: parsedUser.name || 'HR Manager'
        };

        setUser(userWithCompany);
        loadRequirements();
      } catch (error) {
        console.error('Error parsing user data:', error);
        navigate('/access-recruit');
      }
    };

    checkAuthAndLoadUser();
  }, [navigate]);

  // Load job requirements from API
  // Load job requirements from API - UPDATE THIS FUNCTION
  // Load job requirements from API - UPDATE THIS FUNCTION
  const loadRequirements = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      console.log('🔍 Loading requirements...');

      const response = await axios.get(`${API_BASE_URL}/api/requirements`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('📦 API Response:', response.data);

      if (response.data.success) {
        const requirementsData = response.data.data || [];
        console.log('✅ Requirements loaded:', requirementsData.length);

        // Fetch application counts for each requirement
        const requirementsWithCounts = await Promise.all(
          requirementsData.map(async (req) => {
            try {
              const appsResponse = await axios.get(
                `${API_BASE_URL}/api/applications/requirement/${req._id}`,
                {
                  headers: { 'Authorization': `Bearer ${token}` }
                }
              );

              return {
                ...req,
                applicantsCount: appsResponse.data.success ? appsResponse.data.data.length : 0
              };
            } catch (error) {
              console.error(`Error fetching applications for requirement ${req._id}:`, error);
              return { ...req, applicantsCount: 0 };
            }
          })
        );

        setRequirements(requirementsWithCounts);
        updateStats(requirementsWithCounts);
      } else {
        console.error('❌ API returned success: false');
      }
    } catch (error) {
      console.error('💥 Error loading requirements:', error);
    } finally {
      setLoading(false);
    }
  };


  // Filter and sort candidates
  // Filter and sort candidates - FIXED VERSION
  // Filter and sort candidates - UPDATED VERSION
  const filteredCandidates = useMemo(() => {
    let filtered = allCandidates.filter(candidate => {
      // Search term filter - FIXED with better checks
      const searchLower = candidateSearchTerm.toLowerCase();
      const matchesSearch = candidateSearchTerm === '' ||
        (candidate.name && candidate.name.toLowerCase().includes(searchLower)) ||
        (candidate.email && candidate.email.toLowerCase().includes(searchLower)) ||
        (candidate.phone && candidate.phone.toString().includes(candidateSearchTerm)) ||
        (candidate.requirementId?.position && candidate.requirementId.position.toLowerCase().includes(searchLower)) ||
        (candidate.position && candidate.position.toLowerCase().includes(searchLower)) ||
        (candidate.skills && Array.isArray(candidate.skills) &&
          candidate.skills.some(skill => skill.toLowerCase().includes(searchLower)));

      // Status filter
      const matchesStatus = candidateStatusFilter === 'all' ||
        candidate.status === candidateStatusFilter;

      // Position filter - Check both requirementId.position and candidate.position
      const matchesPosition = candidatePositionFilter === 'all' ||
        (candidate.requirementId?.position === candidatePositionFilter) ||
        (candidate.position === candidatePositionFilter);

      // Department filter - Check both requirementId.department and candidate.department
      const matchesDepartment = candidateDepartmentFilter === 'all' ||
        (candidate.requirementId?.department === candidateDepartmentFilter) ||
        (candidate.department === candidateDepartmentFilter);

      // Experience filter - IMPROVED LOGIC
      const matchesExperience = candidateExperienceFilter === 'all' ||
        (candidateExperienceFilter === 'fresher' &&
          (!candidate.totalExperience ||
            candidate.totalExperience === '0' ||
            candidate.totalExperience.toLowerCase().includes('fresher') ||
            candidate.totalExperience.toLowerCase().includes('fresher'))) ||
        (candidateExperienceFilter === '1-3' &&
          candidate.totalExperience &&
          candidate.totalExperience.includes('-') &&
          parseInt(candidate.totalExperience.split('-')[0]) >= 1 &&
          parseInt(candidate.totalExperience.split('-')[1]) <= 3) ||
        (candidateExperienceFilter === '4-6' &&
          candidate.totalExperience &&
          candidate.totalExperience.includes('-') &&
          parseInt(candidate.totalExperience.split('-')[0]) >= 4 &&
          parseInt(candidate.totalExperience.split('-')[1]) <= 6) ||
        (candidateExperienceFilter === '7+' &&
          candidate.totalExperience &&
          parseInt(candidate.totalExperience) >= 7);

      return matchesSearch && matchesStatus && matchesPosition && matchesDepartment && matchesExperience;
    });

    // Sort candidates - FIXED with better fallbacks
    filtered.sort((a, b) => {
      switch (candidateSortBy) {
        case 'newest':
          const dateA = new Date(a.applicationDate || a.createdAt || Date.now());
          const dateB = new Date(b.applicationDate || b.createdAt || Date.now());
          return dateB - dateA;
        case 'oldest':
          const dateA2 = new Date(a.applicationDate || a.createdAt || Date.now());
          const dateB2 = new Date(b.applicationDate || b.createdAt || Date.now());
          return dateA2 - dateB2;
        case 'name':
          return (a.name || '').localeCompare(b.name || '');
        case 'experience':
          const expA = parseInt(a.totalExperience || a.experience || 0);
          const expB = parseInt(b.totalExperience || b.experience || 0);
          return expB - expA;
        case 'position':
          const posA = a.requirementId?.position || a.position || '';
          const posB = b.requirementId?.position || b.position || '';
          return posA.localeCompare(posB);
        case 'status':
          return (a.status || '').localeCompare(b.status || '');
        default:
          return 0;
      }
    });

    return filtered;
  }, [allCandidates, candidateSearchTerm, candidateStatusFilter, candidatePositionFilter, candidateDepartmentFilter, candidateExperienceFilter, candidateSortBy]);


  const paginatedCandidates = useMemo(() => {
    const startIndex = (currentPage - 1) * 10;
    const endIndex = startIndex + 10;
    return filteredCandidates.slice(startIndex, endIndex);
  }, [filteredCandidates, currentPage]);

  // Get unique values for filters
  // Get unique values for filters - UPDATED
  const candidatePositions = useMemo(() => {
    const positions = new Set();

    allCandidates.forEach(candidate => {
      if (candidate.requirementId?.position) {
        positions.add(candidate.requirementId.position);
      }
      if (candidate.position) {
        positions.add(candidate.position);
      }
    });

    return Array.from(positions).filter(Boolean).sort();
  }, [allCandidates]);

  const candidateDepartments = useMemo(() => {
    const departments = new Set();

    allCandidates.forEach(candidate => {
      if (candidate.requirementId?.department) {
        departments.add(candidate.requirementId.department);
      }
      if (candidate.department) {
        departments.add(candidate.department);
      }
    });

    return Array.from(departments).filter(Boolean).sort();
  }, [allCandidates]);

  const candidateStatuses = useMemo(() => {
    const statuses = new Set();

    allCandidates.forEach(candidate => {
      if (candidate.status) {
        statuses.add(candidate.status);
      }
    });

    return Array.from(statuses).filter(Boolean).sort();
  }, [allCandidates]);

  // Filter and sort applications
  const filteredApplications = useMemo(() => {
    let filtered = applications.filter(app => {
      const matchesSearch = searchTerm === '' ||
        app.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        app.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (app.skills && app.skills.some(skill =>
          skill.toLowerCase().includes(searchTerm.toLowerCase())
        ));

      const matchesStatus = statusFilter === 'all' || app.status === statusFilter;

      return matchesSearch && matchesStatus;
    });

    // Sort applications
    filtered.sort((a, b) => {
      switch (sortBy) {
        case 'newest':
          return new Date(b.applicationDate || b.createdAt) - new Date(a.applicationDate || a.createdAt);
        case 'oldest':
          return new Date(a.applicationDate || a.createdAt) - new Date(b.applicationDate || b.createdAt);
        case 'name':
          return (a.name || '').localeCompare(b.name || '');
        case 'status':
          return (a.status || '').localeCompare(b.status || '');
        default:
          return 0;
      }
    });

    return filtered;
  }, [applications, searchTerm, statusFilter, sortBy]);


  // Get current candidates for pagination
  const currentCandidates = useMemo(() => {
    const startIndex = (candidateCurrentPage - 1) * candidatesPerPage;
    return filteredCandidates.slice(startIndex, startIndex + candidatesPerPage);
  }, [filteredCandidates, candidateCurrentPage, candidatesPerPage]);

  // Reset to first page when filters change
  useEffect(() => {
    setCandidateCurrentPage(1);
  }, [candidateSearchTerm, candidateStatusFilter, candidatePositionFilter, candidateDepartmentFilter, candidateExperienceFilter, candidateSortBy]);


  // Clear all candidate filters
  const clearCandidateFilters = () => {
    setCandidateSearchTerm('');
    setCandidateStatusFilter('all');
    setCandidatePositionFilter('all');
    setCandidateDepartmentFilter('all');
    setCandidateExperienceFilter('all');
    setCandidateSortBy('newest');
    setCandidateCurrentPage(1);
  };

  // Get current applications for pagination
  const currentApplications = useMemo(() => {
    const startIndex = (currentPage - 1) * applicationsPerPage;
    return filteredApplications.slice(startIndex, startIndex + applicationsPerPage);
  }, [filteredApplications, currentPage, applicationsPerPage]);

  // Reset to first page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, statusFilter, sortBy]);

  // Load applications for a specific requirement
  // Load applications for a specific requirement - UPDATE THIS FUNCTION
  const loadApplications = async (requirementId) => {
    try {
      const token = sessionStorage.getItem('authToken');
      const response = await axios.get(
        `${API_BASE_URL}/api/applications/requirement/${requirementId}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (response.data.success) {
        const applicationsWithResume = response.data.data.map(app => ({
          ...app,
          hasResume: !!app.resumeUrl || !!app.resume || !!app.resumeData || !!app.resumePath
        }));

        console.log('📋 Loaded applications:', applicationsWithResume);
        setApplications(applicationsWithResume);
        setShowApplications(true);

        // Update the requirement's applicants count in the requirements list
        setRequirements(prev => prev.map(req =>
          req._id === requirementId
            ? { ...req, applicantsCount: applicationsWithResume.length }
            : req
        ));

        // Reset filters when loading new applications
        setSearchTerm('');
        setStatusFilter('all');
        setSortBy('newest');
        setCurrentPage(1);
        setDropdownOpen(null);
      }
    } catch (error) {
      console.error('Error loading applications:', error);
      alert('Failed to load applications');
    }
  };

  // Update application status
  // Update application status - UPDATE THIS FUNCTION
  // Update application status - CORRECTED VERSION
  // Update application status - CORRECTED VERSION for jobs tab
  const updateApplicationStatus = async (applicationId, newStatus, candidate) => {
    try {
      const token = sessionStorage.getItem('authToken');
      const response = await axios.patch(
        `${API_BASE_URL}/api/applications/${applicationId}/status`,
        { status: newStatus },
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (response.data.success) {
        // Update applications state
        setApplications(prev => prev.map(app =>
          app._id === applicationId
            ? { ...app, status: newStatus, statusUpdatedAt: new Date() }
            : app
        ));

        // Update allCandidates state
        setAllCandidates(prev => prev.map(c =>
          c._id === applicationId
            ? { ...c, status: newStatus }
            : c
        ));

        // Update jobApplications state - THIS IS IMPORTANT FOR JOBS TAB
        setJobApplications(prev => {
          const updatedJobApps = { ...prev };

          // Find which job this application belongs to and update it
          Object.keys(updatedJobApps).forEach(jobId => {
            const jobApps = updatedJobApps[jobId];
            if (Array.isArray(jobApps)) {
              const updatedApps = jobApps.map(app =>
                app._id === applicationId
                  ? { ...app, status: newStatus }
                  : app
              );
              updatedJobApps[jobId] = updatedApps;
            }
          });

          return updatedJobApps;
        });

        // Update stats after status change
        updateStats(requirements);

        // Auto-open interview modal when status is set to Shortlisted
        if (newStatus === 'Shortlisted') {
          setSelectedApplication(candidate);
          setShowInterviewModal(true);
          showNotification(`Status updated to ${newStatus}. Schedule interview now.`, 'success');
        } else {
          showNotification(`Status updated to ${newStatus}`, 'success');
        }
      }
    } catch (error) {
      console.error('Error updating application status:', error);
      showNotification('Failed to update application status', 'error');
    }
  };

  // Schedule interview
  const scheduleInterview = async (applicationId, interviewData) => {
    try {
      const token = sessionStorage.getItem('authToken');
      const response = await axios.post(
        `${API_BASE_URL}/api/applications/${applicationId}/interview`,
        interviewData,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (response.data.success) {
        setApplications(prev => prev.map(app =>
          app._id === applicationId
            ? {
              ...app,
              status: 'Shortlisted',
              interview: response.data.data.interview
            }
            : app
        ));
        setShowInterviewModal(false);
        setSelectedApplication(null);
        toast.success('Interview scheduled and email sent to candidate');
      }
    } catch (error) {
      console.error('Error scheduling interview:', error);
      toast.error('Failed to schedule interview');
    }
  };

  // Generate application link for sharing
  const generateApplicationLink = (requirementId) => {
    const baseUrl = window.location.origin;
    return `${baseUrl}/apply/${requirementId}`;
  };

  // Copy application link to clipboard
  const copyApplicationLink = (requirementId) => {
    const link = generateApplicationLink(requirementId);
    navigator.clipboard.writeText(link)
      .then(() => {
        toast.success('Application link copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy link:', err);
        toast.error('Failed to copy link');
      });
  };

  // View applications for a requirement
  const handleViewApplications = (requirement) => {
    setSelectedRequirement(requirement);
    loadApplications(requirement._id);
  };

  // Close applications view
  const handleCloseApplications = () => {
    setShowApplications(false);
    setApplications([]);
    setSelectedRequirement(null);
    setDropdownOpen(null);
  };

  // Handle name click for dropdown
  const handleNameClick = (applicationId) => {
    setDropdownOpen(dropdownOpen === applicationId ? null : applicationId);
  };

  // Update dashboard statistics
  // Update dashboard statistics - UPDATE THIS FUNCTION
  // Update dashboard statistics - CORRECTED VERSION
  const updateStats = (reqs) => {
    const totalJobs = reqs.length;

    const activeJobs = reqs.filter(req => {
      if (req.status !== 'Active') return false;
      if (!req.deadline) return true;
      return new Date(req.deadline) > new Date();
    }).length;

    // Calculate total candidates from all applications
    const totalCandidates = allCandidates.length;

    // For matches, count shortlisted or hired candidates
    const matches = allCandidates.filter(candidate =>
      candidate.status === 'Shortlisted' || candidate.status === 'Hired'
    ).length;

    setStats({
      totalJobs,
      activeJobs,
      totalCandidates,
      matches
    });
  };

  // Handle creating new job requirement
  // Handle creating new job requirement - MODIFIED VERSION
  // Handle creating new job requirement - FIXED with modal
  const handleCreateRequirement = () => {
    // Check job creation limit
    const limitCheck = checkJobCreationLimit();

    console.log('Job creation limit check:', limitCheck);

    if (!limitCheck.allowed) {
      // If it's a trial user trying to create second job
      if (limitCheck.isTrial && !limitCheck.trialEnded && limitCheck.current >= limitCheck.limit) {
        // Show special trial limit modal
        setTrialLimitMessage(limitCheck.reason);
        setShowTrialLimitModal(true);
      }
      // If trial has ended
      else if (limitCheck.trialEnded) {
        setTrialLimitMessage(limitCheck.reason);
        setShowTrialLimitModal(true);
      }
      // For other cases, show regular notification
      else {
        showNotification(limitCheck.reason, 'warning');
      }
      return;
    }

    // If allowed, proceed with creating requirement
    setEditingRequirement(null);
    setShowRequirementModal(true);
  };

  // Handle editing job requirement
  const handleEditRequirement = (requirement) => {
    setEditingRequirement(requirement);
    setShowRequirementModal(true);
  };

  // Handle requirement created/updated
  const handleRequirementCreated = () => {
    setShowRequirementModal(false);
    setEditingRequirement(null);
    loadRequirements();
  };

  // Handle delete requirement
  const handleDeleteRequirement = async (requirementId) => {
    if (!window.confirm('Are you sure you want to delete this job requirement?')) {
      return;
    }

    try {
      const token = sessionStorage.getItem('authToken');
      await axios.delete(`${API_BASE_URL}/api/requirements/${requirementId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      setRequirements(prev => prev.filter(req => req._id !== requirementId));
      loadRequirements();
    } catch (error) {
      console.error('Error deleting requirement:', error);
      alert('Failed to delete requirement');
    }
  };

  // Clear all job filters
  const clearJobFilters = () => {
    setJobSearchTerm('');
    setJobStatusFilter('all');
    setJobDepartmentFilter('all');
    setJobSortBy('newest');
    setJobCurrentPage(1);
  };

  // Handle logout
  const handleLogout = () => {
    const isConfirmed = window.confirm("Are you sure you want to logout?");

    // Only logout if user clicked OK (isConfirmed is true)
    if (isConfirmed) {
      sessionStorage.removeItem('authToken');
      sessionStorage.removeItem('userData');
      sessionStorage.removeItem('userEmail');
      navigate('/access-recruit');
    }
    // If user clicked Cancel (isConfirmed is false), do nothing
  };

  // Helper function to determine subscription class



  if (loading) {
    return (
      <div className="rd-loading-container">
        <div className="rd-loading-spinner"></div>
        <p className="rd-loading-text">Loading your dashboard...</p>
      </div>
    );
  }

  return (
    <div className="rd-main-wrapper">
      {/* Header Section */}
      <header className="hrna-navbar">
        <div className="hrna-nav-container">

          {/* Brand Logo */}
          <div className="hrna-nav-brand">
            <div className="hrna-logo-wrapper">
              <FaBriefcase
                size={26}
                style={{
                  color: "#da1717",
                  marginRight: "10px",
                  verticalAlign: "middle"
                }}
              />
              <h1
                className="hrna-logo-text"
                style={{
                  display: "inline-block",
                  verticalAlign: "middle"
                }}
              >
                RecruitAI
              </h1>
            </div>

          </div>

          {/* Center Section - User & Company Info */}
          <div className="hrna-nav-center">
            <div className="hrna-user-subscription-wrapper">

              {/* User Info */}
              <div className="hrna-user-info-compact">
                <div className="hrna-user-avatar-sm">
                  {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
                </div>
                <div className="hrna-user-details-sm">
                  <span className="hrna-user-name-sm">{user?.name || 'User'}</span>
                  <span className="hrna-company-name-sm">{user?.company || 'Company Name'}</span>
                </div>
              </div>

              {/* Subscription Status */}
              <div className="hrna-subscription-compact">
                {user?.subscription ? (
                  <div className={`hrna-subscription-badge ${getSubscriptionClass(user.subscription)}`}>
                    <span className="hrna-badge-icon">
                      {user.subscription.activePlanType === 'paid' || user.subscription.plan === 'paid' ?
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
                        </svg> :
                        user.subscription.activePlanType === 'trial' || user.subscription.isTrialActive ?
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
                          </svg> :
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" />
                          </svg>}
                    </span>
                    <span className="hrna-badge-text">
                      {user.subscription.activePlanType === 'paid' || user.subscription.plan === 'paid' ? 'Premium' :
                        user.subscription.activePlanType === 'trial' || user.subscription.isTrialActive ? 'Trial' : 'Basic'}
                    </span>
                    {(user.subscription.activePlanType === 'trial' || user.subscription.isTrialActive) && (
                      <span
                        className="hrna-upgrade-indicator"
                        onClick={() => navigate('/pricing', {
                          state: {
                            userEmail: user?.email,
                            companyName: user?.company
                          }
                        })}
                      >
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M18 15L12 9L6 15" />
                        </svg>
                      </span>
                    )}
                  </div>
                ) : (
                  <div
                    className="hrna-subscription-badge hrna-no-plan"
                    onClick={() => navigate('/pricing', {
                      state: {
                        userEmail: user?.email,
                        companyName: user?.company
                      }
                    })}
                  >
                    <span className="hrna-badge-icon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                        <path d="M7 11V7a5 5 0 0110 0v4" />
                      </svg>
                    </span>
                    <span className="hrna-badge-text">Get Plan</span>
                  </div>
                )}
              </div>

            </div>
          </div>

          {/* Right Section - Actions */}
          <div className="hrna-nav-actions">
            {/* Support Button */}
            <button
              className="hrna-nav-btn hrna-support-btn"
              onClick={() => window.open('mailto:support@recruitai.com', '_blank')}
              title="Contact Support">
              <span className="hrna-btn-icon">
                <FaHandsHelping size={20} />
              </span>
            </button>
            {/* Logout */}
            <button
              className="hrna-nav-btn hrna-logout-btn"
              onClick={handleLogout}
              title="Logout" >
              <span className="hrna-btn-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" />
                  <path d="M16 17L21 12L16 7" />
                  <path d="M21 12H9" />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </header>
      {/* Main Content */}
      <div className="rd-content-area">
        {/* Hiring Pipeline Section */}
        {activeTab === 'dashboard' && (
          <section className="hd-dashboard-wrapper">
            {/* Main Dashboard Header */}
            <div className="hd-dashboard-header">
              <div className="hd-header-content">
                <div className="hd-greeting-section">
                  <h1 className="hd-greeting">
                    Welcome back,{" "}
                    <span className="hd-user-name">{user?.name || "User"}</span>
                    <FaHandSparkles
                      size={32}
                      style={{
                        marginLeft: "0px",
                        marginTop: "-8px",
                        color: "#e54646",
                        verticalAlign: "middle",
                      }}
                    />
                  </h1>
                  <p className="hd-date-time">
                    {new Date().toLocaleDateString('en-US', {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </p>
                </div>
                <div className="hd-action-buttons">
                  <button className="hd-action-btn hd-btn-primary" onClick={handleCreateRequirement}>
                    <svg className="hd-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                    </svg>
                    <span>New Job</span>
                  </button>
                  <button className="hd-action-btn hd-btn-secondary" onClick={() => setActiveTab('candidates')}>
                    <svg className="hd-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span>View Candidates</span>
                  </button>
                </div>
              </div>

              {/* Animated Stats Bar */}
              <div className="hd-stats-bar">
                <div className="hd-stat-item">
                  <span className="hd-stat-value">{getTodayInterviewsCount()}</span>
                  <span className="hd-stat-label">Today's Interviews</span>
                </div>
                <div className="hd-stat-divider"></div>
                <div className="hd-stat-item">
                  <span className="hd-stat-value">{getPendingReviewsCount()}</span>
                  <span className="hd-stat-label">Pending Reviews</span>
                </div>
                <div className="hd-stat-divider"></div>
                <div className="hd-stat-item">
                  <span className="hd-stat-value">{getUpcomingDeadlinesCount()}</span>
                  <span className="hd-stat-label">Upcoming Deadlines</span>
                </div>
              </div>
            </div>

            {/* Main Content Grid */}
            <div className="hd-dashboard-grid">
              {/* Left Column - Metrics Cards */}
              <div className="hd-left-column">
                {/* Section Header */}
                <div className="hd-section-header">
                  <div className="hd-section-title">
                    <div className="hd-title-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                      </svg>
                    </div>
                    <h2>Recruitment Overview</h2>
                  </div>
                  <div className="hd-period-selector">
                    <select
                      className="hd-period-select"
                      onChange={(e) => {
                        // Handle period change if needed
                        const period = e.target.value;
                        console.log('Period changed to:', period);
                        // You can add state update or API call here
                      }}
                    >
                      <option value="weekly">This Week</option>
                      <option value="monthly">This Month</option>
                      <option value="quarterly">This Quarter</option>
                      <option value="yearly">This Year</option>
                    </select>
                  </div>
                </div>

                {/* Metrics Cards Grid */}
                <div className="hd-metrics-grid">
                  {/* Total Jobs Card */}
                  <div className="hd-metric-card hd-metric-gradient-blue">
                    <div className="hd-card-header">
                      <div className="hd-card-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                        </svg>
                      </div>
                      <div className="hd-trend-badge hd-trend-up">
                        <svg viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" />
                        </svg>
                        <span>{calculateJobGrowth()}%</span>
                      </div>
                    </div>
                    <div className="hd-card-body">
                      <h3 className="hd-metric-value">{requirements.length}</h3>
                      <p className="hd-metric-title">Total Jobs Posted</p>
                      <div className="hd-progress-bar">
                        <div className="hd-progress-fill" style={{ width: `${(requirements.filter(req => req.status === 'Active' && !isDeadlineExpired(req.deadline)).length / Math.max(requirements.length, 1)) * 100}%` }}></div>
                      </div>
                    </div>
                    <div className="hd-card-footer">
                      <span className="hd-meta-text">
                        <svg className="hd-meta-icon" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        Last updated: Today
                      </span>
                    </div>
                  </div>

                  {/* Active Jobs Card */}
                  <div className="hd-metric-card hd-metric-gradient-green">
                    <div className="hd-card-header">
                      <div className="hd-card-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <div className="hd-status-indicator hd-status-active">
                        <span className="hd-status-pulse"></span>
                        Active
                      </div>
                    </div>
                    <div className="hd-card-body">
                      <h3 className="hd-metric-value">{requirements.filter(req => req.status === 'Active' && !isDeadlineExpired(req.deadline)).length}</h3>
                      <p className="hd-metric-title">Active Jobs</p>
                      <div className="hd-metric-details">
                        <div className="hd-detail-item">
                          <span className="hd-detail-label">Open Positions</span>
                          <span className="hd-detail-value">{requirements.reduce((total, req) => total + (req.vacancies || 1), 0)}</span>
                        </div>
                        <div className="hd-detail-item">
                          <span className="hd-detail-label">Avg. Time to Fill</span>
                          <span className="hd-detail-value">{calculateAverageTimeToFill()}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Total Candidates Card */}
                  <div className="hd-metric-card hd-metric-gradient-purple">
                    <div className="hd-card-header">
                      <div className="hd-card-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                      </div>
                      <div className="hd-trend-badge hd-trend-up">
                        <svg viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" />
                        </svg>
                        <span>{calculateCandidateGrowth()}%</span>
                      </div>
                    </div>
                    <div className="hd-card-body">
                      <h3 className="hd-metric-value">{allCandidates.length}</h3>
                      <p className="hd-metric-title">Total Candidates</p>
                      <div className="hd-stats-breakdown">
                        <div className="hd-breakdown-item">
                          <span className="hd-breakdown-dot hd-dot-new"></span>
                          <span>New: {getNewCandidatesCount()}</span>
                        </div>
                        <div className="hd-breakdown-item">
                          <span className="hd-breakdown-dot hd-dot-screening"></span>
                          <span>Screening: {getScreeningCandidatesCount()}</span>
                        </div>
                        <div className="hd-breakdown-item">
                          <span className="hd-breakdown-dot hd-dot-interview"></span>
                          <span>Interview: {getInterviewCandidatesCount()}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Subscription Card */}
                  <div className={`hd-metric-card hd-subscription-card ${user?.subscription ?
                    (user.subscription.activePlanType === 'paid' || user.subscription.plan === 'paid' ? 'hd-card-premium' :
                      user.subscription.activePlanType === 'trial' || user.subscription.isTrialActive ? 'hd-card-trial' :
                        'hd-card-free') :
                    'hd-card-free'
                    }`}>
                    <div className="hd-card-header">
                      <div className="hd-card-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                      </div>
                      <div className="hd-plan-badge">
                        {user?.subscription ? (
                          user.subscription.activePlanType === 'paid' || user.subscription.plan === 'paid' ? (
                            <span className="hd-badge-premium">Premium</span>
                          ) : user.subscription.activePlanType === 'trial' || user.subscription.isTrialActive ? (
                            <span className="hd-badge-trial">Trial</span>
                          ) : (
                            <span className="hd-badge-free">Free</span>
                          )
                        ) : (
                          <span className="hd-badge-free">Free</span>
                        )}
                      </div>
                    </div>
                    <div className="hd-card-body">
                      <h3 className="hd-plan-name">
                        {user?.subscription ? (
                          user.subscription.activePlanType === 'paid' || user.subscription.plan === 'paid' ? 'Premium Plan' :
                            user.subscription.activePlanType === 'trial' || user.subscription.isTrialActive ? 'Free Trial' : 'Free Plan'
                        ) : 'Free Plan'}
                      </h3>
                      <p className="hd-plan-description">
                        {user?.subscription?.activePlanType === 'paid' || user?.subscription?.plan === 'paid'
                          ? 'Full access to all features'
                          : user?.subscription?.activePlanType === 'trial' || user?.subscription?.isTrialActive
                            ? 'Experience premium features'
                            : 'Limited features access'}
                      </p>

                      <div className="hd-plan-details">
                        <div className="hd-detail-row">
                          <span className="hd-detail-label">Status</span>
                          <span className={`hd-detail-value ${user?.subscription?.activePlanType === 'paid' || user?.subscription?.plan === 'paid'
                            ? 'hd-value-active'
                            : user?.subscription?.activePlanType === 'trial' || user?.subscription?.isTrialActive
                              ? 'hd-value-warning'
                              : 'hd-value-inactive'
                            }`}>
                            {user?.subscription?.activePlanType === 'paid' || user?.subscription?.plan === 'paid'
                              ? 'Active'
                              : user?.subscription?.activePlanType === 'trial' || user?.subscription?.isTrialActive
                                ? 'Active Trial'
                                : 'Inactive'}
                          </span>
                        </div>
                        <div className="hd-detail-row">
                          <span className="hd-detail-label">
                            {user?.subscription?.trialEndDate ? 'Trial Ends' :
                              user?.subscription?.currentPeriodEnd || user?.subscription?.subscriptionEndDate ? 'Renews On' : 'Expires'}
                          </span>
                          <span className="hd-detail-value">
                            {user?.subscription?.currentPeriodEnd
                              ? new Date(user.subscription.currentPeriodEnd).toLocaleDateString()
                              : user?.subscription?.subscriptionEndDate
                                ? new Date(user.subscription.subscriptionEndDate).toLocaleDateString()
                                : user?.subscription?.trialEndDate
                                  ? new Date(user.subscription.trialEndDate).toLocaleDateString()
                                  : 'N/A'}
                          </span>
                        </div>
                      </div>

                      {(!user?.subscription ||
                        (!user.subscription.activePlanType &&
                          !user.subscription.plan &&
                          !user.subscription.isTrialActive)) && (
                          <button
                            className="hd-upgrade-btn hd-btn-gradient"
                            onClick={() => navigate('/pricing')}
                          >
                            <span>Upgrade Plan</span>
                            <svg className="hd-btn-arrow" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                          </button>
                        )}
                    </div>
                  </div>
                </div>

                {/* Additional Features Section */}
                <div className="hd-features-section">
                  <h3 className="hd-features-title">Quick Actions</h3>
                  <div className="hd-features-grid">
                    <button className="hd-feature-card" onClick={handleCreateRequirement}>
                      <div className="hd-feature-icon hd-icon-blue">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                        </svg>
                      </div>
                      <span className="hd-feature-text">Post New Job</span>
                    </button>
                    <button className="hd-feature-card" onClick={() => setActiveTab('candidates')}>
                      <div className="hd-feature-icon hd-icon-green">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                        </svg>
                      </div>
                      <span className="hd-feature-text">View Candidates</span>
                    </button>
                    <button className="hd-feature-card" onClick={() => setActiveTab('interviews')}>
                      <div className="hd-feature-icon hd-icon-purple">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                        </svg>
                      </div>
                      <span className="hd-feature-text">Schedule Interview</span>
                    </button>
                    <button className="hd-feature-card" onClick={() => setActiveTab('offer-letters')}>
                      <div className="hd-feature-icon hd-icon-orange">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                      </div>
                      <span className="hd-feature-text">Send Offer Letter</span>
                    </button>
                  </div>
                </div>
              </div>

              {/* Right Column - Recent Activity & Charts */}
              <div className="hd-right-column">
                {/* Recent Activity */}
                <div className="hd-activity-card">
                  <div className="hd-card-header">
                    <h3 className="hd-card-title">
                      <svg className="hd-title-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                      Recent Activity
                    </h3>
                    <button className="hd-view-all" onClick={() => setActiveTab('jobs')}>View All</button>
                  </div>
                  <div className="hd-activity-list">
                    {getRecentActivities().length > 0 ? (
                      getRecentActivities().slice(0, 4).map((activity, index) => (
                        <div key={index} className="hd-activity-item">
                          <div className="hd-activity-icon">
                            {activity.type === 'interview' ? (
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
                              </svg>
                            ) : activity.type === 'application' ? (
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                              </svg>
                            ) : (
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                            )}
                          </div>
                          <div className="hd-activity-content">
                            <p className="hd-activity-text">{activity.message}</p>
                            <span className="hd-activity-time">{activity.time}</span>
                          </div>
                          <div className={`hd-activity-status hd-status-${activity.status}`}>
                            {activity.status}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="hd-no-activity">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p>No recent activity</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Hiring Pipeline Chart */}
                <div className="hd-chart-card">
                  <div className="hd-card-header">
                    <h3 className="hd-card-title">Hiring Pipeline</h3>
                    <div className="hd-legend">
                      <div className="hd-legend-item">
                        <span className="hd-legend-color hd-color-applied"></span>
                        <span>Applied</span>
                      </div>
                      <div className="hd-legend-item">
                        <span className="hd-legend-color hd-color-screening"></span>
                        <span>Screening</span>
                      </div>
                      <div className="hd-legend-item">
                        <span className="hd-legend-color hd-color-interview"></span>
                        <span>Interview</span>
                      </div>
                      <div className="hd-legend-item">
                        <span className="hd-legend-color hd-color-offer"></span>
                        <span>Offer</span>
                      </div>
                      <div className="hd-legend-item">
                        <span className="hd-legend-color hd-color-hired"></span>
                        <span>Hired</span>
                      </div>
                    </div>
                  </div>
                  <div className="hd-pipeline-chart">
                    <div className="hd-chart-placeholder">
                      <div className="hd-chart-bars">
                        {[
                          { label: 'Applied', count: allCandidates.filter(c => c.status === 'Applied').length },
                          { label: 'Screening', count: allCandidates.filter(c => c.status === 'Under Review').length },
                          { label: 'Interview', count: allCandidates.filter(c => c.status === 'Shortlisted').length },
                          { label: 'Offer', count: allCandidates.filter(c => c.status === 'Hired').length },
                          { label: 'Hired', count: offerLetters.filter(ol => ol.status === 'accepted').length }
                        ].map((stage, index) => {
                          const maxCount = Math.max(10, ...allCandidates.map(c => 1), offerLetters.length); // Get max for scaling
                          const height = Math.max((stage.count / maxCount) * 100, 10); // Minimum 10% height
                          return (
                            <div key={stage.label} className="hd-chart-bar">
                              <div
                                className={`hd-bar-fill hd-bar-${stage.label.toLowerCase()}`}
                                style={{ height: `${height}%` }}
                                title={`${stage.label}: ${stage.count}`}
                              ></div>
                              <span className="hd-bar-label">{stage.label}</span>
                              <span className="hd-bar-count">{stage.count}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Upcoming Interviews */}
                <div className="hd-interviews-card">
                  <div className="hd-card-header">
                    <h3 className="hd-card-title">Upcoming Interviews</h3>
                    <span className="hd-interview-count">{getUpcomingInterviews().length}</span>
                  </div>
                  <div className="hd-interviews-list">
                    {getUpcomingInterviews().slice(0, 3).map((interview, index) => (
                      <div key={index} className="hd-interview-item">
                        <div className="hd-interview-time">
                          <span className="hd-time">{interview.time || '10:00 AM'}</span>
                          <span className="hd-date">{interview.date || 'Today'}</span>
                        </div>
                        <div className="hd-interview-details">
                          <h4 className="hd-candidate-name">{interview.candidateName || 'John Doe'}</h4>
                          <p className="hd-job-title">{interview.jobTitle || 'Frontend Developer'}</p>
                          <div className="hd-interview-tags">
                            <span className="hd-tag hd-tag-type">{interview.type || 'Technical'}</span>
                            <span className="hd-tag hd-tag-platform">{interview.platform || 'Zoom'}</span>
                          </div>
                        </div>
                        <button className="hd-join-btn" onClick={() => handleJoinInterview(interview)}>
                          <svg viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                          </svg>
                        </button>
                      </div>
                    ))}
                    {getUpcomingInterviews().length === 0 && (
                      <div className="hd-no-interviews">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <p>No upcoming interviews</p>
                      </div>
                    )}
                  </div>
                  {getUpcomingInterviews().length > 3 && (
                    <button className="hd-view-more" onClick={() => setActiveTab('interviews')}>View All Interviews</button>
                  )}
                </div>
              </div>
            </div>
          </section>
        )}


        <div className="job-portal-container">
          {/* Sidebar Navigation */}
          <aside className="hs-sidebar-container">
            <div className="hs-sidebar-header">
              <div className="hs-header-content">
                <div className="Hr_nav__logo-orb">
                  <img src="/images/logo415.png" alt="Logo" className="Hr_nav__logo-img" /><span className="hr_nav-sidebar-title">umanex</span>
                </div>

                <div className="hs-title-underline"></div>
              </div>
            </div>

            <nav className="hs-nav-menu">
              <button
                className={`hs-nav-item ${activeTab === 'dashboard' ? 'hs-nav-active' : ''}`}
                onClick={() => {
                  setActiveTab('dashboard');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <div className="hs-nav-content">
                  <span className="hs-nav-icon">
                    <svg className="hs-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                  </span>
                  <span className="hs-nav-text">Dashboard</span>
                </div>
                <span className="hs-nav-indicator"></span>
              </button>

              <button
                className={`hs-nav-item ${activeTab === 'job requirements' ? 'hs-nav-active' : ''}`}
                onClick={() => {
                  setActiveTab('job requirements');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <div className="hs-nav-content">
                  <span className="hs-nav-icon">
                    <svg className="hs-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                    </svg>
                  </span>
                  <span className="hs-nav-text">Job Requirements</span>
                </div>
                <span className="hs-nav-indicator"></span>
              </button>

              <button
                className={`hs-nav-item ${activeTab === 'jobs' ? 'hs-nav-active' : ''}`}
                onClick={() => {
                  setActiveTab('jobs');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <div className="hs-nav-content">
                  <span className="hs-nav-icon">
                    <svg className="hs-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </span>
                  <span className="hs-nav-text">Jobs</span>
                </div>
                <span className="hs-nav-indicator"></span>
              </button>

              <button
                className={`hs-nav-item ${activeTab === 'candidates' ? 'hs-nav-active' : ''}`}
                onClick={() => {
                  setActiveTab('candidates');
                  loadAllCandidates();
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <div className="hs-nav-content">
                  <span className="hs-nav-icon">
                    <svg className="hs-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </span>
                  <span className="hs-nav-text">Candidates</span>
                </div>
                <span className="hs-nav-indicator"></span>
              </button>

              <button
                className={`hs-nav-item ${activeTab === 'interviews' ? 'hs-nav-active' : ''}`}
                onClick={() => {
                  setActiveTab('interviews');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <div className="hs-nav-content">
                  <span className="hs-nav-icon">
                    <svg className="hs-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </span>
                  <span className="hs-nav-text">Interviews</span>
                </div>
                <span className="hs-nav-indicator"></span>
              </button>

              <button
                className={`hs-nav-item ${activeTab === 'assessment' ? 'hs-nav-active' : ''}`}
                onClick={() => {
                  setActiveTab('assessment');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <div className="hs-nav-content">
                  <span className="hs-nav-icon">
                    <svg className="hs-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </span>
                  <span className="hs-nav-text">Assessment</span>
                </div>
                <span className="hs-nav-indicator"></span>
              </button>

              <button
                className={`hs-nav-item ${activeTab === 'answers' ? 'hs-nav-active' : ''}`}
                onClick={() => {
                  setActiveTab('answers');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <div className="hs-nav-content">
                  <span className="hs-nav-icon">
                    <svg className="hs-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                  </span>
                  <span className="hs-nav-text">Answers</span>
                </div>
                <span className="hs-nav-indicator"></span>
              </button>

              <button
                className={`hs-nav-item ${activeTab === 'offer-letters' ? 'hs-nav-active' : ''}`}
                onClick={() => {
                  setActiveTab('offer-letters');
                  loadOfferLetters();
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <div className="hs-nav-content">
                  <span className="hs-nav-icon">
                    <svg className="hs-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </span>
                  <span className="hs-nav-text">Offer Letters</span>
                </div>
                <span className="hs-nav-indicator"></span>
              </button>
              {/* Add this button in the sidebar nav section - where other tabs like 'candidates', 'interviews' etc are */}
<button
  className={`hs-nav-item ${activeTab === 'feedback' ? 'hs-nav-active' : ''}`}
  onClick={() => {
    setActiveTab('feedback');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }}
>
  <div className="hs-nav-content">
    <span className="hs-nav-icon">
      <svg className="hs-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
      </svg>
    </span>
    <span className="hs-nav-text">Feedback</span>
  </div>
  <span className="hs-nav-indicator"></span>
</button>

<button
  className={`hs-nav-item ${activeTab === 'verification' ? 'hs-nav-active' : ''}`}
  onClick={() => {
    setActiveTab('verification');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }}
>
  <div className="hs-nav-content">
    <span className="hs-nav-icon">
      <svg className="hs-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    </span>
    <span className="hs-nav-text">Verification</span>
  </div>
  <span className="hs-nav-indicator"></span>
</button>

<button
  className={`hs-nav-item ${activeTab === 'ai-interviews' ? 'hs-nav-active' : ''}`}
  onClick={() => {
    setActiveTab('ai-interviews');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }}
>
  <div className="hs-nav-content">
    <span className="hs-nav-icon">
      <svg className="hs-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3" />
      </svg>
    </span>
    <span className="hs-nav-text">AI Interviews</span>
  </div>
  <span className="hs-nav-indicator"></span>
</button>

            </nav>

            <div className="hs-sidebar-footer">
              <div className="hs-footer-badge">
                <svg className="hs-badge-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                <span className="hs-badge-text">Quick Access</span>
              </div>
            </div>
          </aside>

          {/* Main Content Area */}
          <div className="main-content-wrapper">
            {/* Job Requirements Tab Content */}
            {activeTab === 'job requirements' && (
              <div className="jr-main-container">
                {/* Enhanced Action Bar */}
                <div className="jr-action-bar">
                  <div className="jr-action-left">
                    <button
                      className="jr-create-btn"
                      onClick={handleCreateRequirement}
                      disabled={!checkJobCreationLimit().allowed}
                    >
                      <div className="jr-btn-icon-wrapper">
                        <svg className="jr-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                        </svg>
                      </div>
                      <span className="jr-btn-text">Create Job</span>

                      {/* Show limit badge */}
                      {/* <div className="jr-limit-badge">
                      {user?.subscription?.activePlanType === 'trial' ? (
                        <>
                          <span className="jr-limit-count">{requirements.length}/1</span>
                          <span className="jr-limit-label">Trial Limit</span>
                        </>
                      ) : user?.subscription?.activePlanType === 'paid' ? (
                        <span className="jr-limit-unlimited">Unlimited</span>
                      ) : (
                        <span className="jr-limit-count">{requirements.length}/1</span>
                      )}
                    </div> */}
                    </button>

                    <div className="jr-quick-stats">
                      <div className="jr-stat-item">
                        <div className="jr-stat-icon jr-stat-total">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                        </div>
                        <div className="jr-stat-content">
                          <span className="jr-stat-number">{requirements.length}</span>
                          <span className="jr-stat-label">Total Jobs</span>
                        </div>
                      </div>
                      <div className="jr-stat-divider"></div>
                      <div className="jr-stat-item">
                        <div className="jr-stat-icon jr-stat-active">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                        <div className="jr-stat-content">
                          <span className="jr-stat-number">{requirements.filter(req => req.status === 'Active' && !isDeadlineExpired(req.deadline)).length}</span>
                          <span className="jr-stat-label">Active</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="jr-action-right">
                    <div className="jr-view-tabs">
                      <button
                        className={`jr-view-tab ${jobStatusFilter === 'all' ? 'jr-tab-active' : ''}`}
                        onClick={() => setJobStatusFilter('all')}
                      >
                        <span className="jr-tab-text">All</span>
                        <span className="jr-tab-count">{requirements.length}</span>
                      </button>
                      <button
                        className={`jr-view-tab ${jobStatusFilter === 'active' ? 'jr-tab-active' : ''}`}
                        onClick={() => setJobStatusFilter('active')}
                      >
                        <span className="jr-tab-text">Active</span>
                        <span className="jr-tab-count">{requirements.filter(req => req.status === 'Active' && !isDeadlineExpired(req.deadline)).length}</span>
                      </button>
                      <button
                        className={`jr-view-tab ${jobStatusFilter === 'expired' ? 'jr-tab-active' : ''}`}
                        onClick={() => setJobStatusFilter('expired')}
                      >
                        <span className="jr-tab-text">Expired</span>
                        <span className="jr-tab-count">{requirements.filter(req => isDeadlineExpired(req.deadline)).length}</span>
                      </button>
                    </div>

                    <button
                      className={`jr-filter-btn ${showJobFilters ? 'jr-filter-active' : ''}`}
                      onClick={() => setShowJobFilters(!showJobFilters)}
                    >
                      <svg className="jr-filter-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                      </svg>
                      <span>Filters</span>
                      {(jobSearchTerm || jobStatusFilter !== 'all' || jobDepartmentFilter !== 'all') && (
                        <span className="jr-filter-badge">{[jobSearchTerm, jobStatusFilter !== 'all', jobDepartmentFilter !== 'all'].filter(Boolean).length}</span>
                      )}
                    </button>
                  </div>
                </div>

                {/* Advanced Filters Panel */}
                {showJobFilters && (
                  <div className="jr-filters-container">
                    <div className="jr-filters-header">
                      <div className="jr-filters-title-group">
                        <svg className="jr-filters-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                        </svg>
                        <h4 className="jr-filters-title">Advanced Filters</h4>
                      </div>
                      <button
                        className="jr-clear-btn"
                        onClick={clearJobFilters}
                        disabled={!jobSearchTerm && jobStatusFilter === 'all' && jobDepartmentFilter === 'all'}
                      >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        Clear All
                      </button>
                    </div>

                    <div className="jr-filters-grid">
                      <div className="jr-filter-group">
                        <label className="jr-filter-label">
                          <svg className="jr-label-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                          </svg>
                          Search Jobs
                        </label>
                        <div className="jr-search-wrapper">
                          {/* <svg className="jr-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                          </svg> */}
                          <input
                            type="text"
                            placeholder="Search by position, department..."
                            value={jobSearchTerm}
                            onChange={(e) => setJobSearchTerm(e.target.value)}
                            className="jr-search-input"
                          />
                          {jobSearchTerm && (
                            <button
                              className="jr-clear-search"
                              onClick={() => setJobSearchTerm('')}
                            >
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          )}
                        </div>
                      </div>

                      <div className="jr-filter-group">
                        <label className="jr-filter-label">
                          <svg className="jr-label-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                          </svg>
                          Job Status
                        </label>
                        <div className="jr-select-wrapper">
                          <select
                            value={jobStatusFilter}
                            onChange={(e) => setJobStatusFilter(e.target.value)}
                            className="jr-filter-select"
                          >
                            <option value="all">All Status</option>
                            <option value="active">Active Jobs</option>
                            <option value="expired">Expired Jobs</option>
                            <option value="draft">Draft Jobs</option>
                          </select>
                          <svg className="jr-select-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                          </svg>
                        </div>
                      </div>

                      <div className="jr-filter-group">
                        <label className="jr-filter-label">
                          <svg className="jr-label-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                          </svg>
                          Department
                        </label>
                        <div className="jr-select-wrapper">
                          <select
                            value={jobDepartmentFilter}
                            onChange={(e) => setJobDepartmentFilter(e.target.value)}
                            className="jr-filter-select"
                          >
                            <option value="all">All Departments</option>
                            {departments.map(dept => (
                              <option key={dept} value={dept}>{dept}</option>
                            ))}
                          </select>
                          <svg className="jr-select-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                          </svg>
                        </div>
                      </div>

                      <div className="jr-filter-group">
                        <label className="jr-filter-label">
                          <svg className="jr-label-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
                          </svg>
                          Sort By
                        </label>
                        <div className="jr-select-wrapper">
                          <select
                            value={jobSortBy}
                            onChange={(e) => setJobSortBy(e.target.value)}
                            className="jr-filter-select"
                          >
                            <option value="newest">Newest First</option>
                            <option value="oldest">Oldest First</option>
                            <option value="position">Position A-Z</option>
                            <option value="department">Department A-Z</option>
                            <option value="applicants">Most Applicants</option>
                            <option value="deadline">Deadline</option>
                          </select>
                          <svg className="jr-select-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                          </svg>
                        </div>
                      </div>
                    </div>

                    {(jobSearchTerm || jobStatusFilter !== 'all' || jobDepartmentFilter !== 'all') && (
                      <div className="jr-active-filters">
                        <span className="jr-filters-label">Active Filters:</span>
                        <div className="jr-filter-tags">
                          {jobSearchTerm && (
                            <span className="jr-filter-tag">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                              </svg>
                              <span>"{jobSearchTerm}"</span>
                              <button onClick={() => setJobSearchTerm('')}>×</button>
                            </span>
                          )}
                          {jobStatusFilter !== 'all' && (
                            <span className="jr-filter-tag">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                              <span>{jobStatusFilter}</span>
                              <button onClick={() => setJobStatusFilter('all')}>×</button>
                            </span>
                          )}
                          {jobDepartmentFilter !== 'all' && (
                            <span className="jr-filter-tag">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                              </svg>
                              <span>{jobDepartmentFilter}</span>
                              <button onClick={() => setJobDepartmentFilter('all')}>×</button>
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    <div className="jr-results-summary">
                      <div className="jr-summary-content">
                        <svg className="jr-summary-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                        <span>
                          Showing <strong>{filteredJobs.length}</strong> of <strong>{requirements.length}</strong> jobs
                          {filteredJobs.length !== requirements.length && ' (filtered)'}
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                {/* Empty State */}
                {requirements.length === 0 ? (
                  <div className="jr-empty-state">
                    <div className="jr-empty-illustration">
                      <div className="jr-empty-circle">
                        <svg className="jr-empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                      </div>
                    </div>
                    <h3 className="jr-empty-title">No Job Requirements Yet</h3>
                    <p className="jr-empty-description">Create your first job post to start finding talented candidates</p>
                    <button
                      className="jr-empty-action-btn"
                      onClick={handleCreateRequirement}
                    >
                      <svg className="jr-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                      </svg>
                      Create Your First Job
                    </button>
                  </div>
                ) : (
                  <>
                    {/* Jobs Grid */}
                    <div className="jr-jobs-grid">
                      {currentJobs.map((requirement, index) => (
                        <div
                          key={requirement._id}
                          className={`jr-job-card ${isDeadlineExpired(requirement.deadline) ? 'jr-card-expired' : ''}`}
                          style={{ animationDelay: `${index * 0.1}s` }}
                        >
                          <div className="jr-card-glow"></div>

                          {/* Card Header */}
                          <div className="jr-card-header">
                            <div className="jr-header-main">
                              <h3 className="jr-job-title">{requirement.position}</h3>
                              <span className={`jr-status-badge ${isDeadlineExpired(requirement.deadline) ? 'jr-badge-expired' : 'jr-badge-active'}`}>
                                <span className="jr-badge-dot"></span>
                                {isDeadlineExpired(requirement.deadline) ? 'Expired' : 'Active'}
                              </span>
                            </div>

                            <div className="jr-dept-tag">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                              </svg>
                              <span>{requirement.department}</span>
                            </div>

                            <div className="jr-header-stats">
                              <div className="jr-stat-badge">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                </svg>
                                <span>{requirement.vacancies} positions</span>
                              </div>
                              <div className="jr-stat-badge">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                <span>{requirement.applicantsCount || 0} applicants</span>
                              </div>
                            </div>
                          </div>

                          {/* Card Body */}
                          <div className="jr-card-body">
                            <p className="jr-job-description">
                              {requirement.description.length > 120
                                ? `${requirement.description.substring(0, 120)}...`
                                : requirement.description
                              }
                            </p>

                            <div className="jr-skills-section">
                              <div className="jr-skills-header">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                                </svg>
                                <span>Required Skills</span>
                              </div>
                              <div className="jr-skills-list">
                                {requirement.requiredSkills.slice(0, 3).map((skill, index) => (
                                  <span key={index} className="jr-skill-chip">{skill}</span>
                                ))}
                                {requirement.requiredSkills.length > 3 && (
                                  <span className="jr-skill-more">+{requirement.requiredSkills.length - 3} more</span>
                                )}
                              </div>
                            </div>

                            <div className="jr-info-grid">
                              <div className="jr-info-item">
                                <div className="jr-info-icon jr-icon-location">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                  </svg>
                                </div>
                                <div className="jr-info-content">
                                  <span className="jr-info-label">Location</span>
                                  <span className="jr-info-value">{requirement.location || 'Not specified'}</span>
                                </div>
                              </div>

                              <div className="jr-info-item">
                                <div className="jr-info-icon jr-icon-salary">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                  </svg>
                                </div>
                                <div className="jr-info-content">
                                  <span className="jr-info-label">Salary Range</span>
                                  <span className="jr-info-value">
                                    {requirement.salaryRange || 'Not specified'}
                                  </span>
                                </div>
                              </div>

                              <div className="jr-info-item">
                                <div className="jr-info-icon jr-icon-deadline">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                  </svg>
                                </div>
                                <div className="jr-info-content">
                                  <span className="jr-info-label">Application Deadline</span>
                                  <span className="jr-info-value">{formatDate(requirement.deadline)}</span>
                                </div>
                              </div>
                            </div>

                            {/* Application Link */}
                            <div className="jr-link-section">
                              <div className="jr-link-header">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                                </svg>
                                <span>Application Link</span>
                              </div>
                              <div className="jr-link-box">
                                <input
                                  type="text"
                                  value={generateApplicationLink(requirement._id)}
                                  readOnly
                                  className="jr-link-input"
                                />
                                <button
                                  onClick={() => copyApplicationLink(requirement._id)}
                                  className="jr-copy-btn"
                                  title="Copy link"
                                >
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                  </svg>
                                  <span>Copy</span>
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* Card Footer */}
                          <div className="jr-card-footer">
                            <button
                              className="jr-action-btn jr-btn-edit"
                              onClick={() => handleEditRequirement(requirement)}
                            >
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                              </svg>
                              <span>Edit</span>
                            </button>
                            <button
                              className="jr-action-btn jr-btn-view"
                              onClick={() => handleViewApplications(requirement)}
                            >
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                              </svg>
                              <span>View ({requirement.applicantsCount || 0})</span>
                            </button>
                            <button
                              className="jr-action-btn jr-btn-delete"
                              onClick={() => handleDeleteRequirement(requirement._id)}
                            >
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                              <span>Delete</span>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Enhanced Pagination */}
                    {filteredJobs.length > jobsPerPage && (
                      <div className="jr-pagination-wrapper">
                        <div className="jr-pagination-info">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                          </svg>
                          <span>
                            Showing <strong>{((jobCurrentPage - 1) * jobsPerPage) + 1}</strong> to <strong>{Math.min(jobCurrentPage * jobsPerPage, filteredJobs.length)}</strong> of <strong>{filteredJobs.length}</strong> jobs
                          </span>
                        </div>

                        <div className="jr-pagination-controls">
                          <button
                            onClick={() => setJobCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={jobCurrentPage === 1}
                            className="jr-page-btn jr-page-prev"
                          >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                            </svg>
                            <span>Previous</span>
                          </button>

                          <div className="jr-page-numbers">
                            {Array.from({ length: Math.ceil(filteredJobs.length / jobsPerPage) }, (_, i) => i + 1)
                              .filter(page => {
                                const totalPages = Math.ceil(filteredJobs.length / jobsPerPage);
                                return page === 1 || page === totalPages || Math.abs(page - jobCurrentPage) <= 1;
                              })
                              .map((page, index, array) => {
                                const prevPage = array[index - 1];
                                if (prevPage && page - prevPage > 1) {
                                  return (
                                    <React.Fragment key={`ellipsis-${page}`}>
                                      <span className="jr-page-ellipsis">...</span>
                                      <button
                                        onClick={() => setJobCurrentPage(page)}
                                        className={`jr-page-number ${jobCurrentPage === page ? 'jr-page-active' : ''}`}
                                      >
                                        {page}
                                      </button>
                                    </React.Fragment>
                                  );
                                }
                                return (
                                  <button
                                    key={page}
                                    onClick={() => setJobCurrentPage(page)}
                                    className={`jr-page-number ${jobCurrentPage === page ? 'jr-page-active' : ''}`}
                                  >
                                    {page}
                                  </button>
                                );
                              })}
                          </div>

                          <button
                            onClick={() => setJobCurrentPage(prev => Math.min(prev + 1, Math.ceil(filteredJobs.length / jobsPerPage)))}
                            disabled={jobCurrentPage === Math.ceil(filteredJobs.length / jobsPerPage)}
                            className="jr-page-btn jr-page-next"
                          >
                            <span>Next</span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                            </svg>
                          </button>
                        </div>

                        <div className="jr-page-size-selector">
                          <label>Items per page:</label>
                          <select
                            value={jobsPerPage}
                            onChange={(e) => {
                              setJobsPerPage(Number(e.target.value));
                              setJobCurrentPage(1);
                            }}
                            className="jr-page-size-select"
                          >
                            <option value={6}>6</option>
                            <option value={9}>9</option>
                            <option value={12}>12</option>
                            <option value={18}>18</option>
                          </select>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            {/* Other Tab Contents */}
            {activeTab === 'jobs' && (
              <div className="rde-jobs-section">
                {/* Header with Action Buttons */}
                <div className="rde-jobs-header">
                  <div className="rde-header-left">
                    <h2 className="rde-page-title">Job Positions</h2>
                    <p className="rde-page-subtitle">
                      Manage and track all your job postings and candidate applications
                    </p>
                  </div>

                  <div className="rde-header-right">
                    {/* In the rde-header-right section */}
                    <button
                      className="rde-create-job-btn"
                      onClick={handleCreateRequirement}
                      disabled={!checkJobCreationLimit().allowed}
                      title={!checkJobCreationLimit().allowed ? checkJobCreationLimit().reason : 'Create new job'}
                    >
                      <svg className="rde-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                      </svg>
                      <span className="rde-btn-text">
                        {checkJobCreationLimit().allowed ? 'Create New Job' : 'Upgrade to Create More'}
                      </span>
                    </button>
                  </div>
                </div>

                {/* Filter and Search Section */}
                <div className="rde-filters-section">
                  <div className="rde-quick-filters">
                    <div className="rde-search-box">
                      {/* <svg className="rde-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg> */}
                      <input
                        type="text"
                        placeholder="Search jobs by position, department, or skills..."
                        value={jobSearchFilter}
                        onChange={(e) => setJobSearchFilter(e.target.value)}
                        className="rde-search-input"
                      />
                      {jobSearchFilter && (
                        <button
                          className="rde-clear-search-btn"
                          onClick={() => setJobSearchFilter('')}
                        >
                          {/* <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg> */}
                        </button>
                      )}
                    </div>

                    <div className="rde-filter-controls">
                      <div className="rde-filter-group">
                        <label className="rde-filter-label">
                          <svg className="rde-filter-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                          </svg>
                          Department
                        </label>
                        <select
                          value={departmentFilter}
                          onChange={(e) => setDepartmentFilter(e.target.value)}
                          className="rde-filter-select"
                        >
                          <option value="all">All Departments</option>
                          {Array.from(new Set(requirements.map(req => req.department))).map(dept => (
                            <option key={dept} value={dept}>{dept}</option>
                          ))}
                        </select>
                      </div>

                      <div className="rde-filter-group">
                        <label className="rde-filter-label">
                          <svg className="rde-filter-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          Status
                        </label>
                        <select
                          value={statusFilter}
                          onChange={(e) => setStatusFilter(e.target.value)}
                          className="rde-filter-select"
                        >
                          <option value="all">All Status</option>
                          <option value="active">Active</option>
                          <option value="expired">Expired</option>
                          <option value="draft">Draft</option>
                        </select>
                      </div>

                      <div className="rde-filter-group">
                        <label className="rde-filter-label">
                          <svg className="rde-filter-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
                          </svg>
                          Sort By
                        </label>
                        <select
                          value={sortBy}
                          onChange={(e) => setSortBy(e.target.value)}
                          className="rde-filter-select"
                        >
                          <option value="newest">Newest First</option>
                          <option value="oldest">Oldest First</option>
                          <option value="position">Position A-Z</option>
                          <option value="applicants">Most Applicants</option>
                          <option value="deadline">Deadline</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Active Filters Display */}
                  {hasActiveFiltersForJobsTab && (
                    <div className="rde-active-filters">
                      <div className="rde-filters-header">
                        <div className="rde-filters-title">
                          <svg className="rde-filters-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                          </svg>
                          <span>Active Filters:</span>
                        </div>
                        <button
                          className="rde-clear-all-filters-btn"
                          onClick={clearAllFiltersForJobsTab}
                        >
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                          Clear All
                        </button>
                      </div>

                      <div className="rde-filter-chips">
                        {jobSearchFilter && (
                          <div className="rde-filter-chip">
                            <span className="rde-chip-text">Search: "{jobSearchFilter}"</span>
                            <button
                              className="rde-chip-remove"
                              onClick={() => setJobSearchFilter('')}
                            >
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </div>
                        )}
                        {departmentFilter !== 'all' && (
                          <div className="rde-filter-chip">
                            <span className="rde-chip-text">Department: {departmentFilter}</span>
                            <button
                              className="rde-chip-remove"
                              onClick={() => setDepartmentFilter('all')}
                            >
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </div>
                        )}
                        {statusFilter !== 'all' && (
                          <div className="rde-filter-chip">
                            <span className="rde-chip-text">Status: {statusFilter}</span>
                            <button
                              className="rde-chip-remove"
                              onClick={() => setStatusFilter('all')}
                            >
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </div>
                        )}
                        {sortBy !== 'newest' && (
                          <div className="rde-filter-chip">
                            <span className="rde-chip-text">Sorted by: {sortBy}</span>
                            <button
                              className="rde-chip-remove"
                              onClick={() => setSortBy('newest')}
                            >
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Stats Cards */}
                <div className="rde-stats-grid">
                  <div className="rde-stat-card">
                    <div className="rde-stat-icon rde-stat-total">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                    <div className="rde-stat-content">
                      <div className="rde-stat-number">{requirements.length}</div>
                      <div className="rde-stat-label">Total Jobs</div>
                    </div>
                  </div>

                  <div className="rde-stat-card">
                    <div className="rde-stat-icon rde-stat-active">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div className="rde-stat-content">
                      <div className="rde-stat-number">
                        {requirements.filter(req => req.status === 'Active' && !isDeadlineExpired(req.deadline)).length}
                      </div>
                      <div className="rde-stat-label">Active Jobs</div>
                    </div>
                  </div>

                  <div className="rde-stat-card">
                    <div className="rde-stat-icon rde-stat-expired">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div className="rde-stat-content">
                      <div className="rde-stat-number">
                        {requirements.filter(req => isDeadlineExpired(req.deadline)).length}
                      </div>
                      <div className="rde-stat-label">Expired Jobs</div>
                    </div>
                  </div>

                  <div className="rde-stat-card">
                    <div className="rde-stat-icon rde-stat-applicants">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                    </div>
                    <div className="rde-stat-content">
                      <div className="rde-stat-number">
                        {requirements.reduce((total, job) => total + (job.applicantsCount || 0), 0)}
                      </div>
                      <div className="rde-stat-label">Total Applicants</div>
                    </div>
                  </div>
                </div>

                {/* Jobs Table with Expandable Rows */}
                <div className="rde-jobs-table-container">
                  {currentJobsForJobsTab.length === 0 ? (
                    <div className="rde-empty-state">
                      <div className="rde-empty-illustration">
                        <svg className="rde-empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                      </div>
                      <h3 className="rde-empty-title">
                        {hasActiveFiltersForJobsTab ? 'No Jobs Found' : 'No Job Positions Yet'}
                      </h3>
                      <p className="rde-empty-description">
                        {hasActiveFiltersForJobsTab
                          ? 'Try adjusting your filters or search terms'
                          : 'Create your first job post to start finding talented candidates'
                        }
                      </p>
                      {hasActiveFiltersForJobsTab ? (
                        <button
                          className="rde-clear-filters-btn"
                          onClick={clearAllFiltersForJobsTab}
                        >
                          Clear All Filters
                        </button>
                      ) : (
                        <button
                          className="rde-create-first-btn"
                          onClick={handleCreateRequirement}
                        >
                          <svg className="rde-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                          </svg>
                          Create Your First Job
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="rde-jobs-table-wrapper">
                      <div className="rde-jobs-table">
                        {/* Table Header */}
                        <div className="rde-table-header">
                          <div className="rde-table-row rde-table-header-row">
                            <div className="rde-table-cell rde-cell-job">Job Position</div>
                            <div className="rde-table-cell rde-cell-dept">Department</div>
                            <div className="rde-table-cell rde-cell-applicants">Applicants</div>
                            <div className="rde-table-cell rde-cell-status">Status</div>
                            <div className="rde-table-cell rde-cell-deadline">Deadline</div>
                            <div className="rde-table-cell rde-cell-vacancies">Positions</div>
                            <div className="rde-table-cell rde-cell-actions">Actions</div>
                          </div>
                        </div>

                        {/* Table Body */}
                        <div className="rde-table-body">
                          {currentJobsForJobsTab.map((job) => (
                            <div
                              key={job._id}
                              className={`rde-table-row rde-job-row ${expandedJob === job._id ? 'rde-row-expanded' : ''}`}
                            >
                              {/* Main Row Content */}
                              <div className="rde-row-main" onClick={() => toggleJobExpansion(job._id)}>
                                <div className="rde-table-cell rde-cell-job">
                                  <div className="rde-job-info">
                                    <h4 className="rde-job-title">{job.position}</h4>
                                    <div className="rde-job-meta">
                                      <span className="rde-job-salary">
                                        {job.salaryRange || 'Remote'}
                                      </span>
                                      <span className="rde-job-location">{job.location || 'Remote'}</span>
                                    </div>
                                  </div>
                                </div>

                                <div className="rde-table-cell rde-cell-dept">
                                  <div className="rde-dept-badge">{job.department}</div>
                                </div>

                                <div className="rde-table-cell rde-cell-applicants">
                                  <div className="rde-applicants-info">
                                    <div className="rde-applicants-count">
                                      {jobApplications[job._id]?.length || job.applicantsCount || 0}
                                    </div>
                                    <div className="rde-applicants-label">applicants</div>
                                  </div>
                                </div>

                                <div className="rde-table-cell rde-cell-status">
                                  <div className={`rde-status-badge ${isDeadlineExpired(job.deadline) ? 'rde-status-expired' : 'rde-status-active'}`}>
                                    <span className="rde-status-dot"></span>
                                    {isDeadlineExpired(job.deadline) ? 'Expired' : 'Active'}
                                  </div>
                                </div>

                                <div className="rde-table-cell rde-cell-deadline">
                                  <div className="rde-deadline-info">
                                    <div className="rde-deadline-date">{formatDate(job.deadline)}</div>
                                    <div className="rde-deadline-days">
                                      {getDaysUntilDeadline(job.deadline)}
                                    </div>
                                  </div>
                                </div>

                                <div className="rde-table-cell rde-cell-vacancies">
                                  <div className="rde-vacancies-badge">
                                    {job.vacancies || 1} position{job.vacancies !== 1 ? 's' : ''}
                                  </div>
                                </div>

                                <div className="rde-table-cell rde-cell-actions">
                                  <div className="rde-action-buttons">
                                    <button
                                      className="rde-action-btn rde-btn-copy"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        copyApplicationLink(job._id);
                                      }}
                                      title="Copy Application Link"
                                    >
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                      </svg>
                                    </button>

                                    <button
                                      className="rde-action-btn rde-btn-edit"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleEditRequirement(job);
                                      }}
                                      title="Edit Job"
                                    >
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                      </svg>
                                    </button>

                                    <button
                                      className="rde-action-btn rde-btn-view"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleJobExpansion(job._id);
                                      }}
                                      title={expandedJob === job._id ? 'Hide Candidates' : 'View Candidates'}
                                    >
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </div>

                              {/* Expandable Candidates Section */}
                              {expandedJob === job._id && (
                                <div className="rde-row-expandable">
                                  <div className="rde-candidates-panel">
                                    <div className="rde-candidates-header">
                                      <h4 className="rde-candidates-title">
                                        Candidates for {job.position}
                                        <span className="rde-candidates-count">
                                          ({jobApplications[job._id]?.length || 0} applicants)
                                        </span>
                                      </h4>

                                      <div className="rde-candidates-actions">
                                        <button
                                          className="rde-export-btn"
                                          onClick={() => exportToExcel(jobApplications[job._id] || [])}
                                        >
                                          <svg className="rde-export-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                          </svg>
                                          Export to Excel
                                        </button>

                                        <button
                                          className="rde-copy-link-btn"
                                          onClick={() => copyApplicationLink(job._id)}
                                        >
                                          <svg className="rde-link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                                          </svg>
                                          Copy Application Link
                                        </button>
                                      </div>
                                    </div>

                                    {loadingApplications[job._id] ? (
                                      <div className="rde-loading-candidates">
                                        <div className="rde-loading-spinner"></div>
                                        <span>Loading candidates...</span>
                                      </div>
                                    ) : jobApplications[job._id]?.length > 0 ? (
                                      <div className="rde-candidates-table">
                                        <div className="rde-candidates-table-header">
                                          <div className="rde-candidate-col rde-col-name">Candidate</div>
                                          <div className="rde-candidate-col rde-col-email">Email</div>
                                          <div className="rde-candidate-col rde-col-phone">Phone</div>
                                          <div className="rde-candidate-col rde-col-experience">Experience</div>
                                          <div className="rde-candidate-col rde-col-skills">Skills</div>
                                          <div className="rde-candidate-col rde-col-status">Status</div>
                                          <div className="rde-candidate-col rde-col-actions">Actions</div>
                                        </div>

                                        <div className="rde-candidates-table-body">
                                          {jobApplications[job._id].map((candidate) => (
                                            <div key={candidate._id} className="rde-candidate-row">
                                              <div className="rde-candidate-col rde-col-name">
                                                <div className="rde-candidate-info">
                                                  <div className="rde-candidate-avatar">
                                                    {candidate.name ? candidate.name.charAt(0).toUpperCase() : 'U'}
                                                  </div>
                                                  <div className="rde-candidate-details">
                                                    <div className="rde-candidate-name">{candidate.name || 'No Name'}</div>
                                                    {candidate.location && (
                                                      <div className="rde-candidate-location">
                                                        <svg className="rde-location-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                        </svg>
                                                        {candidate.location}
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="rde-candidate-col rde-col-email">
                                                <a href={`mailto:${candidate.email}`} className="rde-candidate-email">
                                                  {candidate.email || 'No Email'}
                                                </a>
                                              </div>

                                              <div className="rde-candidate-col rde-col-phone">
                                                {candidate.phone ? (
                                                  <div className="rde-phone-info">
                                                    <a href={`tel:${candidate.phone}`} className="rde-phone-link">
                                                      {candidate.phone}
                                                    </a>
                                                    <button
                                                      className="rde-whatsapp-btn"
                                                      onClick={() => {
                                                        const message = `Hi ${candidate.name}, we'd like to discuss your application for ${job.position}`;
                                                        window.open(`https://wa.me/${candidate.phone.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`, '_blank');
                                                      }}
                                                      title="Message on WhatsApp"
                                                    >
                                                      <svg className="rde-whatsapp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                                                      </svg>
                                                    </button>
                                                  </div>
                                                ) : (
                                                  <span className="rde-no-phone">Not provided</span>
                                                )}
                                              </div>

                                              <div className="rde-candidate-col rde-col-experience">
                                                <div className="rde-experience-badge">
                                                  {candidate.totalExperience || candidate.experience || 'Fresher'}
                                                </div>
                                              </div>

                                              {/* In the candidate row skills section */}
                                              <div className="rde-candidate-col rde-col-skills">
                                                <div className="rde-skills-list">
                                                  {(candidate.skills || []).slice(0, 3).map((skill, index) => (
                                                    <span key={index} className="rde-skill-chip">{skill}</span>
                                                  ))}
                                                  {(candidate.skills || []).length > 3 && (
                                                    <button
                                                      className="rde-view-all-skills-btn"
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectedSkills(candidate.skills || []);
                                                        setSelectedCandidateName(candidate.name || 'Candidate');
                                                        setSkillsModalOpen(true);
                                                      }}
                                                      title="View all skills"
                                                    >
                                                      +{(candidate.skills || []).length - 3} more
                                                    </button>
                                                  )}
                                                </div>
                                              </div>

                                              <div className="rde-candidate-col rde-col-status">
                                                <select
                                                  value={candidate.status || 'Applied'}
                                                  onChange={(e) => updateApplicationStatus(candidate._id, e.target.value, candidate)}
                                                  className={`rde-status-select rde-status-${(candidate.status || 'Applied').toLowerCase().replace(' ', '-')}`}
                                                >
                                                  <option value="Applied">Applied</option>
                                                  <option value="Under Review">Under Review</option>
                                                  <option value="Shortlisted">Shortlisted</option>
                                                  <option value="Rejected">Rejected</option>
                                                  {/* <option value="Hired">Hired</option> */}
                                                </select>
                                              </div>

                                              <div className="rde-candidate-col rde-col-actions">
                                                <div className="rde-candidate-actions">
                                                  <button
                                                    className="rde-action-icon rde-btn-resume"
                                                    onClick={() => handleDownloadClick(candidate)}
                                                    title="Download Resume"
                                                  >
                                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                    </svg>
                                                  </button>

                                                  <button
                                                    className="rde-action-icon rde-btn-view"
                                                    onClick={() => {
                                                      setSelectedSkills(candidate.skills || []);
                                                      setSelectedCandidateName(candidate.name || 'Candidate');
                                                      setSkillsModalOpen(true);
                                                    }}
                                                    title="View Skills"
                                                  >
                                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                    </svg>
                                                  </button>

                                                  <button
                                                    className="rde-action-icon rde-btn-interview"
                                                    onClick={() => {
                                                      setSelectedApplication(candidate);
                                                      setShowInterviewModal(true);
                                                    }}
                                                    title="Schedule Interview"
                                                  >
                                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                    </svg>
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="rde-no-candidates">
                                        <div className="rde-no-candidates-icon">
                                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                          </svg>
                                        </div>
                                        <h4 className="rde-no-candidates-title">No Applications Yet</h4>
                                        <p className="rde-no-candidates-description">
                                          Share the application link to start receiving applications from candidates.
                                        </p>
                                        <div className="rde-application-link">
                                          <input
                                            type="text"
                                            value={generateApplicationLink(job._id)}
                                            readOnly
                                            className="rde-link-input"
                                          />
                                          <button
                                            onClick={() => copyApplicationLink(job._id)}
                                            className="rde-copy-link-btn"
                                          >
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                            </svg>
                                            Copy Link
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Pagination */}
                {filteredJobsForJobsTab.length > jobsPerPage && (
                  <div className="rde-pagination-wrapper">
                    <div className="rde-pagination-info">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                      </svg>
                      <span>
                        Showing <strong>{((jobCurrentPage - 1) * jobsPerPage) + 1}</strong> to{' '}
                        <strong>{Math.min(jobCurrentPage * jobsPerPage, filteredJobsForJobsTab.length)}</strong> of{' '}
                        <strong>{filteredJobsForJobsTab.length}</strong> jobs
                        {hasActiveFiltersForJobsTab && ' (filtered)'}
                      </span>
                    </div>

                    <div className="rde-pagination-controls">
                      <button
                        onClick={() => setJobCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={jobCurrentPage === 1}
                        className="rde-page-btn rde-page-prev"
                      >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                        </svg>
                        Previous
                      </button>

                      <div className="rde-page-numbers">
                        {Array.from({ length: Math.ceil(filteredJobsForJobsTab.length / jobsPerPage) }, (_, i) => i + 1)
                          .filter(page => {
                            const totalPages = Math.ceil(filteredJobsForJobsTab.length / jobsPerPage);
                            return page === 1 || page === totalPages || Math.abs(page - jobCurrentPage) <= 1;
                          })
                          .map((page, index, array) => {
                            const prevPage = array[index - 1];
                            if (prevPage && page - prevPage > 1) {
                              return (
                                <React.Fragment key={`ellipsis-${page}`}>
                                  <span className="rde-page-ellipsis">...</span>
                                  <button
                                    onClick={() => setJobCurrentPage(page)}
                                    className={`rde-page-number ${jobCurrentPage === page ? 'rde-page-active' : ''}`}
                                  >
                                    {page}
                                  </button>
                                </React.Fragment>
                              );
                            }
                            return (
                              <button
                                key={page}
                                onClick={() => setJobCurrentPage(page)}
                                className={`rde-page-number ${jobCurrentPage === page ? 'rde-page-active' : ''}`}
                              >
                                {page}
                              </button>
                            );
                          })}
                      </div>

                      <button
                        onClick={() => setJobCurrentPage(prev => Math.min(prev + 1, Math.ceil(filteredJobsForJobsTab.length / jobsPerPage)))}
                        disabled={jobCurrentPage === Math.ceil(filteredJobsForJobsTab.length / jobsPerPage)}
                        className="rde-page-btn rde-page-next"
                      >
                        Next
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                      </button>

                      <div className="rde-page-size-selector">
                        <select
                          value={jobsPerPage}
                          onChange={(e) => {
                            setJobsPerPage(Number(e.target.value));
                            setJobCurrentPage(1);
                          }}
                          className="rde-page-size-select"
                        >
                          <option value={10}>10 per page</option>
                          <option value={20}>20 per page</option>
                          <option value={50}>50 per page</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}


            {showTrialLimitModal && (
              <div className="rd-trial-limit-modal-overlay">
                <div className="rd-trial-limit-modal">
                  <div className="rd-trial-modal-header">
                    <div className="rd-trial-modal-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.998-.833-2.768 0L4.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                      </svg>
                    </div>
                    <h3 className="rd-trial-modal-title">Trial Limit Reached</h3>
                    <button
                      className="rd-trial-modal-close"
                      onClick={() => setShowTrialLimitModal(false)}
                    >
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  <div className="rd-trial-modal-body">
                    <p className="rd-trial-modal-message">{trialLimitMessage}</p>

                    <div className="rd-trial-limit-details">
                      <div className="rd-trial-limit-card">
                        <div className="rd-trial-limit-icon">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                        </div>
                        <div className="rd-trial-limit-content">
                          <span className="rd-trial-limit-count">1/1</span>
                          <span className="rd-trial-limit-text">Job Posts Created</span>
                        </div>
                      </div>

                      <div className="rd-trial-features">
                        <h4 className="rd-trial-features-title">With Premium Plan:</h4>
                        <ul className="rd-trial-features-list">
                          <li className="rd-trial-feature-item">
                            <svg className="rd-feature-check" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                            </svg>
                            <span>Unlimited Job Posts</span>
                          </li>
                          <li className="rd-trial-feature-item">
                            <svg className="rd-feature-check" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                            </svg>
                            <span>Unlimited Candidates</span>
                          </li>
                          <li className="rd-trial-feature-item">
                            <svg className="rd-feature-check" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                            </svg>
                            <span>Advanced AI Screening</span>
                          </li>
                          <li className="rd-trial-feature-item">
                            <svg className="rd-feature-check" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                            </svg>
                            <span>Priority Support</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="rd-trial-modal-footer">
                    <button
                      className="rd-trial-modal-btn rd-trial-modal-cancel"
                      onClick={() => setShowTrialLimitModal(false)}
                    >
                      Maybe Later
                    </button>
                    <button
                      className="rd-trial-modal-btn rd-trial-modal-upgrade"
                      onClick={() => {
                        setShowTrialLimitModal(false);
                        navigate('/pricing', {
                          state: {
                            upgradeRequired: true,
                            userEmail: user?.email,
                            fromTrial: true
                          }
                        });
                      }}
                    >
                      <svg className="rd-upgrade-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                      </svg>
                      Upgrade to Premium
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Add this at the end of the Jobs section, before the closing div */}
            {/* Skills Modal */}
            {skillsModalOpen && (
              <div className="rde-skills-modal-overlay">
                <div className="rde-skills-modal">
                  <div className="rde-modal-header">
                    <div className="rde-modal-title">
                      <svg className="rde-modal-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                      </svg>
                      <div className="rde-title-content">
                        <h3 className="rde-modal-main-title">Skills</h3>
                        <p className="rde-modal-subtitle">{selectedCandidateName}'s Technical Skills</p>
                      </div>
                    </div>
                    <button
                      className="rde-modal-close-btn"
                      onClick={() => setSkillsModalOpen(false)}
                    >
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  <div className="rde-modal-body">
                    {selectedSkills.length === 0 ? (
                      <div className="rde-no-skills">
                        <svg className="rde-no-skills-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <h4 className="rde-no-skills-title">No Skills Added</h4>
                        <p className="rde-no-skills-description">This candidate hasn't added any skills yet.</p>
                      </div>
                    ) : (
                      <>
                        <div className="rde-skills-summary">
                          <div className="rde-skills-count">
                            <span className="rde-count-number">{selectedSkills.length}</span>
                            <span className="rde-count-label">Total Skills</span>
                          </div>
                          <div className="rde-skills-categories">
                            <span className="rde-category-badge rde-category-technical">Technical</span>
                            <span className="rde-category-badge rde-category-soft">Soft Skills</span>
                          </div>
                        </div>

                        <div className="rde-skills-grid">
                          {selectedSkills.map((skill, index) => (
                            <div key={index} className="rde-skill-card">
                              <div className="rde-skill-header">
                                <div className="rde-skill-index">#{index + 1}</div>
                                <div className="rde-skill-proficiency">
                                  <div className="rde-proficiency-bar">
                                    <div
                                      className="rde-progress-fill"
                                      style={{
                                        width: `${Math.min(100, Math.max(30, (index % 5 + 1) * 20))}%`
                                      }}
                                    ></div>
                                  </div>
                                  <span className="rde-proficiency-level">
                                    {['Beginner', 'Intermediate', 'Advanced', 'Expert'][index % 4]}
                                  </span>
                                </div>
                              </div>
                              <div className="rde-skill-content">
                                <h4 className="rde-skill-name">{skill}</h4>
                                <p className="rde-skill-description">
                                  {getSkillDescription(skill)}
                                </p>
                              </div>
                              <div className="rde-skill-footer">
                                <button
                                  className="rde-skill-action-btn"
                                  onClick={() => handleSkillAction(skill)}
                                >
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                                  </svg>
                                  View Details
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>

                  <div className="rde-modal-footer">
                    <button
                      className="rde-modal-cancel-btn"
                      onClick={() => setSkillsModalOpen(false)}
                    >
                      Close
                    </button>
                    <div className="rde-modal-actions">
                      <button
                        className="rde-modal-export-btn"
                        onClick={() => exportSkillsToPDF(selectedSkills)}
                      >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        Export Skills
                      </button>
                      <button
                        className="rde-modal-copy-btn"
                        onClick={() => copySkillsToClipboard(selectedSkills)}
                      >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                        Copy All
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}


            {activeTab === 'candidates' && (
              <div className="rcan-candidates-section">
                {/* Header Section */}
                <div className="rcan-candidates-header">
                  <div className="rcan-header-content">
                    <div className="rcan-title-section">
                      <h2 className="rcan-main-title">All Candidates</h2>
                      <p className="rcan-subtitle">
                        Total {allCandidates.length} candidates across all job positions
                      </p>
                    </div>

                    <div className="rcan-header-actions">
                      <button
                        className="rcan-export-all-btn"
                        onClick={exportAllCandidatesToExcel}
                        disabled={allCandidates.length === 0}
                      >
                        <svg className="rcan-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        Export All to Excel
                      </button>

                      <button
                        className="rcan-refresh-btn"
                        onClick={loadAllCandidates}
                      >
                        <svg className="rcan-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                        </svg>
                        Refresh
                      </button>
                    </div>
                  </div>
                </div>

                {/* Statistics Cards */}
                <div className="rcan-stats-grid">
                  <div className="rcan-stat-card">
                    <div className="rcan-stat-content">
                      <span className="rcan-stat-number">{allCandidates.length}</span>
                      <span className="rcan-stat-label">Total Candidates</span>
                    </div>
                    <div className="rcan-stat-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                    </div>
                  </div>
                  <div className="rcan-stat-card">
                    <div className="rcan-stat-content">
                      <span className="rcan-stat-number">
                        {allCandidates.filter(c => c.status === 'Applied').length}
                      </span>
                      <span className="rcan-stat-label">Applied</span>
                    </div>
                    <div className="rcan-stat-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                  </div>
                  <div className="rcan-stat-card">
                    <div className="rcan-stat-content">
                      <span className="rcan-stat-number">
                        {allCandidates.filter(c => c.status === 'Shortlisted').length}
                      </span>
                      <span className="rcan-stat-label">Shortlisted</span>
                    </div>
                    <div className="rcan-stat-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                      </svg>
                    </div>
                  </div>
                  <div className="rcan-stat-card">
                    <div className="rcan-stat-content">
                      <span className="rcan-stat-number">
                        {allCandidates.filter(c => c.status === 'Hired').length}
                      </span>
                      <span className="rcan-stat-label">Hired</span>
                    </div>
                    <div className="rcan-stat-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Search and Filter Bar */}
                {/* Search and Filter Bar - UPDATED VERSION */}
                <div className="rcan-search-filter-bar">
                  <div className="rcan-search-box">
                    <input
                      type="text"
                      placeholder="Search candidates by name, email, or position..."
                      value={candidateSearchTerm}
                      onChange={(e) => setCandidateSearchTerm(e.target.value)}
                      className="rcan-search-input"
                    />
                    {candidateSearchTerm && (
                      <button
                        className="rcan-clear-search"
                        onClick={() => setCandidateSearchTerm('')}
                      >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    )}
                  </div>

                  <div className="rcan-filter-options">
                    {/* Status Filter */}
                    <div className="rcan-filter-group">
                      <label className="rcan-filter-label">Status</label>
                      <select
                        value={candidateStatusFilter}
                        onChange={(e) => setCandidateStatusFilter(e.target.value)}
                        className="rcan-filter-select"
                      >
                        <option value="all">All Status</option>
                        {candidateStatuses.map(status => (
                          <option key={status} value={status}>{status}</option>
                        ))}
                      </select>
                    </div>

                    {/* Position Filter */}
                    <div className="rcan-filter-group">
                      <label className="rcan-filter-label">Position</label>
                      <select
                        value={candidatePositionFilter}
                        onChange={(e) => setCandidatePositionFilter(e.target.value)}
                        className="rcan-filter-select"
                        disabled={candidatePositions.length === 0}
                      >
                        <option value="all">All Positions</option>
                        {candidatePositions.map(position => (
                          <option key={position} value={position}>{position}</option>
                        ))}
                      </select>
                    </div>

                    {/* Department Filter */}
                    <div className="rcan-filter-group">
                      <label className="rcan-filter-label">Department</label>
                      <select
                        value={candidateDepartmentFilter}
                        onChange={(e) => setCandidateDepartmentFilter(e.target.value)}
                        className="rcan-filter-select"
                        disabled={candidateDepartments.length === 0}
                      >
                        <option value="all">All Departments</option>
                        {candidateDepartments.map(dept => (
                          <option key={dept} value={dept}>{dept}</option>
                        ))}
                      </select>
                    </div>

                    {/* Sort By */}
                    <div className="rcan-filter-group">
                      <label className="rcan-filter-label">Sort By</label>
                      <select
                        value={candidateSortBy}
                        onChange={(e) => setCandidateSortBy(e.target.value)}
                        className="rcan-filter-select"
                      >
                        <option value="newest">Newest First</option>
                        <option value="oldest">Oldest First</option>
                        <option value="name">Name A-Z</option>
                        <option value="experience">Experience</option>
                        <option value="position">Position</option>
                        <option value="status">Status</option>
                      </select>
                    </div>

                    {/* Experience Filter */}
                    <div className="rcan-filter-group">
                      <label className="rcan-filter-label">Experience</label>
                      <select
                        value={candidateExperienceFilter}
                        onChange={(e) => setCandidateExperienceFilter(e.target.value)}
                        className="rcan-filter-select"
                      >
                        <option value="all">All Experience</option>
                        <option value="fresher">Fresher</option>
                        <option value="1-3">1-3 Years</option>
                        <option value="4-6">4-6 Years</option>
                        <option value="7+">7+ Years</option>
                      </select>
                    </div>

                    {/* Clear Filters Button */}
                    {(candidateSearchTerm || candidateStatusFilter !== 'all' ||
                      candidatePositionFilter !== 'all' || candidateDepartmentFilter !== 'all' ||
                      candidateExperienceFilter !== 'all' || candidateSortBy !== 'newest') && (
                        <button
                          className="rcan-clear-filters-btn"
                          onClick={clearCandidateFilters}
                        >
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                          Clear All
                        </button>
                      )}
                  </div>
                </div>

                {/* Candidates Table */}
                <div className="rcan-table-container">
                  {candidatesLoading ? (
                    <div className="rcan-loading-state">
                      <div className="rcan-loading-spinner"></div>
                      <p className="rcan-loading-text">Loading candidates...</p>
                    </div>
                  ) : filteredCandidates.length === 0 ? (
                    <div className="rcan-empty-state">
                      <div className="rcan-empty-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                      </div>
                      <h3 className="rcan-empty-title">No Candidates Found</h3>
                      <p className="rcan-empty-description">
                        There are no candidates in the system yet. Candidates will appear here when they apply to your job posts.
                      </p>
                      <button
                        className="rcan-primary-btn"
                        onClick={() => setActiveTab('jobs')}
                      >
                        <svg className="rcan-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                        </svg>
                        Create Job Posts
                      </button>
                    </div>
                  ) : (
                    <div className="rcan-table-wrapper">
                      <div className="rcan-table-scroll-container">
                        <table className="rcan-candidates-table">
                          <thead className="rcan-table-head">
                            <tr className="rcan-table-header-row">
                              <th className="rcan-table-header rcan-col-name">Candidate</th>
                              <th className="rcan-table-header rcan-col-email">Email</th>
                              <th className="rcan-table-header rcan-col-phone">Phone</th>
                              <th className="rcan-table-header rcan-col-position">Position</th>
                              <th className="rcan-table-header rcan-col-department">Dept</th>
                              <th className="rcan-table-header rcan-col-experience">Experience</th>
                              <th className="rcan-table-header rcan-col-skills">Skills</th>
                              <th className="rcan-table-header rcan-col-status">Status</th>
                              <th className="rcan-table-header rcan-col-location">Location</th>
                              <th className="rcan-table-header rcan-col-date">Applied</th>
                              <th className="rcan-table-header rcan-col-actions">Actions</th>
                            </tr>
                          </thead>
                          <tbody className="rcan-table-body">
                            {paginatedCandidates.map(candidate => (
                              <tr key={candidate._id} className="rcan-table-row">
                                {/* Candidate Name */}
                                <td className="rcan-table-cell rcan-cell-name">
                                  <div className="rcan-candidate-profile">
                                    <div className="rcan-candidate-avatar">
                                      {candidate.name ? candidate.name.charAt(0).toUpperCase() : 'U'}
                                    </div>
                                    <div className="rcan-candidate-details">
                                      <div className="rcan-candidate-name" title={candidate.name || 'No Name'}>
                                        {candidate.name || 'No Name'}
                                      </div>
                                      {candidate.currentCompany && (
                                        <div className="rcan-candidate-company" title={candidate.currentCompany}>
                                          <svg className="rcan-company-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                          </svg>
                                          <span className="rcan-company-text">{candidate.currentCompany}</span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </td>

                                {/* Email */}
                                <td className="rcan-table-cell rcan-cell-email">
                                  <a
                                    href={`mailto:${candidate.email}`}
                                    className="rcan-email-link"
                                    title={candidate.email || 'No Email'}
                                  >
                                    {candidate.email ? candidate.email.split('@')[0] + '@...' : 'No Email'}
                                  </a>
                                </td>

                                {/* Phone */}
                                <td className="rcan-table-cell rcan-cell-phone">
                                  {candidate.phone ? (
                                    <div className="rcan-phone-wrapper">
                                      <a
                                        href={`tel:${candidate.phone}`}
                                        className="rcan-phone-link"
                                        title={candidate.phone}
                                      >
                                        {candidate.phone}
                                      </a>
                                      <button
                                        className="rcan-whatsapp-action"
                                        onClick={() => {
                                          const message = `Hi ${candidate.name}, we'd like to discuss your application`;
                                          window.open(`https://wa.me/${candidate.phone.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`, '_blank');
                                        }}
                                        title="Message on WhatsApp"
                                      >
                                        <svg className="rcan-whatsapp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                                        </svg>
                                      </button>
                                    </div>
                                  ) : (
                                    <span className="rcan-no-phone">No Phone</span>
                                  )}
                                </td>

                                {/* Position */}
                                <td className="rcan-table-cell rcan-cell-position">
                                  <span
                                    className="rcan-position-text"
                                    title={candidate.requirementId?.position || 'N/A'}
                                  >
                                    {candidate.requirementId?.position || 'N/A'}
                                  </span>
                                </td>

                                {/* Department */}
                                <td className="rcan-table-cell rcan-cell-department">
                                  <span
                                    className="rcan-department-badge"
                                    title={candidate.requirementId?.department || 'N/A'}
                                  >
                                    {candidate.requirementId?.department ? candidate.requirementId.department.substring(0, 3) : 'N/A'}
                                  </span>
                                </td>

                                {/* Experience */}
                                <td className="rcan-table-cell rcan-cell-experience">
                                  <span
                                    className="rcan-experience-badge"
                                    title={candidate.totalExperience || candidate.experience || 'Not specified'}
                                  >
                                    {candidate.totalExperience || candidate.experience || 'Not specified'}
                                  </span>
                                </td>

                                {/* Skills */}
                                <td className="rcan-table-cell rcan-cell-skills">
                                  <div className="rcan-skills-container">
                                    <div className="rcan-skills-list">
                                      {candidate.skills && candidate.skills.length > 0 ? (
                                        candidate.skills.slice(0, 2).map((skill, index) => (
                                          <span
                                            key={index}
                                            className="rcan-skill-tag"
                                            title={skill}
                                          >
                                            {skill}
                                          </span>
                                        ))
                                      ) : (
                                        <span className="rcan-no-skills">No skills</span>
                                      )}
                                      {candidate.skills && candidate.skills.length > 2 && (
                                        <button
                                          className="rcan-view-more-skills"
                                          onClick={() => {
                                            setSelectedSkills(candidate.skills || []);
                                            setSelectedCandidateName(candidate.name || 'Candidate');
                                            setSkillsModalOpen(true);
                                          }}
                                          title={`View all ${candidate.skills.length} skills`}
                                        >
                                          +{candidate.skills.length - 2} more
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </td>

                                {/* Status */}
                                <td className="rcan-table-cell rcan-cell-status">
                                  <span
                                    className={`rcan-status-badge rcan-status-${(candidate.status || 'Applied').toLowerCase().replace(' ', '-')}`}
                                    title={candidate.status || 'Applied'}
                                  >
                                    {candidate.status || 'Applied'}
                                  </span>
                                </td>

                                {/* Location - Enhanced */}
                                <td className="rcan-table-cell rcan-cell-location">
                                  {candidate.location ? (
                                    <div className="rcan-location-info">
                                      <svg className="rcan-location-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                      </svg>
                                      <div className="rcan-location-details">
                                        <span className="rcan-location-city" title={candidate.location}>
                                          {candidate.location.split(',')[0]}
                                        </span>
                                        {candidate.location.includes(',') && (
                                          <span className="rcan-location-country">
                                            {candidate.location.split(',')[1].trim()}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <span className="rcan-no-location">Not specified</span>
                                  )}
                                </td>

                                {/* Applied Date */}
                                <td className="rcan-table-cell rcan-cell-date">
                                  <div className="rcan-date-info">
                                    <span className="rcan-date-day">
                                      {new Date(candidate.applicationDate || candidate.createdAt).getDate()}
                                    </span>
                                    <div className="rcan-date-details">
                                      <span className="rcan-date-month">
                                        {new Date(candidate.applicationDate || candidate.createdAt).toLocaleDateString('en-US', { month: 'short' })}
                                      </span>
                                      <span className="rcan-date-year">
                                        {new Date(candidate.applicationDate || candidate.createdAt).getFullYear()}
                                      </span>
                                    </div>
                                  </div>
                                </td>

                                {/* Actions */}
                                <td className="rcan-table-cell rcan-cell-actions">
                                  <div className="rcan-actions-container">
                                    {/* Download Resume Button */}
                                    {candidate.resumePath || candidate.resumeUrl ? (
                                      <button
                                        className="rcan-action-button rcan-download-resume"
                                        onClick={() => handleDownloadClick(candidate)}
                                        title="Download Resume"
                                      >
                                        <svg className="rcan-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                      </button>
                                    ) : (
                                      <button
                                        className="rcan-action-button rcan-no-resume"
                                        title="No Resume Available"
                                        disabled
                                      >
                                        <svg className="rcan-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                      </button>
                                    )}

                                    {/* Email Button */}
                                    <button
                                      className="rcan-action-button rcan-send-email"
                                      onClick={() => window.open(`mailto:${candidate.email}`, '_blank')}
                                      title="Email Candidate"
                                      disabled={!candidate.email}
                                    >
                                      <svg className="rcan-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89-5.26a2 2 0 012.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                      </svg>
                                    </button>

                                    {/* View Profile Button */}
                                    <button
                                      className="rcan-action-button rcan-view-profile"
                                      onClick={() => viewCandidateProfile(candidate)}
                                      title="View Full Profile"
                                    >
                                      <svg className="rcan-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                      </svg>
                                    </button>

                                    {/* WhatsApp Button */}
                                    <button
                                      className="rcan-action-button rcan-whatsapp-btn"
                                      onClick={() => {
                                        const message = `Hi ${candidate.name}, we'd like to discuss your application`;
                                        window.open(`https://wa.me/${candidate.phone?.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`, '_blank');
                                      }}
                                      title="WhatsApp"
                                      disabled={!candidate.phone}
                                    >
                                      <svg className="rcan-whatsapp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                                      </svg>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>

                {/* Pagination */}
                {filteredCandidates.length > 10 && (
                  <div className="rcan-pagination">
                    <div className="rcan-pagination-info">
                      Showing {Math.min(currentPage * 10, filteredCandidates.length)} of {filteredCandidates.length}
                    </div>
                    <div className="rcan-pagination-controls">
                      <button
                        className="rcan-pagination-btn rcan-pagination-prev"
                        onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                      <div className="rcan-pagination-numbers">
                        {Array.from({ length: Math.ceil(allCandidates.length / 10) }, (_, i) => i + 1)
                          .slice(0, 5)
                          .map(page => (
                            <button
                              key={page}
                              className={`rcan-pagination-number ${currentPage === page ? 'rcan-page-active' : ''}`}
                              onClick={() => setCurrentPage(page)}
                            >
                              {page}
                            </button>
                          ))}
                      </div>
                      <button
                        className="rcan-pagination-btn rcan-pagination-next"
                        onClick={() => setCurrentPage(prev => Math.min(Math.ceil(allCandidates.length / 10), prev + 1))}
                        disabled={currentPage === Math.ceil(allCandidates.length / 10)}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}

            {activeTab === 'interviews' && <InterviewsList />}
            {activeTab === 'assessment' && <QuestionsManager />}
            {activeTab === 'answers' && <AssessmentAnswers />}


            {activeTab === 'offer-letters' && (
              <div className="ofn-offer-letters-section">
                {/* Header Section */}
                <div className="ofn-header-section">
                  <div className="ofn-header-content">
                    <div className="ofn-title-section">
                      <h2 className="ofn-main-title">Offer Letters Management</h2>
                      <p className="ofn-subtitle">
                        {loadingOfferLetters ? (
                          'Loading offer letters...'
                        ) : (
                          <>
                            Total <strong>{offerLetters.length}</strong> offer letters •{' '}
                            <span className="ofn-status-sent">Sent: {offerLetters.filter(ol => ol.status === 'sent_to_candidate').length}</span> •{' '}
                            <span className="ofn-status-accepted">Accepted: {offerLetters.filter(ol => ol.status === 'accepted').length}</span> •{' '}
                            <span className="ofn-status-pending">Pending: {offerLetters.filter(ol => ol.status === 'sent_to_candidate' && !ol.acceptedDate).length}</span>
                          </>
                        )}
                      </p>
                    </div>

                    <div className="ofn-header-actions">
                      <button
                        className="ofn-export-btn ofn-btn-export-all"
                        onClick={exportAllOfferLettersToExcel}
                        disabled={offerLetters.length === 0 || loadingOfferLetters}
                      >
                        <svg className="ofn-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        Export All
                      </button>

                      <button
                        className="ofn-refresh-btn"
                        onClick={loadOfferLetters}
                        disabled={loadingOfferLetters}
                      >
                        <svg className="ofn-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                        </svg>
                        {loadingOfferLetters ? 'Loading...' : 'Refresh'}
                      </button>
                    </div>
                  </div>
                </div>

                {/* Statistics Cards - Fixed alignment */}
                <div className="ofn-stats-grid">
                  <div className="ofn-stat-card">
                    <div className="ofn-stat-icon-wrapper">
                      <div className="ofn-stat-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                      </div>
                    </div>
                    <div className="ofn-stat-content">
                      <span className="ofn-stat-number">
                        {loadingOfferLetters ? '...' : offerLetters.length}
                      </span>
                      <span className="ofn-stat-label">Total Offers</span>
                    </div>
                  </div>

                  <div className="ofn-stat-card">
                    <div className="ofn-stat-icon-wrapper">
                      <div className="ofn-stat-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89-5.26a2 2 0 012.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </div>
                    </div>
                    <div className="ofn-stat-content">
                      <span className="ofn-stat-number">
                        {loadingOfferLetters ? '...' : offerLetters.filter(ol => ol.status === 'sent_to_candidate').length}
                      </span>
                      <span className="ofn-stat-label">Sent</span>
                    </div>
                  </div>

                  <div className="ofn-stat-card">
                    <div className="ofn-stat-icon-wrapper">
                      <div className="ofn-stat-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                    </div>
                    <div className="ofn-stat-content">
                      <span className="ofn-stat-number">
                        {loadingOfferLetters ? '...' : offerLetters.filter(ol => ol.status === 'accepted').length}
                      </span>
                      <span className="ofn-stat-label">Accepted</span>
                    </div>
                  </div>

                  <div className="ofn-stat-card">
                    <div className="ofn-stat-icon-wrapper">
                      <div className="ofn-stat-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </div>
                    </div>
                    <div className="ofn-stat-content">
                      <span className="ofn-stat-number">
                        {loadingOfferLetters ? '...' : offerLetters.filter(ol => ol.status === 'rejected').length}
                      </span>
                      <span className="ofn-stat-label">Rejected</span>
                    </div>
                  </div>
                </div>

                {/* Filters Section */}
                <div className="ofn-filters-section">
                  <div className="ofn-filters-container">
                    <div className="ofn-search-container">
                      <input
                        type="text"
                        placeholder="Search by candidate name, position, email..."
                        value={offerLetterSearchTerm}
                        onChange={(e) => setOfferLetterSearchTerm(e.target.value)}
                        className="ofn-search-input"
                        disabled={loadingOfferLetters}
                      />
                      {offerLetterSearchTerm && (
                        <button
                          className="ofn-clear-search"
                          onClick={() => setOfferLetterSearchTerm('')}
                        >
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      )}
                    </div>

                    <div className="ofn-filter-select-wrapper">
                      <svg className="ofn-filter-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                      </svg>
                      <select
                        value={offerLetterStatusFilter}
                        onChange={(e) => setOfferLetterStatusFilter(e.target.value)}
                        className="ofn-filter-select"
                        disabled={loadingOfferLetters}
                      >
                        <option value="all">All Status</option>
                        <option value="sent_to_candidate">Sent</option>
                        <option value="accepted">Accepted</option>
                        <option value="rejected">Rejected</option>
                        <option value="expired">Expired</option>
                      </select>
                    </div>

                    <div className="ofn-sort-select-wrapper">
                      <svg className="ofn-sort-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
                      </svg>
                      <select
                        value={offerLetterSortBy}
                        onChange={(e) => setOfferLetterSortBy(e.target.value)}
                        className="ofn-sort-select"
                        disabled={loadingOfferLetters}
                      >
                        <option value="newest">Newest First</option>
                        <option value="oldest">Oldest First</option>
                        <option value="candidate_name">Candidate Name A-Z</option>
                        <option value="position">Position A-Z</option>
                        <option value="salary_high">Salary (High to Low)</option>
                        <option value="salary_low">Salary (Low to High)</option>
                      </select>
                    </div>

                    <button
                      onClick={clearOfferLetterFilters}
                      className="ofn-clear-filters-btn"
                      disabled={loadingOfferLetters || (!offerLetterSearchTerm && offerLetterStatusFilter === 'all' && offerLetterSortBy === 'newest')}
                    >
                      <svg className="ofn-clear-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                      Clear Filters
                    </button>
                  </div>
                </div>

                {/* Offer Letters Table Container - Fixed alignment */}
                <div className="ofn-table-container">
                  {loadingOfferLetters ? (
                    <div className="ofn-loading-state">
                      <div className="ofn-loading-spinner"></div>
                      <p className="ofn-loading-text">Loading offer letters...</p>
                    </div>
                  ) : filteredOfferLetters.length === 0 ? (
                    <div className="ofn-empty-state">
                      <div className="ofn-empty-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                      </div>
                      <h3 className="ofn-empty-title">
                        {offerLetterSearchTerm || offerLetterStatusFilter !== 'all'
                          ? 'No Offer Letters Match Your Filters'
                          : 'No Offer Letters Yet'
                        }
                      </h3>
                      <p className="ofn-empty-description">
                        {offerLetterSearchTerm || offerLetterStatusFilter !== 'all'
                          ? 'Try adjusting your filters to see more results.'
                          : "You haven't sent any offer letters yet. Go to the Interviews tab and send offer letters to hired candidates."
                        }
                      </p>
                      {offerLetterSearchTerm || offerLetterStatusFilter !== 'all' ? (
                        <button
                          className="ofn-primary-btn"
                          onClick={clearOfferLetterFilters}
                        >
                          Clear All Filters
                        </button>
                      ) : (
                        <button
                          className="ofn-primary-btn"
                          onClick={() => setActiveTab('interviews')}
                        >
                          <svg className="ofn-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                          </svg>
                          Go to Interviews
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="ofn-table-wrapper">
                      <table className="ofn-offers-table">
                        <thead className="ofn-table-head">
                          <tr className="ofn-header-row">
                            <th className="ofn-table-header ofn-col-candidate">Candidate</th>
                            <th className="ofn-table-header ofn-col-position">Position</th>
                            <th className="ofn-table-header ofn-col-department">Department</th>
                            <th className="ofn-table-header ofn-col-salary">Salary</th>
                            <th className="ofn-table-header ofn-col-joining">Joining Date</th>
                            <th className="ofn-table-header ofn-col-status">Status</th>
                            <th className="ofn-table-header ofn-col-sent">Sent</th>
                          </tr>
                        </thead>
                        <tbody className="ofn-table-body">
                          {currentOfferLetters.map(offer => (
                            <tr key={offer._id} className="ofn-table-row">
                              {/* Candidate - Fixed alignment */}
                              <td className="ofn-table-cell ofn-cell-candidate">
                                <div className="ofn-candidate-profile">
                                  <div className="ofn-candidate-avatar">
                                    {offer.candidateName ? offer.candidateName.charAt(0).toUpperCase() : 'C'}
                                  </div>
                                  <div className="ofn-candidate-details">
                                    <div className="ofn-candidate-name" title={offer.candidateName || 'No Name'}>
                                      {offer.candidateName || 'No Name'}
                                    </div>
                                    <a
                                      href={`mailto:${offer.candidateEmail}`}
                                      className="ofn-candidate-email"
                                      title={offer.candidateEmail || 'No Email'}
                                    >
                                      {offer.candidateEmail || 'No Email'}
                                    </a>
                                  </div>
                                </div>
                              </td>

                              {/* Position - Fixed alignment */}
                              <td className="ofn-table-cell ofn-cell-position">
                                <span
                                  className="ofn-position-text"
                                  title={offer.position || 'N/A'}
                                >
                                  {offer.position || 'N/A'}
                                </span>
                              </td>

                              {/* Department - Fixed alignment */}
                              <td className="ofn-table-cell ofn-cell-department">
                                <span
                                  className="ofn-department-badge"
                                  title={offer.department || 'N/A'}
                                >
                                  {offer.department || 'N/A'}
                                </span>
                              </td>

                              {/* Salary - Fixed alignment */}
                              <td className="ofn-table-cell ofn-cell-salary">
                                {offer.salary ? (
                                  <div className="ofn-salary-info">
                                    <span className="ofn-salary-amount">
                                      {typeof offer.salary === 'number'
                                        ? `₹${offer.salary.toLocaleString('en-IN')}`
                                        : offer.salary
                                      }
                                    </span>
                                    <span className="ofn-salary-period">/{offer.salaryPeriod || 'month'}</span>
                                  </div>
                                ) : (
                                  <span className="ofn-no-salary">Not specified</span>
                                )}
                              </td>

                              {/* Joining Date - Fixed alignment */}
                              <td className="ofn-table-cell ofn-cell-joining">
                                {offer.joiningDate ? (
                                  <div className="ofn-joining-date">
                                    {new Date(offer.joiningDate).toLocaleDateString('en-IN', {
                                      day: '2-digit',
                                      month: 'short',
                                      year: 'numeric'
                                    })}
                                    {offer.status === 'accepted' && (
                                      <div className="ofn-days-to-join">
                                        {getDaysUntilDate(offer.joiningDate)} to join
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <span className="ofn-no-date">Not set</span>
                                )}
                              </td>

                              {/* Status - Fixed alignment */}
                              <td className="ofn-table-cell ofn-cell-status">
                                <div className={`ofn-status-badge ofn-status-${offer.status || 'sent_to_candidate'}`}>
                                  <span className="ofn-status-text">
                                    {offer.status === 'sent_to_candidate' && 'Sent'}
                                    {offer.status === 'accepted' && 'Accepted'}
                                    {offer.status === 'rejected' && 'Rejected'}
                                    {offer.status === 'expired' && 'Expired'}
                                    {!offer.status && 'Draft'}
                                  </span>
                                </div>
                              </td>

                              {/* Sent Date - Fixed alignment */}
                              <td className="ofn-table-cell ofn-cell-sent">
                                {offer.sentDate ? (
                                  <div className="ofn-sent-date">
                                    <div className="ofn-date-main">
                                      {new Date(offer.sentDate).toLocaleDateString('en-IN', {
                                        day: '2-digit',
                                        month: 'short'
                                      })}
                                    </div>
                                    <div className="ofn-date-time">
                                      {new Date(offer.sentDate).toLocaleTimeString('en-IN', {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                      })}
                                    </div>
                                  </div>
                                ) : (
                                  <span className="ofn-not-sent">Not sent</span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                {/* Results Summary */}
                {!loadingOfferLetters && filteredOfferLetters.length > 0 && (
                  <div className="ofn-results-summary">
                    <div className="ofn-summary-content">
                      <svg className="ofn-summary-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                      </svg>
                      <span>
                        Showing <strong>{((offerLetterCurrentPage - 1) * offerLettersPerPage) + 1}</strong> to{' '}
                        <strong>{Math.min(offerLetterCurrentPage * offerLettersPerPage, filteredOfferLetters.length)}</strong> of{' '}
                        <strong>{filteredOfferLetters.length}</strong> offer letters
                        {(offerLetterSearchTerm || offerLetterStatusFilter !== 'all') && ' (filtered)'}
                      </span>
                    </div>
                  </div>
                )}

                {/* Enhanced Pagination */}
                {filteredOfferLetters.length > offerLettersPerPage && (
                  <div className="ofn-pagination-wrapper">
                    <div className="ofn-pagination-info">
                      <div className="ofn-page-size-selector">
                        <label className="ofn-page-size-label">Show:</label>
                        <select
                          value={offerLettersPerPage}
                          onChange={(e) => {
                            setOfferLettersPerPage(Number(e.target.value));
                            setOfferLetterCurrentPage(1);
                          }}
                          className="ofn-page-size-select"
                        >
                          <option value={5}>5 per page</option>
                          <option value={10}>10 per page</option>
                          <option value={20}>20 per page</option>
                          <option value={50}>50 per page</option>
                        </select>
                      </div>
                    </div>

                    <div className="ofn-pagination-controls">
                      <button
                        onClick={() => setOfferLetterCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={offerLetterCurrentPage === 1}
                        className="ofn-page-btn ofn-page-prev"
                      >
                        <svg className="ofn-page-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                        </svg>
                        <span className="ofn-page-btn-text">Previous</span>
                      </button>

                      <div className="ofn-page-numbers">
                        {(() => {
                          const totalPages = Math.ceil(filteredOfferLetters.length / offerLettersPerPage);
                          const pages = [];

                          // Always show first page
                          pages.push(1);

                          // Show pages around current page
                          for (let i = Math.max(2, offerLetterCurrentPage - 1); i <= Math.min(totalPages - 1, offerLetterCurrentPage + 1); i++) {
                            if (!pages.includes(i)) pages.push(i);
                          }

                          // Always show last page
                          if (totalPages > 1 && !pages.includes(totalPages)) pages.push(totalPages);

                          // Add ellipsis where needed
                          const formattedPages = [];
                          for (let i = 0; i < pages.length; i++) {
                            if (i > 0 && pages[i] - pages[i - 1] > 1) {
                              formattedPages.push(
                                <span key={`ellipsis-${pages[i]}`} className="ofn-page-ellipsis">...</span>
                              );
                            }
                            formattedPages.push(
                              <button
                                key={pages[i]}
                                onClick={() => setOfferLetterCurrentPage(pages[i])}
                                className={`ofn-page-number ${offerLetterCurrentPage === pages[i] ? 'ofn-page-active' : ''}`}
                              >
                                {pages[i]}
                              </button>
                            );
                          }

                          return formattedPages;
                        })()}
                      </div>

                      <button
                        onClick={() => setOfferLetterCurrentPage(prev => Math.min(prev + 1, Math.ceil(filteredOfferLetters.length / offerLettersPerPage)))}
                        disabled={offerLetterCurrentPage === Math.ceil(filteredOfferLetters.length / offerLettersPerPage)}
                        className="ofn-page-btn ofn-page-next"
                      >
                        <span className="ofn-page-btn-text">Next</span>
                        <svg className="ofn-page-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
                        {activeTab === 'feedback' && <FeedBack />}
                        {/* Verification Dashboard Tab */}
{activeTab === 'verification' && <AdminVerificationDashboard />}

{activeTab === 'ai-interviews' && <AIInterviewDashboard />}

          </div>
        </div>
      </div>


      {/* Jobs Tab Content */}
      {/* Jobs Tab Content */}




      {user?.subscription?.activePlanType === 'trial' && !user?.subscription?.plan === 'paid' && (
        <div className="rd-trial-notification-bar">
          <div className="rd-trial-notification-content">
            <svg className="rd-trial-notification-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
            <span className="rd-trial-notification-text">
              You are on <strong>Free Trial</strong> • {requirements.length}/1 Jobs Created
              {requirements.length >= 1 && (
                <span className="rd-trial-limit-reached"> • Limit Reached!</span>
              )}
            </span>
            <button
              className="rd-trial-notification-upgrade"
              onClick={() => navigate('/pricing')}
            >
              Upgrade to Premium
            </button>
          </div>
        </div>
      )}


      {/* Candidates Tab Content - ADD THIS SECTION */}


      {/* Applications Modal */}
      {showApplications && selectedRequirement && (
        <div className="rd-applications-modal">
          <div className="rd-modal-content rd-table-modal">
            {/* Modal Header */}
            <div className="rd-modal-header">
              <h2 className="rd-modal-title">
                Applications for {selectedRequirement.position}
                <span className="rd-applications-count">({applications.length} applications)</span>
              </h2>
              <div className="rd-modal-actions">
                <button
                  className="rd-export-button"
                  onClick={() => exportToExcel(filteredApplications)}
                  disabled={filteredApplications.length === 0}
                >
                  <svg className="rd-export-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Export to Excel
                </button>
                <button className="rd-close-button" onClick={handleCloseApplications}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Applications Statistics */}
            <div className="rd-applications-stats">
              <div
                className={`rd-app-stat-card ${statusFilter === 'all' ? 'rd-app-stat-active' : ''}`}
                onClick={() => handleStatCardClick('all')}
              >
                <span className="rd-app-stat-number">{applications.length}</span>
                <span className="rd-app-stat-label">Total</span>
              </div>
              <div
                className={`rd-app-stat-card ${statusFilter === 'Applied' ? 'rd-app-stat-active' : ''}`}
                onClick={() => handleStatCardClick('Applied')}
              >
                <span className="rd-app-stat-number">
                  {applications.filter(app => app.status === 'Applied').length}
                </span>
                <span className="rd-app-stat-label">Applied</span>
              </div>
              <div
                className={`rd-app-stat-card ${statusFilter === 'Under Review' ? 'rd-app-stat-active' : ''}`}
                onClick={() => handleStatCardClick('Under Review')}
              >
                <span className="rd-app-stat-number">
                  {applications.filter(app => app.status === 'Under Review').length}
                </span>
                <span className="rd-app-stat-label">Review</span>
              </div>
              <div
                className={`rd-app-stat-card ${statusFilter === 'Shortlisted' ? 'rd-app-stat-active' : ''}`}
                onClick={() => handleStatCardClick('Shortlisted')}
              >
                <span className="rd-app-stat-number">
                  {applications.filter(app => app.status === 'Shortlisted').length}
                </span>
                <span className="rd-app-stat-label">Shortlisted</span>
              </div>
              <div
                className={`rd-app-stat-card ${statusFilter === 'Rejected' ? 'rd-app-stat-active' : ''}`}
                onClick={() => handleStatCardClick('Rejected')}
              >
                <span className="rd-app-stat-number">
                  {applications.filter(app => app.status === 'Rejected').length}
                </span>
                <span className="rd-app-stat-label">Rejected</span>
              </div>
              <div
                className={`rd-app-stat-card ${statusFilter === 'Hired' ? 'rd-app-stat-active' : ''}`}
                onClick={() => handleStatCardClick('Hired')}
              >
                <span className="rd-app-stat-number">
                  {applications.filter(app => app.status === 'Hired').length}
                </span>
                <span className="rd-app-stat-label">Hired</span>
              </div>
            </div>

            {/* Filter and Search Section */}
            <div className="rd-applications-filters">
              <div className="rd-filter-group">
                <div className="rd-search-box">
                  <input
                    type="text"
                    placeholder="Search by name, email, phone, skills..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="rd-search-input"
                  />
                  <svg className="rd-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>

                <select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  className="rd-status-filter"
                >
                  <option value="all">All Status</option>
                  <option value="Applied">Applied</option>
                  <option value="Under Review">Under Review</option>
                  <option value="Shortlisted">Shortlisted</option>
                  <option value="Rejected">Rejected</option>
                  <option value="Hired">Hired</option>
                </select>

                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="rd-sort-select"
                >
                  <option value="newest">Newest First</option>
                  <option value="oldest">Oldest First</option>
                  <option value="name">Name A-Z</option>
                  <option value="status">By Status</option>
                </select>

                <button
                  onClick={() => {
                    setSearchTerm('');
                    setStatusFilter('all');
                    setSortBy('newest');
                  }}
                  className="rd-clear-filters"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                  Clear Filters
                </button>
              </div>

              <div className="rd-results-info">
                Showing {currentApplications.length} of {filteredApplications.length} applications
                {filteredApplications.length !== applications.length && ` (filtered from ${applications.length} total)`}
                {statusFilter !== 'all' && ` - ${statusFilter} candidates`}
              </div>
            </div>

            {/* Applications Table */}
            <div className="rd-applications-table-container">
              {currentApplications.length === 0 ? (
                <div className="rd-empty-applications">
                  <svg className="rd-empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <h3 className="rd-empty-title">No Applications Found</h3>
                  <p className="rd-empty-description">
                    {statusFilter !== 'all'
                      ? `No ${statusFilter.toLowerCase()} applications found. Try adjusting your filters.`
                      : 'Try adjusting your filters or search terms'
                    }
                  </p>
                </div>
              ) : (
                <div className="rd-table-wrapper">
                  <table className="rd-applications-table">
                    <thead className="rd-table-header">
                      <tr>
                        <th className="rd-table-col-checkbox">
                          <input type="checkbox" className="rd-select-all" />
                        </th>
                        <th className="rd-table-col-name">Candidate Name</th>
                        <th className="rd-table-col-email">Email</th>
                        <th className="rd-table-col-phone">Phone</th>
                        <th className="rd-table-col-experience">Experience</th>
                        <th className="rd-table-col-skills">Skills</th>
                        <th className="rd-table-col-status">Status</th>
                        <th className="rd-table-col-date">Applied Date</th>
                        <th className="rd-table-col-actions">Actions</th>
                      </tr>
                    </thead>
                    <tbody className="rd-table-body">
                      {currentApplications.map(application => (
                        <tr key={application._id} className="rd-table-row">
                          <td className="rd-table-cell rd-table-cell-checkbox">
                            <input type="checkbox" className="rd-row-select" />
                          </td>
                          <td className="rd-table-cell rd-table-cell-name">
                            <div className="rd-candidate-name-cell">
                              <div className="rd-candidate-avatar-small">
                                {application.name ? application.name.charAt(0).toUpperCase() : 'U'}
                              </div>
                              <div className="rd-candidate-info">
                                <div className="rd-candidate-name">{application.name || 'No Name'}</div>
                                {application.location && (
                                  <div className="rd-candidate-location">
                                    <svg className="rd-location-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    {application.location}
                                  </div>
                                )}
                              </div>
                            </div>
                          </td>
                          <td className="rd-table-cell rd-table-cell-email">
                            <a href={`mailto:${application.email}`} className="rd-email-link">
                              {application.email || 'No Email'}
                            </a>
                          </td>
                          <td className="rd-table-cell rd-table-cell-phone">
                            {application.phone ? (
                              <div className="rd-phone-cell">
                                <a href={`tel:${application.phone}`} className="rd-phone-link">
                                  {application.phone}
                                </a>
                                <button
                                  className="rd-whatsapp-btn"
                                  onClick={() => {
                                    const message = `Hi ${application.name}, we'd like to discuss your application for ${selectedRequirement.position}`;
                                    window.open(`https://wa.me/${application.phone.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`, '_blank');
                                  }}
                                  title="Message on WhatsApp"
                                >
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                                  </svg>
                                </button>
                              </div>
                            ) : (
                              'No Phone'
                            )}
                          </td>
                          <td className="rd-table-cell rd-table-cell-experience">
                            {application.totalExperience || application.experience || 'Not specified'}
                          </td>
                          <td className="rd-table-cell rd-table-cell-skills">
                            <div className="rd-skills-cell">
                              <div className="rd-skills-scroll-container">
                                {application.skills && application.skills.map((skill, index) => (
                                  <span key={index} className="rd-skill-tag-small">{skill}</span>
                                ))}
                                {application.skills && application.skills.length === 0 && (
                                  <span className="rd-no-skills">No skills listed</span>
                                )}
                              </div>
                            </div>
                          </td>
                          <td className="rd-table-cell rd-table-cell-status">
                            <select
                              value={application.status || 'Applied'}
                              onChange={(e) => updateApplicationStatus(application._id, e.target.value, application)}
                              className={`rd-status-select rd-status-${(application.status || 'Applied').toLowerCase().replace(' ', '-')}`}
                            >
                              <option value="Applied">Applied</option>
                              <option value="Under Review">Under Review</option>
                              <option value="Shortlisted">Shortlisted</option>
                              <option value="Rejected">Rejected</option>
                              <option value="Hired">Hired</option>
                            </select>
                          </td>
                          <td className="rd-table-cell rd-table-cell-date">
                            {new Date(application.applicationDate || application.createdAt).toLocaleDateString('en-IN', {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric'
                            })}
                          </td>
                          <td className="rd-table-cell rd-table-cell-actions">
                            <div className="rd-table-actions">
                              <button
                                className="rd-action-btn rd-download-btn"
                                onClick={() => handleDownloadClick(application)}
                                title="Download Resume"
                              >
                                <svg className="rd-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                Resume
                              </button>

                              <button
                                className="rd-action-btn rd-email-btn"
                                onClick={() => window.open(`mailto:${application.email}`, '_blank')}
                                title="Email Candidate"
                              >
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                              </button>

                              <button
                                className="rd-action-btn rd-profile-btn"
                                onClick={() => handleNameClick(application._id)}
                                title="View Full Profile"
                              >
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                              </button>

                              {/* Quick Actions Dropdown */}
                              <div className="rd-actions-dropdown">
                                <button className="rd-more-actions-btn" title="More actions">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                                  </svg>
                                </button>
                                <div className="rd-actions-menu">
                                  <button
                                    className="rd-action-menu-item"
                                    onClick={() => {
                                      setSelectedApplication(application);
                                      setShowInterviewModal(true);
                                    }}
                                  >
                                    <svg className="rd-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                    Schedule Interview
                                  </button>
                                  {/* <button
                                    className="rd-action-menu-item"
                                    onClick={() => {
                                     
                                    }}
                                  >
                                    <svg className="rd-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>
                                    Add Notes
                                  </button> */}
                                  <button
                                    className="rd-action-menu-item rd-action-delete"
                                    onClick={() => {
                                      if (window.confirm('Are you sure you want to delete this application?')) {
                                      }
                                    }}
                                  >
                                    <svg className="rd-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                    </svg>
                                    Delete
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Pagination */}
              {filteredApplications.length > applicationsPerPage && (
                <div className="rd-pagination-container">
                  <div className="rd-pagination-info">
                    Showing {((currentPage - 1) * applicationsPerPage) + 1} to {Math.min(currentPage * applicationsPerPage, filteredApplications.length)} of {filteredApplications.length} applications
                    {statusFilter !== 'all' && ` (${statusFilter} only)`}
                  </div>

                  <div className="rd-pagination-controls">
                    <button
                      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                      disabled={currentPage === 1}
                      className="rd-pagination-btn rd-pagination-prev"
                    >
                      <svg className="rd-pagination-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                      </svg>
                      Previous
                    </button>

                    <div className="rd-pagination-numbers">
                      {Array.from({ length: Math.ceil(filteredApplications.length / applicationsPerPage) }, (_, i) => i + 1)
                        .filter(page => {
                          const totalPages = Math.ceil(filteredApplications.length / applicationsPerPage);
                          return page === 1 || page === totalPages || Math.abs(page - currentPage) <= 1;
                        })
                        .map((page, index, array) => {
                          const prevPage = array[index - 1];
                          if (prevPage && page - prevPage > 1) {
                            return (
                              <React.Fragment key={`ellipsis-${page}`}>
                                <span className="rd-pagination-ellipsis">...</span>
                                <button
                                  onClick={() => setCurrentPage(page)}
                                  className={`rd-pagination-number ${currentPage === page ? 'rd-pagination-active' : ''}`}
                                >
                                  {page}
                                </button>
                              </React.Fragment>
                            );
                          }
                          return (
                            <button
                              key={page}
                              onClick={() => setCurrentPage(page)}
                              className={`rd-pagination-number ${currentPage === page ? 'rd-pagination-active' : ''}`}
                            >
                              {page}
                            </button>
                          );
                        })}
                    </div>

                    <button
                      onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(filteredApplications.length / applicationsPerPage)))}
                      disabled={currentPage === Math.ceil(filteredApplications.length / applicationsPerPage)}
                      className="rd-pagination-btn rd-pagination-next"
                    >
                      Next
                      <svg className="rd-pagination-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                    </button>

                    <div className="rd-page-size-control">
                      <select
                        value={applicationsPerPage}
                        onChange={(e) => {
                          setApplicationsPerPage(Number(e.target.value));
                          setCurrentPage(1);
                        }}
                        className="rd-page-size-select"
                      >
                        <option value={10}>10 per page</option>
                        <option value={25}>25 per page</option>
                        <option value={50}>50 per page</option>
                        <option value={100}>100 per page</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Skills Modal */}
      <SkillsModal
        isOpen={skillsModalOpen}
        onClose={() => setSkillsModalOpen(false)}
        skills={selectedSkills}
        candidateName={selectedCandidateName}
      />

      {/* Interview Schedule Modal */}
      {showInterviewModal && selectedApplication && (
        <InterviewSchedule
          application={selectedApplication}
          onClose={() => {
            setShowInterviewModal(false);
            setSelectedApplication(null);
          }}
          onSchedule={scheduleInterview}
        />
      )}

      {/* Requirement Modal */}
      <Requirement
        isOpen={showRequirementModal}
        onClose={() => {
          setShowRequirementModal(false);
          setEditingRequirement(null);
        }}
        onRequirementCreated={handleRequirementCreated}
        editRequirement={editingRequirement}
      />
    </div>
  );
};

export default HiringDashboard;